import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import RecordAudioHightlightPageNewView from "views/audioHighlight/RecordAudioHightlightPageNewView";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import PlayerService from "services/PlayerService";
import PersistentModels from "services/PersistentModels";
import { isTranscriptionQuotaError, showOutOfTranscriptionMinutesPrompt } from "models/helper/TranscriptionQuotaErrorHelper";
import Utils from "models/helper/Utils";
import VideoUtilsHelper from "helper/VideoUtilsHelper";
import ExpectedError, {
    EXPECTED_ERROR_CATEGORY,
    EXPECTED_ERROR_CLASSIFICATION,
    EXPECTED_ERROR_SOURCE,
} from "models/helper/ExpectedError";
import AudioRecorderHelper from "models/helper/AudioRecorderHelper";
import SongSelectorListController from "controllers/common/SongSelectorListController";
import SingleSongSelectorInputController from "controllers/common/SingleSongSelectorInputController";
import YTSCRemoteSongCollection from "collections/YTSCRemoteSongCollection";
import SongContextController from "controllers/common/SongContextController";
import ListItemCollection from "collections/ListItemCollection";
import LocalStorageHelper from "models/helper/LocalStorageHelper";
import ProgressBarController from "controllers/common/ProgressBarController";
import CustomSelectFieldController from "controllers/common/CustomSelectFieldController";
import Songs from "collections/Songs";
import FeatureRolloutHelper from "models/helper/FeatureRolloutHelper";
import BrowserRecordingDraftStore, {
    STATUSES as RECORDING_DRAFT_STATUSES
} from "models/helper/BrowserRecordingDraftStore";
import ti18n from "i18n!nls/RecordAudioHightlightPagei18n";
import FacebookEventTrackingHelper from "models/helper/FacebookEventTrackingHelper";
import TranscriptionManager from "models/helper/TranscriptionManager";
import SequencerController from "controllers/audioEditor/SequencerController";
import PeakMeterWidgetController from "controllers/common/PeakMeterWidgetController";
import TrebbleAudio from "models/TrebbleAudio";
import TrebbleVideo from "models/TrebbleVideo";
import FileUploadHelper from "models/helper/FileUploadHelper";
import moment from 'moment';
import RSVP from "rsvp";

const REMEMBER_UPLOAD_SETTING_IN_CURRENT_SESSION = true;
const CREATION_MODE = {"FROM_FILE":"fromFile", "FROM_RECORDING":"fromRecording","FROM_TEXT":"fromText", "FROM_VOICE_ACTOR":"fromVoiceActor"};
const IS_CAPSULE_CREATION_VIA_TEXT_AVAILABLE = FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.CREATE_CAPSULE_FROM_TEXT);
const IS_CAPSULE_CREATION_VIA_VOICE_ACTOR = FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.CREATE_CAPSULE_USING_VOICE_ACTOR);
const CONFIGURE_BACKGROUND_MUSIC = FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.CONFIGURE_BACKGROUND_MUSIC);

const ALLOW_USER_TO_RECORD_MULTIPLE_AUDIO_SEGMENT = true;
const ONLY_SHOW_COUNTER_ANIMATION_FOR_FIRST_SEGMENT_RECORDING = false;
const TREBBLE_TEXT_BASED_AUDIO_EDITOR = FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.TREBBLE_TEXT_BASED_AUDIO_EDITOR, true);
const LIMIT_MAX_FILE_RENDERED = false;
const SAVE_AUDIO_WAV_FILE_FROM_AUDIO_EDITOR = false;// FeatureRolloutHelper.getInstance().getFeatureVariable(FeatureRolloutHelper.FEATURES.TREBBLE_TEXT_BASED_AUDIO_EDITOR, FeatureRolloutHelper.FEATURES.TREBBLE_TEXT_BASED_AUDIO_EDITOR.variables.save_wav_file_when_saving_shortcast, true);
const RENDER_VIDEO_ON_BACKEND = FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.RENDER_VIDEO_IN_CLOUD, true);
const RECORD_PAGE_ONBOARDING = FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.RECORD_PAGE_ONBOARDING, true);
const PROJECT_ROUTE_TYPE = {
    DUPLICATE: "duplicate",
    EDIT: "edit",
    SHARED: "shared",
};
const RecordAudioHightlightPageNewController = Chaplin.Controller.extend({

    initialize : function(options) {
        this._defaultSongToPlayAfterCapsule = options.songModel;
        this.capsuleId = options.capsuleId;
        this.context = options.context;
        this._pageId = options.pageId;
        this._receiverUserId = options.receiverUserId;
        this._createFromTranscriptionId =  options.transcriptionId;
        this._createFromProjectId = options.projectIdToDuplicate;
        this._editProjectId = options.projectIdToEdit;
        this._projectRouteType = options.projectRouteType || PROJECT_ROUTE_TYPE.DUPLICATE;
        this._projectAccessLevel = options.projectAccessLevel || null;
        this._workspaceReadOnly = options.workspaceReadOnly === true;
        this._workspaceId = Object.prototype.hasOwnProperty.call(options || {}, "workspaceId")
            ? options.workspaceId
            : undefined;
        this._capsuleIdToEdit = options.capsuleIdToEdit;
        // When set, the page launches a transcription pipeline against an
        // already-uploaded S3 audio (legacy "Continue without editing"
        // capsule) instead of the normal record/upload flow.
        this._capsuleAudioUrlToTranscribe = options.capsuleAudioUrlToTranscribe;
        this._capsuleAudioDurationInSeconds = options.capsuleAudioDurationInSeconds;
        this._editSuggestionRequestId = options.editSuggestionRequestId;
        this._turboEditorCommentId = options.turboEditorCommentId;
        this._turboEditorCommentMessageId = options.turboEditorCommentMessageId;
        this._capsuleInfoToEdit = null;
        this._audioRecordingSupported = options.audioRecordingSupported;
        this._onCapsuleSuccessfullyCreated = options.onCapsuleSuccessfullyCreated;
        this._onCapsuleSuccessfullyUpdated =  options.onCapsuleSuccessfullyUpdated;
        this._onCapsuleCreationPageClosed = options.onCapsuleCreationPageClosed;
        this._addBackgroundMusicToUploadedAudio = options.addBackgroundMusicToUploadedAudio ;
        this._backgroundTrackUrl =  options.backgroundMusicUri;
        this._onAllAudioRecorded = options.onAllAudioRecorded;
        this._recordOnly = options.recordOnly;
        this._returnToDefaultAfterCreation = options.returnToDefaultAfterCreation;
        this._customPageTitle = options.customPageTitle;
        this._fileNameOfCurrentRecording = null;
        this._currentRecordingCounter = null;
        this._interruptedRecordingCounterForStop = null;
        this._creationMode = CREATION_MODE.FROM_RECORDING;
        this._recordingMediaType = "audio";
        this._recordingVisualSource = "camera";
        AudioRecorderHelper.getInstance().setRecordingMediaType(this._recordingMediaType);
        this._saveAsDraft = options.saveAsDraft;
        this._createAShortcast = options.createAShortcast;
        this._startCreationInFileUploadMode = options.startCreationInFileUploadMode;
        this._canSaveOnlyAfterTranscriptionAndEditing = options.canSaveOnlyAfterTranscriptionAndEditing;
        // Folder id to pre-select in the Create Content save step. Non-null when
        // the user opened Create Content from within a library folder.
        this._defaultFolderId = options.defaultFolderId || null;
        this._buildCreationModeListItemModels();
        this.creationModeSelectorController = this._buildCreationModeSelectFieldController();
        this._buildCreationModeFlatListView();

        this._recordingCounterArray  = [];
        this._filenameArray = [];
        this._recordingCounterToFilename = {};
        this._processQueueStarted = false;
        this._uploadedAudioPartInfoForTranscriptionAndEditing = null;
        this._audioUriToTrebbleAudio = null;
        this._lastTranscriptionResults = null;
        this._sequencerController = null;
        this._lastRenderWavFileBlob = null;
        this._durableRecordingDraftsEnabled = !!(BrowserRecordingDraftStore.getInstance().isEnabled && BrowserRecordingDraftStore.getInstance().isEnabled());
        this._recoveryMode = !!options.recoveryMode;
        this._recoverableRecordingDrafts = options.recoverableDrafts ? options.recoverableDrafts.slice() : [];
        this._recoveredTranscriptionPollingTimeoutId = null;
        this._pageTeardownStarted = false;

            //this.songSelectorListController = this._buildSongSelectorListController();
        this.songAttachedToCapsuleSongSelectorInputController = this._buildSongAttachedToCapsuleSongSelectorInputControllerNew();
        this.backgroundSongSelectorInputController = this._buildBackgroundSongSelectorInputController();
        this.peakMeterWidgetController = this._buildPeakMeterWidgetController();
        this.capsuleSchedulingAvailable = LocalStorageHelper.getInstance().isUserHasCapsuleSchedulingFeature();
        this.capsuleInfoProgressBarController = new ProgressBarController();
        this.audioEditorProgressBarController = new ProgressBarController();
        _.extend(this, Backbone.Events);
    },

    _buildCreationModeListItemModels : function(){
        this._creationFromRecordingListItemModel  = Utils.getInstance().getListItemModel(CREATION_MODE.FROM_RECORDING, "<span class='icon pe-7s-micro'></span>" +this._getRecordCreationOptionLabel());
        this._creationFromVoiceActorListItemModel  = Utils.getInstance().getListItemModel(CREATION_MODE.FROM_VOICE_ACTOR,   "<span class='icon pe-7s-headphones'></span>" +window.getI18n(ti18n, "USE_VOICE_ACTOR"));
            this._creationFromFileListItemModel  = Utils.getInstance().getListItemModel(CREATION_MODE.FROM_FILE,   "<span class='icon pe-7s-upload'></span>" + window.getI18n(ti18n, "IMPORT"));//IMPORT_AUDIO
            this._creationFromTextListItemModel  = Utils.getInstance().getListItemModel(CREATION_MODE.FROM_TEXT,   "<span class='icon pe-7s-news-paper'></span>" +window.getI18n(ti18n, "USE_TEXT"));
        },

        _buildSongSelectorInfoBoxParams:function(){
            return Utils.getInstance().buildInfoBoxParams(null, "ion-ios7-musical-notes", null, window.getI18n(ti18n,"NO_YOUTUBE_VIDEOS_FOUND"), window.getI18n(ti18n,"PLEASE_TRY_DIFFERENT_KEYWORD"), null, null);
        },

        _buildSongSelectorInfoBoxParamsForEmptySearchField:function(){
            return Utils.getInstance().buildInfoBoxParams(null, null, null, window.getI18n(ti18n,"CHOOSE_YOUTUBE_VIDEO_TO_USE_AS_BACKGROUND_MUSIC"), null, null, null);
        },

        _buildCreationModeSelectFieldController : function(){
            const controllerParams = {};
            controllerParams.singleSelect =  true;
            controllerParams.propertyFunction = "getLabel";
            controllerParams.propertyIdFunction = "getId";
            controllerParams.showEmtptyInfoBox  = true;
            controllerParams.loadHandler = this.getCreationModesAvailable.bind(this);
            controllerParams.defaultText = window.getI18n(ti18n, "MODE");
            const customSelectFieldController = new CustomSelectFieldController(controllerParams);

            return customSelectFieldController;
        },

        _getRecordCreationOptionLabel :function(){
            let recordingOptionLabel = window.getI18n(ti18n, "RECORD_FROM_THIS_BROWSER");
            if(window.isMobileBrowser){
                recordingOptionLabel = window.getI18n(ti18n, "RECORD_FROM_THIS_PHONE");
            }
            return  window.getI18n(ti18n, "RECORD");
            return recordingOptionLabel;
        },

        _buildCreationModeFlatListView : function(){
            this._creationModeFlatListViewContainer$el =  $("<div  id='creation_mode_flat_list_container' class=' tag_button_list_wrapper size_large no_max_width display_on_desktop'></div>");
            if(this._audioRecordingSupported){
                this._recordModeItemViewButton$el = $("<div class='list_tag_button'>"+"<span class='icon pe-7s-micro'></span>" +this._getRecordCreationOptionLabel()+"</div>")
                this._creationModeFlatListViewContainer$el.append(this._recordModeItemViewButton$el);
                this._recordModeItemViewButton$el.on("click", (function(){
                    //this.showSelectedCreationMode(this._recordModeItemViewButton$el);
                    this._onCreationModeSelectionChanged(this._creationFromRecordingListItemModel);
                    /*if(this.creationModeSelectorController){
                        this.creationModeSelectorController.setSelected(this._creationFromRecordingListItemModel, true, true);
                    }*/
                }).bind(this));
            }
            this._creationFromFileModeItemViewButton$el = $("<div class='list_tag_button'>"+  "<span class='icon pe-7s-upload'></span>" +window.getI18n(ti18n, "IMPORT") +"</div>")
            if(this._startCreationInFileUploadMode){
                this._creationModeFlatListViewContainer$el.prepend(this._creationFromFileModeItemViewButton$el);
            }else{
                this._creationModeFlatListViewContainer$el.append(this._creationFromFileModeItemViewButton$el);
            }
            this._creationFromFileModeItemViewButton$el.on("click", (function(){
                    //this.showSelectedCreationMode(this._creationFromFileModeItemViewButton$el);
                this._onCreationModeSelectionChanged(this._creationFromFileListItemModel);
                    /*if(this.creationModeSelectorController){
                        this.creationModeSelectorController.setSelected(this._creationFromFileListItemModel, true, true);
                    }*/
            }).bind(this));
            if(IS_CAPSULE_CREATION_VIA_VOICE_ACTOR){
                this._creationViaVoiceActorModeItemViewButton$el = $("<div class='list_tag_button'>"+"<span class='icon pe-7s-headphones'></span>" +window.getI18n(ti18n, "USE_VOICE_ACTOR")+"</div>")
                this._creationModeFlatListViewContainer$el.append(this._creationViaVoiceActorModeItemViewButton$el);
                this._creationViaVoiceActorModeItemViewButton$el.on("click", (function(){
                    //this.showSelectedCreationMode(this._creationViaVoiceActorModeItemViewButton$el);
                    this._onCreationModeSelectionChanged(this._creationFromVoiceActorListItemModel);
                    /*if(this.creationModeSelectorController){
                        this.creationModeSelectorController.setSelected(this._creationFromVoiceActorListItemModel, true, true);
                    }*/
                }).bind(this));
            }
            if(IS_CAPSULE_CREATION_VIA_TEXT_AVAILABLE){
                this._creationFromTextModeItemViewButton$el = $("<div class='list_tag_button'>"+ "<span class='icon pe-7s-news-paper'></span>" +window.getI18n(ti18n, "USE_TEXT") +"</div>")
                this._creationModeFlatListViewContainer$el.append(this._creationFromTextModeItemViewButton$el);
                this._creationFromTextModeItemViewButton$el.on("click", (function(){
                    //this.showSelectedCreationMode(this._creationFromTextModeItemViewButton$el);
                    this._onCreationModeSelectionChanged(this._creationFromTextListItemModel);
                    /*if(this.creationModeSelectorController){
                        this.creationModeSelectorController.setSelected(this._creationFromTextListItemModel, true, true);
                    }*/
                }).bind(this));
            }
        },

        _setCreationMode$elAsSelected : function(list_tag_button$el){
            if(this._selectedCreationModeButton$el){
                this._selectedCreationModeButton$el.removeClass("selected");
            }
            this._selectedCreationModeButton$el = list_tag_button$el;
            this._selectedCreationModeButton$el.addClass("selected");

        },

        showSelectedCreationMode: function(creationModeListModel ){
            let creationModeListTagButton$el = null;
            if(creationModeListModel === this._creationFromRecordingListItemModel){
                creationModeListTagButton$el = this._recordModeItemViewButton$el;
            }
            if(creationModeListModel === this._creationFromVoiceActorListItemModel){
                creationModeListTagButton$el = this._creationViaVoiceActorModeItemViewButton$el;
            }
            if(creationModeListModel === this._creationFromFileListItemModel){
                creationModeListTagButton$el = this._creationFromFileModeItemViewButton$el;
            }
            if(creationModeListModel === this._creationFromTextListItemModel){
                creationModeListTagButton$el = this._creationFromTextModeItemViewButton$el;
            }
            if(creationModeListTagButton$el){
                this._setCreationMode$elAsSelected(creationModeListTagButton$el);
            }
        },

        getCreationModesAvailable : function(){
            const listItemCollection = new ListItemCollection();
            if(this._audioRecordingSupported){
                listItemCollection.add(this._creationFromRecordingListItemModel);
            }
            if(IS_CAPSULE_CREATION_VIA_VOICE_ACTOR){
                listItemCollection.add(this._creationFromVoiceActorListItemModel);
            }
            listItemCollection.add(this._creationFromFileListItemModel);
            if(IS_CAPSULE_CREATION_VIA_TEXT_AVAILABLE){
                listItemCollection.add(this._creationFromTextListItemModel);
            }

            return RSVP.Promise.resolve(listItemCollection.models);
        },

        getNarrationParams : function(){
            if(IS_CAPSULE_CREATION_VIA_VOICE_ACTOR){
                const narrationLanguage =  this.view.getNarrationLanguage();
                const voiceProfile =  this.view.getVoiceProfile();
                const voiceTone =  this.view.getVoiceTone();
                const textToNarrate = this.view.getTextToNarrate();
                const narrationInstructions = this.view.getNarrationInstructions();
                return {"narrationLanguage": narrationLanguage, "voiceProfile": voiceProfile,"voiceTone": voiceTone, "textToNarrate": textToNarrate, "narrationInstructions": narrationInstructions};
            }else{
                return null;
            }
        },

        _buildSongAttachedToCapsuleSongSelectorInputController : function(){
            const params = {};
            params.songCollectionToChooseFrom = new Songs( PersistentModels.getInstance().getSongCollection().searchOnTitleAndArtist(""));
            params.selectionSongPopupTitle = window.getI18n(ti18n,"CHOOSE_SONG");
            params.infoBoxMessageInSongSelectionPopupOnEmptySearchField = window.getI18n(ti18n,"SEARCH_SONG_LIBRARY");
            params.helperinfoBoxMessageInSongSelectionPopupOnEmptySearchField = window.getI18n(ti18n,"CHOOSE_A_SONG_TO_PLAY_AFTER_CAPSULE");
            params.songWithAudioPreviewOnly = true;
            return new SingleSongSelectorInputController(params);
        },

        _buildSongAttachedToCapsuleSongSelectorInputControllerNew : function(){
            const params = {};
            const sourceLabelToSongCollectionToChooseFrom = {};
            // Fail-closed: only expose MY_LIBRARY once we have confirmed user
            // info and the account is NOT a temporary visitor. A missing/null
            // userInfo during auth bootstrap must not be treated as "real user
            // with library" just because `.temporary` is undefined on `{}`.
            const currentUserInfo = LocalStorageHelper.getInstance().getUserInfo();
            const isConfirmedNonTemporaryUser = !!currentUserInfo && !currentUserInfo.temporary;
            if(isConfirmedNonTemporaryUser){
                const songCollection = PersistentModels.getInstance().getSongCollection();
                if(songCollection){
                    sourceLabelToSongCollectionToChooseFrom[window.getI18n(ti18n,"MY_LIBRARY")] = new Songs(songCollection.searchOnTitleAndArtist(""));
                }
            }
            const trebbleSearchSongCollection = new YTSCRemoteSongCollection();
            trebbleSearchSongCollection.setSource(YTSCRemoteSongCollection.sourceTypes.TREBBLE);
            sourceLabelToSongCollectionToChooseFrom[window.getI18n(ti18n,"TREBBLE")] = trebbleSearchSongCollection;
            const soundcloudSearchSongCollection = new YTSCRemoteSongCollection();
            soundcloudSearchSongCollection.setSource(YTSCRemoteSongCollection.sourceTypes.SOUNDCLOUD);
            sourceLabelToSongCollectionToChooseFrom[window.getI18n(ti18n,"SOUNDCLOUD")] = soundcloudSearchSongCollection;
            const youtubeSearchSongCollection = new YTSCRemoteSongCollection();
            youtubeSearchSongCollection.setSource(YTSCRemoteSongCollection.sourceTypes.YOUTUBE);
            sourceLabelToSongCollectionToChooseFrom[window.getI18n(ti18n,"YOUTUBE")] = youtubeSearchSongCollection;
            //params.songCollectionToChooseFrom = new Songs( PersistentModels.getInstance().getSongCollection().searchOnTitleAndArtist(""));
            params.labelToSongCollectionToChooseFrom  = sourceLabelToSongCollectionToChooseFrom;
            params.selectionSongPopupTitle = window.getI18n(ti18n,"CHOOSE_SONG");
            const sourceLabelToInfoBoxMessageInSongSelectionPopupOnEmptySearchField = {};
            sourceLabelToInfoBoxMessageInSongSelectionPopupOnEmptySearchField[window.getI18n(ti18n,"MY_LIBRARY")] = window.getI18n(ti18n,"SEARCH_SONG_LIBRARY");
            sourceLabelToInfoBoxMessageInSongSelectionPopupOnEmptySearchField[window.getI18n(ti18n,"TREBBLE")] = window.getI18n(ti18n,"SEARCH_TREBBLE");
            sourceLabelToInfoBoxMessageInSongSelectionPopupOnEmptySearchField[window.getI18n(ti18n,"SOUNDCLOUD")] = window.getI18n(ti18n,"SEARCH_SOUNDCLOUD");
            sourceLabelToInfoBoxMessageInSongSelectionPopupOnEmptySearchField[window.getI18n(ti18n,"YOUTUBE")] = window.getI18n(ti18n,"SEARCH_YOUTUBE");
            params.sourceLabelToInfoBoxMessageInSongSelectionPopupOnEmptySearchField = sourceLabelToInfoBoxMessageInSongSelectionPopupOnEmptySearchField;
            const sourceLabelToInfoBoxHelplerMessageInSongSelectionPopupOnEmptySearchField = {};
            const defaultHelperMessage  = window.getI18n(ti18n,"CHOOSE_SONG_TO_PLAY_AFTER_CAPSULE");
            sourceLabelToInfoBoxHelplerMessageInSongSelectionPopupOnEmptySearchField[window.getI18n(ti18n,"MY_LIBRARY")] = defaultHelperMessage;
            sourceLabelToInfoBoxHelplerMessageInSongSelectionPopupOnEmptySearchField[window.getI18n(ti18n,"TREBBLE")]  =  defaultHelperMessage;
            sourceLabelToInfoBoxHelplerMessageInSongSelectionPopupOnEmptySearchField[window.getI18n(ti18n,"SOUNDCLOUD")] =  defaultHelperMessage;
            sourceLabelToInfoBoxHelplerMessageInSongSelectionPopupOnEmptySearchField[window.getI18n(ti18n,"YOUTUBE")]  =  defaultHelperMessage;
            params.sourceLabelToInfoBoxHelplerMessageInSongSelectionPopupOnEmptySearchField = sourceLabelToInfoBoxHelplerMessageInSongSelectionPopupOnEmptySearchField;
            params.songWithAudioPreviewOnly = true;
            return new SingleSongSelectorInputController(params);
        },

        _buildBackgroundSongSelectorInputController : function(){
            const params = {};
            params.songCollectionToChooseFrom = new YTSCRemoteSongCollection();
            params.songCollectionToChooseFrom.setSource(YTSCRemoteSongCollection.sourceTypes.YOUTUBE);
            params.selectionSongPopupTitle = window.getI18n(ti18n,"CHOOSE_BACKGROUND_MUSIC");
            params.customInfoBoxInfoParams =  this._buildSongSelectorInfoBoxParams();
            params.infoBoxMessageOnFieldEmpty =  this._buildSongSelectorInfoBoxParamsForEmptySearchField();
            params.helperMessageInSongSelectionPopup = window.getI18n(ti18n,"CHOOSE_YOUTUBE_VIDEO_TO_USER_AS_BACKGROUND_MUSIC");
            params.songWithAudioPreviewOnly = true;
            return new SingleSongSelectorInputController(params);
        },

        _buildPeakMeterWidgetController : function(){
            const params = {};
            return new PeakMeterWidgetController(params);
        },

        getModel : function() {
            return null;
        },

        getView : function() {
            return this.view;
        },

        getSongModelToPlayAfterCapsule : function(){
            return this.songAttachedToCapsuleSongSelectorInputController? this.songAttachedToCapsuleSongSelectorInputController.getSelectedSongModel(): null;
        },

        checkRecordingPermissionAndRecord : function(){
            let userConfirmedRecording = false;
            const isScreenVideoRecording = this.isRecordingMediaTypeVideo() && this.getRecordingVisualSource() === "screen";
            const permissionPromise = isScreenVideoRecording ? AudioRecorderHelper.getInstance().getPermissionToRecord("audio") : AudioRecorderHelper.getInstance().getPermissionToRecord(this.getRecordingMediaType());
            return permissionPromise.then((function(){
                if(ALLOW_USER_TO_RECORD_MULTIPLE_AUDIO_SEGMENT){
                    return true;
                }else{
                    return this.view.confirmUserWantToDeleteExistingRecordingIfApplicable();
                }
            }).bind(this)).then((function(contiuneWithRecording){
                userConfirmedRecording = contiuneWithRecording;
                if(userConfirmedRecording && LocalStorageHelper.getInstance().getRecordingCountdownEnabled() && (!ONLY_SHOW_COUNTER_ANIMATION_FOR_FIRST_SEGMENT_RECORDING || (!this._filenameArray || this._filenameArray.length == 0))){
                    return this.view.showCounterAnimation(3);
                }
            }).bind(this)).then((function(){
                if(userConfirmedRecording){
                    return this.view.onUserStartRecording();
                }
            }).bind(this)).catch((function(error){
                console.error(error);
                this._showMediaCaptureErrorMessage(error, {
                    context: "recording"
                });
            }).bind(this))
        },

        setMagicSoundEnhancer : function(on, doNoRecordInHistory){
            if(this._sequencerController){
                this._sequencerController.setMagicSoundEnhancer(on, doNoRecordInHistory);
            }
        },

        setRecordingMediaType: function(recordingMediaType) {
            this._recordingMediaType = recordingMediaType === "video" ? "video" : "audio";
            if(this._recordingMediaType === "video" && !AudioRecorderHelper.getInstance().isRecordingMediaTypeSupported("video")){
                this._recordingMediaType = "audio";
                return false;
            }
            AudioRecorderHelper.getInstance().setRecordingMediaType(this._recordingMediaType);
            if(this.isRecordingMediaTypeVideo()){
                this.refreshVideoPreviewIfApplicable();
            }else{
                this.stopVideoPreviewIfApplicable();
            }
            return true;
        },

        getRecordingVisualSource: function() {
            return this._recordingVisualSource === "screen" ? "screen" : "camera";
        },

        _stopLocalMediaStreamTracks: function(stream) {
            if(!stream || !stream.getTracks){
                return;
            }

            stream.getTracks().forEach(function(track) {
                try{
                    track.stop();
                }catch(error){
                    console.warn("Unable to stop a temporary recording stream track", error);
                }
            });
        },

        _getTrackedRecordingFilenames: function(recordingCounter) {
            const trackedEntry = recordingCounter !== null && recordingCounter !== undefined ? this._recordingCounterToFilename[recordingCounter] : null;
            if(!trackedEntry){
                return [];
            }

            return Array.isArray(trackedEntry) ? trackedEntry.slice() : [trackedEntry];
        },

        _buildRecordingFileName: function(recordingCounter, segmentIndex) {
            const recordingMediaType = this.getRecordingMediaType();
            const recordingFileInfo = AudioRecorderHelper.getInstance().getRecordingFileInfo(recordingMediaType);
            const fileExtension = window.trebble.useNativeRecording ? (window.isIOSMobileDevice ? "wav" : "aac") : recordingFileInfo.fileExtension;
            const normalizedSegmentIndex = segmentIndex && segmentIndex > 0 ? segmentIndex : 0;
            const segmentSuffix = normalizedSegmentIndex > 0 ? "_segment" + normalizedSegmentIndex : "";
            return this.view.getFileRecordingKey()+"_"+recordingCounter + segmentSuffix + "."+ fileExtension;
        },

        _getNextRecordingSegmentFileName: function(recordingCounter) {
            return this._buildRecordingFileName(recordingCounter, this._getTrackedRecordingFilenames(recordingCounter).length);
        },

        _waitForPendingRecordingVisualSourceSwitch: function() {
            return this._activeRecordingVisualSourceSwitchPromise ? this._activeRecordingVisualSourceSwitchPromise.catch(function() {
                return null;
            }) : RSVP.Promise.resolve();
        },

        _switchActiveBrowserRecordingVisualSourceSegment: function(sourceType) {
            const normalizedSourceType = sourceType === "screen" ? "screen" : "camera";
            const previousSourceType = this.getRecordingVisualSource();
            const currentRecordingCounter = this._currentRecordingCounter;
            const currentFileName = this._fileNameOfCurrentRecording;
            const audioRecorderHelper = AudioRecorderHelper.getInstance();

            if(!currentFileName || currentRecordingCounter === null || currentRecordingCounter === undefined){
                return RSVP.Promise.reject(new Error("No active browser video recording segment was found."));
            }

            let nextRecordingStream = null;
            let currentSegmentStopped = false;
            let nextSegmentFileName = null;
            const existingScreenPreviewStream = normalizedSourceType === "screen" && audioRecorderHelper.getCurrentVideoPreviewSourceType && audioRecorderHelper.getCurrentVideoPreviewSourceType() === "screen" ? audioRecorderHelper.getCurrentVideoPreviewStream() : null;

            if(this.view && this.view.showRecordingPreviewLoading){
                this.view.showRecordingPreviewLoading(window.getI18n(ti18n, normalizedSourceType === "screen" ? "STARTING_SCREEN_SHARE_PREVIEW" : "STARTING_CAMERA_PREVIEW"));
            }

            return audioRecorderHelper.getBrowserVideoRecordingStreamForSourceType(normalizedSourceType, existingScreenPreviewStream ? {
                displayStream: existingScreenPreviewStream
            } : null).then((function(stream){
                nextRecordingStream = stream;
                return audioRecorderHelper.stopRecording(currentFileName);
            }).bind(this)).then((function(){
                currentSegmentStopped = true;
                if(this._fileNameOfCurrentRecording === currentFileName){
                    this._fileNameOfCurrentRecording = null;
                }
                nextSegmentFileName = this._getNextRecordingSegmentFileName(currentRecordingCounter);
                this._recordingVisualSource = normalizedSourceType;
                this._trackPendingRecording(nextSegmentFileName, currentRecordingCounter, {
                    append: true
                });
                return this._startRecordingProcess({
                    existingStream: nextRecordingStream,
                    skipTimerRestart: true
                });
            }).bind(this)).then((function(updatedRecorderInstance){
                if(this.view && this.view.setStudioDockVisualSource){
                    this.view.setStudioDockVisualSource(normalizedSourceType, true);
                }
                return updatedRecorderInstance;
            }).bind(this)).catch((function(error){
                console.error("Unable to switch the active recording video source", error);

                if(!currentSegmentStopped){
                    this._stopLocalMediaStreamTracks(nextRecordingStream);
                    if(this.view && this.view.setStudioDockVisualSource){
                        this.view.setStudioDockVisualSource(previousSourceType, true);
                    }
                    this._showMediaCaptureErrorMessage(error, {
                        context: "preview",
                        recordingMediaType: "video"
                    });
                    return null;
                }

                const cleanupPromise = nextSegmentFileName ? this._cleanupFailedRecordingAttempt(nextSegmentFileName, currentRecordingCounter, true) : RSVP.Promise.resolve();
                return cleanupPromise.then((function(){
                    this._stopLocalMediaStreamTracks(nextRecordingStream);
                    this._interruptedRecordingCounterForStop = currentRecordingCounter;
                    this._fileNameOfCurrentRecording = null;
                    this._currentRecordingCounter = null;
                    return this.refreshVideoPreviewIfApplicable(true).catch(function(previewError){
                        console.warn("Unable to restore the preview after the recording source switch failed", previewError);
                        return null;
                    }).then((function(){
                        this._showMediaCaptureErrorMessage(error, {
                            context: "recording",
                            recordingMediaType: "video"
                        });
                        return null;
                    }).bind(this));
                }).bind(this));
            }).bind(this));
        },

        onRecordingVisualSourceChanged: function(sourceType) {
            const normalizedSourceType = sourceType === "screen" ? "screen" : "camera";

            if(AudioRecorderHelper.getInstance().isRecording()){
                if(!this.isRecordingMediaTypeVideo()){
                    if(this.view && this.view.setStudioDockVisualSource){
                        this.view.setStudioDockVisualSource(this.getRecordingVisualSource(), true);
                    }
                    return;
                }

                if(window.device && window.device.platform == "browser" && !(window.trebble.useNativeRecording && "Media" in window)){
                    const pendingSwitchPromise = this._activeRecordingVisualSourceSwitchPromise ? this._activeRecordingVisualSourceSwitchPromise.catch(function() {
                        return null;
                    }) : RSVP.Promise.resolve();
                    const activeSwitchPromise = pendingSwitchPromise.then((function() {
                        return this._switchActiveBrowserRecordingVisualSourceSegment(normalizedSourceType);
                    }).bind(this));
                    const trackedSwitchPromise = activeSwitchPromise.then((function(result) {
                        if(this._activeRecordingVisualSourceSwitchPromise === trackedSwitchPromise){
                            this._activeRecordingVisualSourceSwitchPromise = null;
                        }
                        return result;
                    }).bind(this)).catch((function(error) {
                        if(this._activeRecordingVisualSourceSwitchPromise === trackedSwitchPromise){
                            this._activeRecordingVisualSourceSwitchPromise = null;
                        }
                        throw error;
                    }).bind(this));
                    this._activeRecordingVisualSourceSwitchPromise = trackedSwitchPromise;
                    return trackedSwitchPromise;
                }

                return AudioRecorderHelper.getInstance().switchBrowserRecordingVideoSource(this._fileNameOfCurrentRecording, normalizedSourceType).then((function(updatedRecordingStream){
                    this._recordingVisualSource = normalizedSourceType;
                    if(this.view){
                        if(this.view.setStudioDockVisualSource){
                            this.view.setStudioDockVisualSource(this._recordingVisualSource, true);
                        }
                        if(this.view.setRecordingPreviewStream){
                            this.view.setRecordingPreviewStream("video", updatedRecordingStream, {
                                sourceType: normalizedSourceType
                            });
                        }
                    }
                    return updatedRecordingStream;
                }).bind(this)).catch((function(error){
                    console.error("Unable to switch the active recording video source", error);
                    if(this.view && this.view.setStudioDockVisualSource){
                        this.view.setStudioDockVisualSource(this.getRecordingVisualSource(), true);
                    }
                    this._showMediaCaptureErrorMessage(error, {
                        context: "preview",
                        recordingMediaType: "video"
                    });
                    return null;
                }).bind(this));
            }

            this._recordingVisualSource = normalizedSourceType;

            if(this.view && this.view.setStudioDockVisualSource){
                this.view.setStudioDockVisualSource(this._recordingVisualSource, true);
            }

            if(!this.isInRecordMode || !this.isInRecordMode() || !this.isRecordingMediaTypeVideo() || AudioRecorderHelper.getInstance().isRecording()){
                return;
            }

            if(this._recordingVisualSource === "screen"){
                this.refreshVideoPreviewIfApplicable(true);
            }else{
                this.requestRecordingDevicePermissions("video");
            }
        },

        requestRecordingDevicePermissions: function(recordingMediaType) {
            const mediaType = recordingMediaType === "video" ? "video" : this.getRecordingMediaType();
            if(mediaType === "video" && this.getRecordingVisualSource() === "screen"){
                return this.refreshVideoPreviewIfApplicable(true);
            }

            return AudioRecorderHelper.getInstance().getPermissionToRecord(mediaType).then((function() {
                if(this.view && this.view.refreshInlineRecordingDeviceSelectors){
                    return this.view.refreshInlineRecordingDeviceSelectors();
                }
            }).bind(this)).then((function() {
                if(mediaType === "video"){
                    return this.refreshVideoPreviewIfApplicable(true);
                }
            }).bind(this)).catch((function(error) {
                console.error(error);
                this._showMediaCaptureErrorMessage(error, {
                    context: mediaType === "video" ? "preview" : "recording",
                    recordingMediaType: mediaType
                });

                if(this.view && this.view.refreshInlineRecordingDeviceSelectors){
                    this.view.refreshInlineRecordingDeviceSelectors();
                }
            }).bind(this));
        },

        onRecordingVideoDeviceChanged: function() {
            if(this.isRecordingMediaTypeVideo() && this.getRecordingVisualSource() !== "screen"){
                this.refreshVideoPreviewIfApplicable(true);
            }
        },

        onRecordingVideoResolutionChanged: function() {
            if(this.isRecordingMediaTypeVideo() && this.getRecordingVisualSource() !== "screen"){
                this.refreshVideoPreviewIfApplicable(true);
            }
        },

        getRecordingMediaType: function() {
            return this._recordingMediaType || "audio";
        },

        isRecordingMediaTypeVideo: function() {
            return this.getRecordingMediaType() === "video";
        },

        refreshVideoPreviewIfApplicable: function(forceRefresh) {
            if(!this.view || !this.view.setRecordingPreviewStream){
                return RSVP.Promise.resolve(null);
            }

            const visualSource = this.getRecordingVisualSource();
            if(!this.isInRecordMode || !this.isInRecordMode() || !this.isRecordingMediaTypeVideo() || AudioRecorderHelper.getInstance().isRecording()){
                this.view.clearRecordingPreviewStream();
                if(this.view.setRecordingPreviewState){
                    this.view.setRecordingPreviewState("idle");
                }
                return AudioRecorderHelper.getInstance().stopVideoPreview().then(function(){
                    return null;
                });
            }

            if(this.view.showRecordingPreviewLoading){
                this.view.showRecordingPreviewLoading(window.getI18n(ti18n, visualSource === "screen" ? "STARTING_SCREEN_SHARE_PREVIEW" : "STARTING_CAMERA_PREVIEW"));
            }
            const previewPromise = visualSource === "screen" ? AudioRecorderHelper.getInstance().getScreenPreviewStream(forceRefresh) : AudioRecorderHelper.getInstance().getVideoPreviewStream(forceRefresh);
            return previewPromise.then((function(stream){
                if(stream && this.view){
                    this.view.setRecordingPreviewStream("video", stream, {
                        sourceType: visualSource
                    });
                }
                return stream;
            }).bind(this)).catch((function(error){
                console.error("Unable to refresh video preview", error);
                if(this.view){
                    this.view.clearRecordingPreviewStream();
                    if(this.view.showRecordingPreviewError){
                        if(visualSource === "screen"){
                            this.view.showRecordingPreviewError(window.getI18n(ti18n, "SCREEN_SHARE_PREVIEW_UNAVAILABLE"));
                        }else{
                            const errorInfo = this._getMediaCaptureErrorInfo(error, {
                                context: "preview",
                                recordingMediaType: "video"
                            });
                            this.view.showRecordingPreviewError(errorInfo.message);
                        }
                    }
                }
                return AudioRecorderHelper.getInstance().stopVideoPreview().then(function(){
                    return null;
                });
            }).bind(this));
        },

        stopVideoPreviewIfApplicable: function() {
            if(this.view && this.view.clearRecordingPreviewStream){
                this.view.clearRecordingPreviewStream();
                if(this.view.setRecordingPreviewState){
                    this.view.setRecordingPreviewState("idle");
                }
            }
            return AudioRecorderHelper.getInstance().stopVideoPreview();
        },

        prepareRecordingMediaTypeChange: function(recordingMediaType, onPrepared) {
            const mediaType = recordingMediaType === "video" ? "video" : "audio";
            const notifyPrepared = function(error, result) {
                if(typeof onPrepared === "function") {
                    try {
                        onPrepared(error || null, result);
                    } catch(callbackError) {
                        console.warn("Unable to notify that the recording media type change is ready", callbackError);
                    }
                }
            };

            let preparePromise = RSVP.Promise.resolve();
            if(mediaType === "video"){
                preparePromise = this.getRecordingVisualSource() === "screen" ? this.refreshVideoPreviewIfApplicable(true) : this.requestRecordingDevicePermissions(mediaType);
            }
            return preparePromise.then(function(result) {
                notifyPrepared(null, result);
                return result;
            }).catch(function(error) {
                notifyPrepared(error);
                throw error;
            });
        },

        startPeakMeter : function(trebbleRecorderInstance){
            const recorderStream = trebbleRecorderInstance && trebbleRecorderInstance.getStream ? trebbleRecorderInstance.getStream() : null;
            const hasAudioTrack = recorderStream && recorderStream.getAudioTracks && recorderStream.getAudioTracks().length > 0;
            if(!recorderStream || !hasAudioTrack || window.waitForCordovaToLoad || !this.peakMeterWidgetController){
                return RSVP.Promise.resolve(null);
            }

            const audioContext = AudioRecorderHelper.getInstance().getAudioContext();
            return AudioRecorderHelper.getInstance().resumeCurrentAudioContext().catch(function(error) {
                console.warn("Unable to resume the audio context before starting the peak meter", error);
                return null;
            }).then((function() {
                this.peakMeterWidgetController.startMeter(recorderStream, audioContext);
                return audioContext;
            }).bind(this));
        },

        _getMediaCaptureErrorInfo: function(error, options) {
            const errorOptions = options || {};
            const mediaType = errorOptions.recordingMediaType === "video" ? "video" : (errorOptions.recordingMediaType === "audio" ? "audio" : this.getRecordingMediaType());
            const context = errorOptions.context === "preview" ? "preview" : "recording";
            return AudioRecorderHelper.getInstance().getMediaCaptureErrorInfo(error, mediaType, {
                context: context
            });
        },

        _alertMediaCaptureErrorInfo: function(errorInfo) {
            if (errorInfo && errorInfo.isNoAudioSignalError) {
                Utils.getInstance().showUserConfirmationDialog(errorInfo.title, errorInfo.title, errorInfo.message, {
                    buttonLabels: [window.getI18n(ti18n, "DISMISS"), window.getI18n(ti18n, "CHECK_MICROPHONE_SETTINGS")]
                }).then((function(userWantsToCheckMicrophoneSettings) {
                    if (userWantsToCheckMicrophoneSettings) {
                        this.showRecordingSettings();
                    }
                }).bind(this));
                return;
            }
            window.alertUserErrorMessage(errorInfo.title, errorInfo.message);
        },

        _showMediaCaptureErrorMessage: function(error, options) {
            const errorInfo = this._getMediaCaptureErrorInfo(error, options);
            this._alertMediaCaptureErrorInfo(errorInfo);
            return errorInfo;
        },

        _getCurrentRecordingDraftOriginRoute: function() {
            return window.location && window.location.hash ? window.location.hash : this._pageId;
        },

        _getCurrentRecordingDraftOriginFlow: function() {
            if (this._recordOnly) {
                return "record_only";
            }

            return this._createAShortcast ? "shortcast_creation" : "capsule_creation";
        },

        _isRecordingDraftCompatibleWithCurrentRecoveryPage: function(draftManifest) {
            const draftOriginFlow = draftManifest && draftManifest.originFlow ? draftManifest.originFlow : null;
            const currentOriginFlow = this._getCurrentRecordingDraftOriginFlow ? this._getCurrentRecordingDraftOriginFlow() : null;
            if (!draftOriginFlow || !currentOriginFlow) {
                return true;
            }

            return draftOriginFlow === currentOriginFlow;
        },

        _completeRecoveredRecordOnlyDrafts: function(recordedFiles) {
            const filesToDownload = Array.isArray(recordedFiles) ? recordedFiles : [];
            filesToDownload.forEach(function(recordedFile, index) {
                if (!recordedFile) {
                    return;
                }

                Utils.getInstance().downloadFile(
                    recordedFile,
                    recordedFile.name || ("recovered-browser-recording-" + (index + 1))
                );
            });

            return RSVP.Promise.resolve(filesToDownload);
        },

        _rerouteRecoveryDraftToCompatiblePage: function(draftManifest) {
            const router = PersistentModels.getInstance().getRouter ? PersistentModels.getInstance().getRouter() : null;
            if (!router || !draftManifest) {
                return RSVP.Promise.resolve(null);
            }

            const recoveryOptions = {
                recoveryMode: true,
                recoverableDrafts: [draftManifest]
            };
            const onRecoveryPageOpened = (function(result) {
                if (this.view && this.view.removePage) {
                    this.view.removePage();
                }
                return result;
            }).bind(this);

            if (draftManifest.originFlow === "record_only") {
                if (!router.showAudioRecorderPage) {
                    return RSVP.Promise.resolve(null);
                }

                const onAllAudioRecorded = this._onAllAudioRecorded || this._completeRecoveredRecordOnlyDrafts.bind(this);
                return RSVP.Promise.resolve(router.showAudioRecorderPage(
                    onAllAudioRecorded,
                    null,
                    null,
                    true,
                    recoveryOptions
                )).then(onRecoveryPageOpened);
            }

            if (router.showAddAudioHightlightPageNew) {
                return RSVP.Promise.resolve(router.showAddAudioHightlightPageNew(
                    null,
                    null,
                    null,
                    null,
                    true,
                    true,
                    null,
                    null,
                    null,
                    true,
                    null,
                    true,
                    draftManifest.originFlow === "shortcast_creation",
                    null,
                    null,
                    null,
                    recoveryOptions
                )).then(onRecoveryPageOpened);
            }

            return RSVP.Promise.resolve(null);
        },

        _findDurableDraftManifestForFileName: function(fileName) {
            if (!fileName) {
                return null;
            }

            const helperDraftManifest = AudioRecorderHelper.getInstance().getDurableDraftManifestForRecording(fileName);
            if (helperDraftManifest) {
                return helperDraftManifest;
            }

            return this._recoverableRecordingDrafts.find(function(draftManifest) {
                return draftManifest && (draftManifest.fileName === fileName || draftManifest.recordingId === fileName);
            }) || null;
        },

        _updateDurableDraftManifestForFileName: function(fileName, updateFunction) {
            const canAccessDurableDrafts = this._durableRecordingDraftsEnabled || (
                AudioRecorderHelper.getInstance().canAccessDurableBrowserRecordingDrafts &&
                AudioRecorderHelper.getInstance().canAccessDurableBrowserRecordingDrafts()
            );
            if (!canAccessDurableDrafts || !fileName || !updateFunction) {
                return RSVP.Promise.resolve(null);
            }

            const currentDraftManifest = this._findDurableDraftManifestForFileName(fileName);
            if (!this._durableRecordingDraftsEnabled && !currentDraftManifest) {
                return RSVP.Promise.resolve(null);
            }
            const recordingId = currentDraftManifest && currentDraftManifest.recordingId ? currentDraftManifest.recordingId : fileName;

            return RSVP.Promise.resolve(updateFunction(recordingId, currentDraftManifest)).then((function(updatedDraftManifest) {
                if (updatedDraftManifest) {
                    AudioRecorderHelper.getInstance().registerDurableDraftManifest(fileName, updatedDraftManifest);
                }
                return updatedDraftManifest;
            }).bind(this));
        },

        _refreshRecoverableRecordingDrafts: function(includeDismissed) {
            const canAccessDurableDrafts = this._durableRecordingDraftsEnabled || (
                AudioRecorderHelper.getInstance().canAccessDurableBrowserRecordingDrafts &&
                AudioRecorderHelper.getInstance().canAccessDurableBrowserRecordingDrafts()
            );
            if (!canAccessDurableDrafts) {
                this._recoverableRecordingDrafts = [];
                if (this.view && this.view.setRecordingDraftRecoveryItems) {
                    this.view.setRecordingDraftRecoveryItems([]);
                }
                return RSVP.Promise.resolve([]);
            }

            return AudioRecorderHelper.getInstance().getRecoverableRecordingDraftsForCurrentUser(includeDismissed !== false).then((function(recoverableDrafts) {
                const filteredDrafts = (recoverableDrafts || []).filter((function(draftManifest) {
                    const recoveredFileName = draftManifest && draftManifest.fileName ? draftManifest.fileName : draftManifest && draftManifest.recordingId;
                    return recoveredFileName ? this._filenameArray.indexOf(recoveredFileName) < 0 : true;
                }).bind(this));
                this._recoverableRecordingDrafts = filteredDrafts;
                if (this.view && this.view.setRecordingDraftRecoveryItems) {
                    this.view.setRecordingDraftRecoveryItems(filteredDrafts);
                }
                if (this.view && this.view.setRecoveryMode) {
                    this.view.setRecoveryMode(this._recoveryMode || filteredDrafts.length > 0);
                }
                return filteredDrafts;
            }).bind(this));
        },

        _clearRecoveredTranscriptionPolling: function() {
            if (this._recoveredTranscriptionPollingTimeoutId) {
                clearTimeout(this._recoveredTranscriptionPollingTimeoutId);
                this._recoveredTranscriptionPollingTimeoutId = null;
            }
            if (this._resolveRecoveredTranscriptionPolling) {
                const resolveRecoveredTranscriptionPolling = this._resolveRecoveredTranscriptionPolling;
                this._resolveRecoveredTranscriptionPolling = null;
                resolveRecoveredTranscriptionPolling(false);
            }
        },

        _getRecoveredUploadedMediaPartsForPendingMedia: function() {
            const canAccessDurableDrafts = this._durableRecordingDraftsEnabled || (
                typeof AudioRecorderHelper !== "undefined" &&
                AudioRecorderHelper.getInstance().canAccessDurableBrowserRecordingDrafts &&
                AudioRecorderHelper.getInstance().canAccessDurableBrowserRecordingDrafts()
            );
            if (!canAccessDurableDrafts || !this._filenameArray || this._filenameArray.length === 0) {
                return null;
            }

            const uploadedMediaParts = [];
            let hasMissingRecoveryCheckpoint = false;
            for (let index = 0; index < this._filenameArray.length; index++) {
                const fileName = this._filenameArray[index];
                const draftManifest = this._findDurableDraftManifestForFileName(fileName);
                if (!draftManifest || !draftManifest.uploadedMediaParts || draftManifest.uploadedMediaParts.length === 0) {
                    hasMissingRecoveryCheckpoint = true;
                    continue;
                }

                if (!draftManifest.remoteUploadUrl && draftManifest.status !== RECORDING_DRAFT_STATUSES.UPLOADED_UNREGISTERED && draftManifest.status !== RECORDING_DRAFT_STATUSES.REGISTERED_UNTRANSCRIBED && draftManifest.status !== RECORDING_DRAFT_STATUSES.TRANSCRIBING) {
                    hasMissingRecoveryCheckpoint = true;
                    continue;
                }

                draftManifest.uploadedMediaParts.forEach(function(uploadedMediaPart) {
                    uploadedMediaParts.push(Object.assign({}, uploadedMediaPart, {
                        _filename: fileName,
                        recordingId: draftManifest.recordingId
                    }));
                });
            }

            return (!hasMissingRecoveryCheckpoint && uploadedMediaParts.length > 0) ? uploadedMediaParts : null;
        },

        _getPendingRecordingFileNamesForDurableDrafts: function() {
            const canAccessDurableDrafts = this._durableRecordingDraftsEnabled || (
                typeof AudioRecorderHelper !== "undefined" &&
                AudioRecorderHelper.getInstance().canAccessDurableBrowserRecordingDrafts &&
                AudioRecorderHelper.getInstance().canAccessDurableBrowserRecordingDrafts()
            );
            if (!canAccessDurableDrafts || !this._filenameArray || this._filenameArray.length === 0) {
                return [];
            }

            return this._filenameArray.filter(function(fileName, index, arrayOfFileNames) {
                return !!fileName && arrayOfFileNames.indexOf(fileName) === index;
            });
        },

        _getDurableDraftFileNameFromMediaPart: function(mediaPartInfo, fallbackIndex) {
            if (mediaPartInfo) {
                if (mediaPartInfo._filename) {
                    return mediaPartInfo._filename;
                }

                if (mediaPartInfo.originalFilename) {
                    return mediaPartInfo.originalFilename;
                }

                if (mediaPartInfo.fileName) {
                    return mediaPartInfo.fileName;
                }
            }

            if (fallbackIndex !== undefined && fallbackIndex !== null && this._filenameArray && this._filenameArray.length > fallbackIndex) {
                return this._filenameArray[fallbackIndex];
            }

            return null;
        },

        _groupUploadedMediaPartsByFileName: function(uploadedMediaParts) {
            const uploadedMediaPartsByFileName = {};

            (uploadedMediaParts || []).forEach((function(mediaPartInfo, index) {
                const fileName = this._getDurableDraftFileNameFromMediaPart(mediaPartInfo, index);
                if (!fileName) {
                    return;
                }

                if (!uploadedMediaPartsByFileName[fileName]) {
                    uploadedMediaPartsByFileName[fileName] = [];
                }

                uploadedMediaPartsByFileName[fileName].push(mediaPartInfo);
            }).bind(this));

            return uploadedMediaPartsByFileName;
        },

        _updateRecordingDraftsForFileNames: function(fileNames, updateFunctionFactory) {
            const canAccessDurableDrafts = this._durableRecordingDraftsEnabled || (
                typeof AudioRecorderHelper !== "undefined" &&
                AudioRecorderHelper.getInstance().canAccessDurableBrowserRecordingDrafts &&
                AudioRecorderHelper.getInstance().canAccessDurableBrowserRecordingDrafts()
            );
            if (!canAccessDurableDrafts || !updateFunctionFactory) {
                return RSVP.Promise.resolve([]);
            }

            const normalizedFileNames = (fileNames || []).filter(function(fileName, index, arrayOfFileNames) {
                return !!fileName && arrayOfFileNames.indexOf(fileName) === index;
            });

            if (normalizedFileNames.length === 0) {
                return RSVP.Promise.resolve([]);
            }

            return RSVP.Promise.all(normalizedFileNames.map((function(fileName, index) {
                return this._updateDurableDraftManifestForFileName(fileName, function(recordingId, currentDraftManifest) {
                    return updateFunctionFactory(recordingId, currentDraftManifest, fileName, index);
                }).catch(function(error) {
                    console.warn("Unable to update one of the durable browser recording drafts", fileName, error);
                    throw error;
                });
            }).bind(this)));
        },

        _markPendingRecordingDraftsAsRecoverableFailure: function(error, options) {
            const failureOptions = options || {};
            return this._updateRecordingDraftsForFileNames(this._getPendingRecordingFileNamesForDurableDrafts(), function(recordingId, currentDraftManifest) {
                if (failureOptions.preserveTranscribing && currentDraftManifest && currentDraftManifest.status === RECORDING_DRAFT_STATUSES.TRANSCRIBING) {
                    return currentDraftManifest;
                }

                return BrowserRecordingDraftStore.getInstance().markRecoverableFailure(recordingId, error, {
                    status: RECORDING_DRAFT_STATUSES.FAILED_RECOVERABLE
                });
            }).catch(function(markError) {
                console.warn("Unable to persist the browser recording draft recoverable failure state", markError);
                return null;
            });
        },

        _applyRecoveredDraftCheckpoint: function(recoveredDraftInfo) {
            const draftManifest = recoveredDraftInfo && recoveredDraftInfo.draftManifest ? recoveredDraftInfo.draftManifest : null;
            const fileName = recoveredDraftInfo && recoveredDraftInfo.fileName ? recoveredDraftInfo.fileName : (draftManifest && draftManifest.fileName ? draftManifest.fileName : null);
            if (!draftManifest || !fileName) {
                return RSVP.Promise.resolve(null);
            }

            if (draftManifest.uploadedMediaParts && draftManifest.uploadedMediaParts.length > 0) {
                this._uploadedAudioPartInfoForTranscriptionAndEditing = draftManifest.uploadedMediaParts.map(function(uploadedMediaPart) {
                    return Object.assign({}, uploadedMediaPart, {
                        _filename: fileName,
                        recordingId: draftManifest.recordingId
                    });
                });
            } else if (draftManifest.remoteUploadUrl) {
                this._uploadedAudioPartInfoForTranscriptionAndEditing = [{
                    uri: draftManifest.remoteUploadUrl,
                    locationKey: draftManifest.remoteUploadKey,
                    originalFilename: fileName,
                    _filename: fileName,
                    recordingId: draftManifest.recordingId
                }];
            }

            if (draftManifest.registeredMedia && this._uploadedAudioPartInfoForTranscriptionAndEditing && this._uploadedAudioPartInfoForTranscriptionAndEditing.length > 0) {
                this._audioUriToTrebbleAudio = {};
                this._audioUriToTrebbleAudio[this._uploadedAudioPartInfoForTranscriptionAndEditing[0].uri] = draftManifest.registeredMedia;
            }

            if (draftManifest.status === RECORDING_DRAFT_STATUSES.TRANSCRIBING && draftManifest.transcriptionId) {
                return this._resumeRecoveredTranscription(draftManifest);
            }

            return RSVP.Promise.resolve(draftManifest);
        },

        _waitForRecoveredTranscriptionInfo: async function(draftManifest, maximumPollAttempts) {
            const maxAttempts = maximumPollAttempts || 60;
            const delayInMilli = 10000;

            for (let attemptIndex = 0; attemptIndex < maxAttempts; attemptIndex++) {
                try {
                    const transcriptionInfo = await TrebbleClientAPIHelper.getInstance().getTranscriptionInfo(draftManifest.transcriptionId);
                    if (transcriptionInfo && transcriptionInfo.transcriptionFileLocation && transcriptionInfo.urlOfTranscribedAudio) {
                        return transcriptionInfo;
                    }
                } catch (error) {
                    if (attemptIndex >= maxAttempts - 1) {
                        throw error;
                    }
                }

                const shouldContinuePolling = await new Promise((resolve) => {
                    this._resolveRecoveredTranscriptionPolling = resolve;
                    this._recoveredTranscriptionPollingTimeoutId = setTimeout((function() {
                        this._recoveredTranscriptionPollingTimeoutId = null;
                        this._resolveRecoveredTranscriptionPolling = null;
                        resolve(true);
                    }).bind(this), delayInMilli);
                });
                if (!shouldContinuePolling) {
                    return null;
                }
            }

            throw window.getI18n(ti18n, "TRANSCRIPTION_FAILED");
        },

        _resumeRecoveredTranscription: function(draftManifest) {
            if (!draftManifest || !draftManifest.transcriptionId) {
                return RSVP.Promise.resolve(null);
            }

            this._clearRecoveredTranscriptionPolling();
            if (!this.view) {
                return RSVP.Promise.resolve(null);
            }
            this.view.showHideMessageToStartTranscriptionBox(false);
            this.view.showHideSequncerNodeWrapper(false);
            this.view.showHideUploadingViewInAudioEditor(true);
            this.audioEditorProgressBarController.setIndeterminate(true);
            this.audioEditorProgressBarController.setProgressMessage(this.getTranscribingLabel());
            this.audioEditorProgressBarController.setProgressSubMessage(window.getI18n(ti18n, "THIS_MIGHT_TAKE_A_FEW_MINUTES_WE_WILL_SEND_YOU_AN_EMAIL"));

            if (this.view && this.view.onNextButtonClicked) {
                this.view.onNextButtonClicked(true);
            }

            return RSVP.Promise.resolve(this._waitForRecoveredTranscriptionInfo(draftManifest)).then((function(transcriptionInfo) {
                if (!transcriptionInfo || this._pageTeardownStarted || !this.view) {
                    return null;
                }

                const fileName = draftManifest.fileName || draftManifest.recordingId;
                const uploadedAudioInfo = this._uploadedAudioPartInfoForTranscriptionAndEditing && this._uploadedAudioPartInfoForTranscriptionAndEditing.length > 0 ? this._uploadedAudioPartInfoForTranscriptionAndEditing[0] : null;
                const audioFileUrl = transcriptionInfo.urlOfTranscribedAudio || (uploadedAudioInfo && uploadedAudioInfo.uri) || (draftManifest.registeredMedia && draftManifest.registeredMedia.audioUrl);
                const isVideo = typeof transcriptionInfo.isVideo === "boolean" ? transcriptionInfo.isVideo : !!(draftManifest.registeredMedia && draftManifest.registeredMedia.isVideo);

                return this.initialiazedAudioEditorWithLatestTranscriptions(audioFileUrl, transcriptionInfo.transcriptionFileLocation, draftManifest.transcriptionId, isVideo).then((function(initializedAudioEditor) {
                    const markCompletedPromise = this._updateDurableDraftManifestForFileName(fileName, function(recordingId) {
                        return BrowserRecordingDraftStore.getInstance().markCompleted(recordingId);
                    }).catch(function(error) {
                        console.warn("Unable to mark the recovered durable draft as completed", error);
                        return null;
                    });
                    if(this._pageTeardownStarted || !this.view){
                        return markCompletedPromise.then(function() {
                            return initializedAudioEditor;
                        });
                    }
                    this.view.showHideUploadingViewInAudioEditor(false);
                    this.view.setAudioWasTranscribedAndEdited(true);
                    this.view.showHideSequncerNodeWrapper(true);
                    return markCompletedPromise.then(function() {
                        return initializedAudioEditor;
                    });
                }).bind(this));
            }).bind(this)).catch((function(error) {
                const fileName = draftManifest.fileName || draftManifest.recordingId;
                return this._updateDurableDraftManifestForFileName(fileName, function(recordingId) {
                    return BrowserRecordingDraftStore.getInstance().markRecoverableFailure(recordingId, error, {
                        status: RECORDING_DRAFT_STATUSES.FAILED_RECOVERABLE
                    });
                }).catch(function(markError) {
                    console.warn("Unable to persist the recovered durable draft failure state", markError);
                    return null;
                }).then((function() {
                    if(this._pageTeardownStarted || !this.view){
                        throw error;
                    }
                    this.view.showHideUploadingViewInAudioEditor(false);
                    this.view.showHideMessageToStartTranscriptionBox(true);
                    throw error;
                }).bind(this));
            }).bind(this)).finally((function() {
                this._clearRecoveredTranscriptionPolling();
            }).bind(this));
        },

        recoverRecordingDraft: function(recordingId) {
            const canAccessDurableDrafts = this._durableRecordingDraftsEnabled || (
                AudioRecorderHelper.getInstance().canAccessDurableBrowserRecordingDrafts &&
                AudioRecorderHelper.getInstance().canAccessDurableBrowserRecordingDrafts()
            );
            if (!canAccessDurableDrafts || !recordingId) {
                return RSVP.Promise.resolve(null);
            }

            const selectedDraftManifest = this._recoverableRecordingDrafts.find(function(draftManifest) {
                return draftManifest && draftManifest.recordingId === recordingId;
            }) || null;
            if (selectedDraftManifest && !this._isRecordingDraftCompatibleWithCurrentRecoveryPage(selectedDraftManifest)) {
                return this._rerouteRecoveryDraftToCompatiblePage(selectedDraftManifest);
            }

            return AudioRecorderHelper.getInstance().recoverPersistedRecordingDraft(recordingId).then((function(recoveredDraftInfo) {
                if (!recoveredDraftInfo || !recoveredDraftInfo.draftManifest) {
                    throw new Error("The selected recording draft could not be recovered.");
                }

                const fileName = recoveredDraftInfo.fileName || recoveredDraftInfo.draftManifest.fileName || recordingId;
                const currentRecordingCounter = this.view && this.view.getFileRecordingCounter ? this.view.getFileRecordingCounter() : this._recordingCounterArray.length;

                return RSVP.Promise.resolve(BrowserRecordingDraftStore.getInstance().markRecovered(recordingId)).catch(function(error) {
                    console.warn("Unable to persist the recovered durable draft checkpoint", error);
                    return recoveredDraftInfo.draftManifest;
                }).then((function(updatedDraftManifest) {
                    if (updatedDraftManifest) {
                        recoveredDraftInfo.draftManifest = updatedDraftManifest;
                        AudioRecorderHelper.getInstance().registerDurableDraftManifest(fileName, updatedDraftManifest);
                    }

                    return this._applyRecoveredDraftCheckpoint(recoveredDraftInfo).then((function(result) {
                        const recoveredDraftStatus = recoveredDraftInfo.draftManifest ? recoveredDraftInfo.draftManifest.status : null;
                        const shouldRestorePendingRecordingUi = recoveredDraftStatus !== RECORDING_DRAFT_STATUSES.TRANSCRIBING;
                        if (shouldRestorePendingRecordingUi) {
                            this._trackPendingRecording(fileName, currentRecordingCounter);
                            if (recoveredDraftInfo.mediaInfo && this.view && this.view.addRecoveredRecordingMedia) {
                                this.view.addRecoveredRecordingMedia(recoveredDraftInfo.mediaInfo);
                            }
                        }

                        this._recoveryMode = true;
                        this._recoverableRecordingDrafts = this._recoverableRecordingDrafts.filter(function(draftManifest) {
                            return !draftManifest || draftManifest.recordingId !== recordingId;
                        });
                        if (this.view && this.view.setRecoveryMode) {
                            this.view.setRecoveryMode(true);
                        }
                        if (this.view && this.view.setRecordingDraftRecoveryItems) {
                            this.view.setRecordingDraftRecoveryItems(this._recoverableRecordingDrafts);
                        }

                        if (this.view && this.view.onNextButtonClicked && (
                            recoveredDraftStatus === RECORDING_DRAFT_STATUSES.UPLOADED_UNREGISTERED ||
                            recoveredDraftStatus === RECORDING_DRAFT_STATUSES.REGISTERED_UNTRANSCRIBED
                        )) {
                            this.view.onNextButtonClicked(true);
                        }
                        return result;
                    }).bind(this));
                }).bind(this));
            }).bind(this)).catch((function(error) {
                console.error("Failed recovering the durable browser recording draft", error);
                return RSVP.Promise.resolve(BrowserRecordingDraftStore.getInstance().markRecoverableFailure(recordingId, error, {
                    status: RECORDING_DRAFT_STATUSES.FAILED_RECOVERABLE
                })).catch(function(markError) {
                    console.warn("Unable to persist the recovered durable draft failure state", markError);
                    return null;
                }).then((function() {
                    window.alertUserErrorMessage(window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_PROCESSING_YOUR_RECORDING"));
                    return null;
                }).bind(this));
            }).bind(this));
        },

        discardRecordingDraft: function(recordingId) {
            if (!recordingId) {
                return RSVP.Promise.resolve();
            }

            return AudioRecorderHelper.getInstance().deletePersistedRecordingDraft(recordingId).then((function() {
                this._recoverableRecordingDrafts = this._recoverableRecordingDrafts.filter(function(draftManifest) {
                    return !draftManifest || draftManifest.recordingId !== recordingId;
                });
                if (this.view && this.view.setRecoveryMode) {
                    this.view.setRecoveryMode(this._recoveryMode || this._recoverableRecordingDrafts.length > 0);
                }
                if (this.view && this.view.setRecordingDraftRecoveryItems) {
                    this.view.setRecordingDraftRecoveryItems(this._recoverableRecordingDrafts);
                }
            }).bind(this));
        },

        _trackPendingRecording: function(fileName, recordingCounter, options) {
            const trackingOptions = options || {};
            this._fileNameOfCurrentRecording = fileName;
            this._currentRecordingCounter = recordingCounter;
            this._interruptedRecordingCounterForStop = null;

            if(this._filenameArray.indexOf(fileName) < 0){
                this._filenameArray.push(fileName);
            }
            if(this._recordingCounterArray.indexOf(recordingCounter) < 0){
                this._recordingCounterArray.push(recordingCounter);
            }

            const existingTrackedEntry = this._recordingCounterToFilename[recordingCounter];
            if(trackingOptions.append && existingTrackedEntry){
                const trackedFilenames = Array.isArray(existingTrackedEntry) ? existingTrackedEntry.slice() : [existingTrackedEntry];
                if(trackedFilenames.indexOf(fileName) < 0){
                    trackedFilenames.push(fileName);
                }
                this._recordingCounterToFilename[recordingCounter] = trackedFilenames;
            }else{
                this._recordingCounterToFilename[recordingCounter] = fileName;
            }
        },

        _removeTrackedRecording: function(fileName, recordingCounter) {
            this._filenameArray = this._filenameArray.filter(function(recordingFileName) {
                return recordingFileName !== fileName;
            });

            if(recordingCounter !== null && recordingCounter !== undefined){
                const trackedEntry = this._recordingCounterToFilename[recordingCounter];
                if(Array.isArray(trackedEntry)){
                    const remainingTrackedFilenames = trackedEntry.filter(function(trackedFileName) {
                        return trackedFileName !== fileName;
                    });
                    if(remainingTrackedFilenames.length > 0){
                        this._recordingCounterToFilename[recordingCounter] = remainingTrackedFilenames;
                    }else{
                        delete this._recordingCounterToFilename[recordingCounter];
                    }
                }else if(trackedEntry === fileName){
                    delete this._recordingCounterToFilename[recordingCounter];
                }
            }

            if(!this._recordingCounterToFilename[recordingCounter]){
                this._recordingCounterArray = this._recordingCounterArray.filter(function(counter) {
                    return counter !== recordingCounter;
                });
            }

            if(this._fileNameOfCurrentRecording === fileName){
                this._fileNameOfCurrentRecording = null;
            }
            if(this._currentRecordingCounter === recordingCounter){
                this._currentRecordingCounter = null;
            }
        },

        _cleanupFailedRecordingAttempt: function(fileName, recordingCounter, cleanupMedia) {
            this._removeTrackedRecording(fileName, recordingCounter);

            if(!cleanupMedia || !fileName){
                return RSVP.Promise.resolve();
            }

            return AudioRecorderHelper.getInstance().deleteRecording(fileName).catch(function(error){
                console.warn("Failed cleaning up incomplete browser recording", error);
                return null;
            });
        },

        startRecording : function(recordingCounter){
            //THIS FUNCTION WAS REWRITTEN WITH A LOT OF IF/ELSE CLAUSE TO AVOID USING PROMISE WHEN UNCESSARY AS THIS SEEM TO CAUSE ISSUES ON IOS11
            this._clearLegacyTranscriptionSource();
            let permissionToRecordWasDenided = false;
            let permissionError = null;
            const recordingMediaType = this.getRecordingMediaType();
            const isScreenVideoRecording = recordingMediaType === "video" && this.getRecordingVisualSource() === "screen";
            const permissionPromise = isScreenVideoRecording ? AudioRecorderHelper.getInstance().getPermissionToRecord("audio") : AudioRecorderHelper.getInstance().getPermissionToRecord(recordingMediaType);
            return permissionPromise.catch((function(error){
                console.error(error);
                permissionError = error;
            }).bind(this)).then((function(){
                if(!permissionError){

                    const fileName = this._buildRecordingFileName(recordingCounter, 0);
                    this._trackPendingRecording(fileName, recordingCounter);
                    if(window.isSafariBrowser){
                        //We will assume audio is alredy stopped so we will not try to stop as we will need to add an async process which will prevent user to record after because of iOS limitation
                        //We will also not try to get the browser recorder/record permission because the code which handles safari browser will do it all at once
                        return this._startRecordingProcess().catch((function(error){
                            return this._cleanupFailedRecordingAttempt(fileName, recordingCounter, true).then((function(){
                                if(this.view && this.view.onRecordingStartFailed){
                                    this.view.onRecordingStartFailed();
                                }
                                return null;
                            }).bind(this));
                        }).bind(this));
                    }else{
                        return this.stopPlayingRecordings().catch((function(error){
                            console.error(error);
                            window.alertErrorMessage(window.getI18n(ti18n,"SOMETHING_WENT_WRONG_WHEN_GETTING_READY_TO_RECORD"));
                            throw error;
                        }).bind(this)).then((function(){
                            return this._startRecordingProcess();
                        }).bind(this)).catch((function(error){
                            return this._cleanupFailedRecordingAttempt(fileName, recordingCounter, true).then((function(){
                                if(this.view && this.view.onRecordingStartFailed){
                                    this.view.onRecordingStartFailed();
                                }
                                return null;
                            }).bind(this));
                        }).bind(this));
                    }
                }else{
                    this._showMediaCaptureErrorMessage(permissionError, {
                        context: "recording",
                        recordingMediaType: recordingMediaType
                    });
                }

            }).bind(this))
        },

        _startRecordingProcess : function(options){
            const startOptions = options || {};
            this.setAudioRecordingSupported(true);
            const mediaType = this.getRecordingMediaType();
            const visualSource = this.getRecordingVisualSource();
            const isScreenVideoRecording = mediaType === "video" && visualSource === "screen";
            const stopPreviewPromise = (mediaType === "video" && !isScreenVideoRecording) ? AudioRecorderHelper.getInstance().stopVideoPreview().then((function(){
                if(this.view && this.view.showRecordingPreviewLoading){
                    this.view.showRecordingPreviewLoading();
                }
            }).bind(this)) : RSVP.Promise.resolve();
            const existingScreenPreviewStream = isScreenVideoRecording && AudioRecorderHelper.getInstance().getCurrentVideoPreviewSourceType() === "screen" ? AudioRecorderHelper.getInstance().getCurrentVideoPreviewStream() : null;
            const recordingStreamPromise = startOptions.existingStream ? RSVP.Promise.resolve(startOptions.existingStream) : (isScreenVideoRecording ? AudioRecorderHelper.getInstance().getScreenRecordingStream({
                displayStream: existingScreenPreviewStream
            }) : RSVP.Promise.resolve(null));
            const recorderStartOptions = Object.assign({}, startOptions, {
                mediaType: mediaType,
                originRoute: this._getCurrentRecordingDraftOriginRoute(),
                originFlow: this._getCurrentRecordingDraftOriginFlow(),
                userId: BrowserRecordingDraftStore.getInstance().getCurrentUserId()
            });

            const onRecordingStarted = (function(trebbleRecorderInstance){
                const previewStream = trebbleRecorderInstance && trebbleRecorderInstance.getPreviewStream ? trebbleRecorderInstance.getPreviewStream() : trebbleRecorderInstance.getStream();
                if(!startOptions.skipTimerRestart){
                    this.view.startRecordTimer();
                }
                this.startPeakMeter(trebbleRecorderInstance);
                this.view.setRecordingPreviewStream(this.getRecordingMediaType(), previewStream, {
                    sourceType: visualSource
                });
                if(window.trebbleAnalyticsHelper && !this._analyticsRecordedForCapsuleAudioRecording){
                    window.trebbleAnalyticsHelper.trackEvent("Capsule", "CapsuleAudioRecorded", "Capsule Audio Recorded");
                    this._analyticsRecordedForCapsuleAudioRecording = true;
                }
                try {
                    FacebookEventTrackingHelper.getInstance().trackCapsuleRecorded();
                    FacebookEventTrackingHelper.getInstance().trackContentCreationStarted('capsule');
                } catch(trackingError) {
                    console.warn('Tracking error (record start):', trackingError);
                }
                return trebbleRecorderInstance;
            }).bind(this);

            const onRecordingFailed = (function(error){
                console.error(error);
                const errorInfo = this._getMediaCaptureErrorInfo(error, {
                    context: "recording",
                    recordingMediaType: mediaType
                });
                if(errorInfo.isUnsupportedError){
                    this.setAudioRecordingSupported(false);
                }
                const restorePreviewPromise = mediaType === "video" && visualSource !== "screen" ? this.refreshVideoPreviewIfApplicable(true).catch(function(previewError) {
                    console.warn("Unable to restore the camera preview after the recording start failed", previewError);
                    return null;
                }) : RSVP.Promise.resolve();

                return restorePreviewPromise.then((function() {
                    this._alertMediaCaptureErrorInfo(errorInfo);
                    throw error;
                }).bind(this));
            }).bind(this);

            return stopPreviewPromise.then((function(){
                if(isScreenVideoRecording){
                    return recordingStreamPromise.then((function(stream){
                        if( window.isSafariBrowser){
                            return AudioRecorderHelper.getInstance().getBrowserRecorderAndStartRecordingForiOSWeb(this._fileNameOfCurrentRecording, Object.assign({}, recorderStartOptions, {
                                existingStream: stream
                            }));
                        }
                        return AudioRecorderHelper.getInstance().startRecording(this._fileNameOfCurrentRecording, Object.assign({}, recorderStartOptions, {
                            existingStream: stream
                        }));
                    }).bind(this));
                }
                if(startOptions.existingStream){
                    if( window.isSafariBrowser){
                        return AudioRecorderHelper.getInstance().getBrowserRecorderAndStartRecordingForiOSWeb(this._fileNameOfCurrentRecording, Object.assign({}, recorderStartOptions, {
                            existingStream: startOptions.existingStream
                        }));
                    }
                    return AudioRecorderHelper.getInstance().startRecording(this._fileNameOfCurrentRecording, Object.assign({}, recorderStartOptions, {
                        existingStream: startOptions.existingStream
                    }));
                }
                if( window.isSafariBrowser){
                    return AudioRecorderHelper.getInstance().getBrowserRecorderAndStartRecordingForiOSWeb(this._fileNameOfCurrentRecording, recorderStartOptions);
                }else{
                    return AudioRecorderHelper.getInstance().startRecording(this._fileNameOfCurrentRecording, recorderStartOptions);
                }
            }).bind(this)).then(onRecordingStarted).catch(onRecordingFailed);
        },

        setAudioRecordingSupported : function(audioRecordingSupported){
            this._audioRecordingSupported = audioRecordingSupported;
            this.view.setAudioRecordingSupported(this._audioRecordingSupported);
        },


        stopRecording : function(recordingCounter){
            const finalizeStopUiState = (function(stopSucceeded, result){
                const shouldRestoreCameraPreview = this.isRecordingMediaTypeVideo() && this.getRecordingVisualSource() !== "screen";
                const previewResetPromise = shouldRestoreCameraPreview ? this.refreshVideoPreviewIfApplicable(true).catch(function(error){
                    console.warn("Unable to refresh the recording preview after stopping the recorder", error);
                    return null;
                }) : this.stopVideoPreviewIfApplicable().then((function(){
                    if(this.view && this.view.showRecordingPreviewError && this.isRecordingMediaTypeVideo() && this.getRecordingVisualSource() === "screen"){
                        this.view.showRecordingPreviewError(window.getI18n(ti18n, "SCREEN_SHARE_PREVIEW_ENDED"));
                    }
                    return null;
                }).bind(this));

                return previewResetPromise.then((function(){
                    if(!this.view){
                        return result;
                    }
                    if(stopSucceeded && this.view.onRecordingStopSucceeded){
                        this.view.onRecordingStopSucceeded();
                    }else if(!stopSucceeded && this.view.onRecordingStopFailed){
                        this.view.onRecordingStopFailed();
                    }
                    return result;
                }).bind(this));
            }).bind(this);
            return this._waitForPendingRecordingVisualSourceSwitch().then((function(){
                const fileName = this._fileNameOfCurrentRecording;
                const currentRecordingCounter = this._currentRecordingCounter;
                const effectiveRecordingCounter = currentRecordingCounter !== null && currentRecordingCounter !== undefined ? currentRecordingCounter : this._interruptedRecordingCounterForStop;
                this._interruptedRecordingCounterForStop = null;
                if(this.peakMeterWidgetController){
                    this.peakMeterWidgetController.stopMeter();
                }
                if(AudioRecorderHelper.getInstance().isRecording()){
                    return AudioRecorderHelper.getInstance().stopRecording(fileName).then((function(result){
                        if(this._fileNameOfCurrentRecording === fileName){
                            this._fileNameOfCurrentRecording = null;
                        }
                        if(this._currentRecordingCounter === currentRecordingCounter){
                            this._currentRecordingCounter = null;
                        }
                        return finalizeStopUiState(true, result);
                    }).bind(this)).catch((function(error){
                        return this._cleanupFailedRecordingAttempt(fileName, currentRecordingCounter, false).then((function(){
                            window.alertErrorMessage(error);
                            return finalizeStopUiState(false, null);
                        }).bind(this));
                    }).bind(this));
                }else{
                    const recordedMediaInfoMap = AudioRecorderHelper.getInstance().getRecordFilenameToMediaInfo();
                    const trackedFilenames = effectiveRecordingCounter !== null && effectiveRecordingCounter !== undefined ? this._getTrackedRecordingFilenames(effectiveRecordingCounter) : [];
                    const hasRecordedMedia = trackedFilenames.some(function(trackedFileName) {
                        return !!(trackedFileName && recordedMediaInfoMap && recordedMediaInfoMap[trackedFileName]);
                    });

                    if(this._fileNameOfCurrentRecording === fileName){
                        this._fileNameOfCurrentRecording = null;
                    }
                    if(this._currentRecordingCounter === currentRecordingCounter){
                        this._currentRecordingCounter = null;
                    }
                    return finalizeStopUiState(hasRecordedMedia, null);
                }
            }).bind(this));
        },

        deleteRecording : function(recordingCounter, onDeleteCompleted){
            const completeDelete = function(error, result){
                if(onDeleteCompleted){
                    try{
                        onDeleteCompleted(error || null);
                    }catch(callbackError){
                        console.warn("Unable to notify the view that recording deletion completed", callbackError);
                    }
                }
                if(error){
                    throw error;
                }
                return result;
            };
            const waitForUploadPromise = this._uploadingPromise ? this._uploadingPromise.catch(function(){
                return null;
            }) : RSVP.Promise.resolve();

            return this._waitForPendingRecordingVisualSourceSwitch().then((function(){
                return waitForUploadPromise;
            }).bind(this)).then((function(){
                const recordingFilenamesToDelete = this._getTrackedRecordingFilenames(recordingCounter);
                const removeLocalState = (function(fileNamesToRemove){
                    const trackedFilenamesToRemove = fileNamesToRemove && fileNamesToRemove.length ? fileNamesToRemove.slice() : [];
                    if(trackedFilenamesToRemove.length === 0){
                        const recordingToDeleteIndex  = this._recordingCounterArray.indexOf(recordingCounter);
                        if(recordingToDeleteIndex >= 0){
                            this._recordingCounterArray.splice(recordingToDeleteIndex, 1);
                        }
                        delete this._recordingCounterToFilename[recordingCounter];
                    }else{
                        trackedFilenamesToRemove.forEach((function(fileNameToDelete) {
                            this._removeTrackedRecording(fileNameToDelete, recordingCounter);
                        }).bind(this));
                    }
                    this.resetTranscriptionAndAudioEdits();
                }).bind(this);

                if(!recordingFilenamesToDelete || recordingFilenamesToDelete.length === 0){
                    removeLocalState();
                    return completeDelete(null, []);
                }

                return RSVP.allSettled(recordingFilenamesToDelete.map(function(fileNameToDelete){
                    return AudioRecorderHelper.getInstance().deleteRecording(fileNameToDelete);
                })).then((function(deleteResults){
                    const successfullyDeletedFilenames = [];
                    const deletionErrors = [];

                    deleteResults.forEach(function(deleteResult, index) {
                        if(deleteResult && deleteResult.state === "fulfilled"){
                            successfullyDeletedFilenames.push(recordingFilenamesToDelete[index]);
                        }else if(deleteResult && deleteResult.state === "rejected"){
                            deletionErrors.push(deleteResult.reason);
                        }
                    });

                    if(successfullyDeletedFilenames.length > 0){
                        removeLocalState(successfullyDeletedFilenames);
                    }

                    if(deletionErrors.length > 0){
                        const primaryDeleteError = deletionErrors[0];
                        const deleteError = primaryDeleteError instanceof Error ? primaryDeleteError : new Error(primaryDeleteError || "Unable to delete one or more recordings.");
                        deleteError.partialDeletionErrors = deletionErrors;
                        deleteError.partiallyDeletedFilenames = successfullyDeletedFilenames;
                        return completeDelete(deleteError, deleteResults);
                    }

                    return completeDelete(null, deleteResults);
                }).bind(this));
            }).bind(this)).catch(function(error){
                return completeDelete(error);
            });


            },

            deleteAllRecordings : function(){
                AudioRecorderHelper.getInstance().deleteAllBackgroundMusicDownloadedLocally();
                return this._waitForPendingRecordingVisualSourceSwitch().then((function(){
                    const stopRecordingIfApplicablePromise = AudioRecorderHelper.getInstance().isRecording()? AudioRecorderHelper.getInstance().stopRecording(this._fileNameOfCurrentRecording): RSVP.Promise.resolve();
                    return stopRecordingIfApplicablePromise.then((function(){
                        return this.stopPlayingRecordings()
                    }).bind(this)).catch((function(error){
                        console.error(error);
                    }).bind(this)).then((function(){
                        const promises = [];
                        const recordingCounterArrayCopy = this._recordingCounterArray.slice();
                        for(let index in recordingCounterArrayCopy){
                            const recordingCounter =  recordingCounterArrayCopy[index];
                            promises.push(this.deleteRecording(recordingCounter));
                        }
                        return RSVP.Promise.all(promises);
                    }).bind(this));
                }).bind(this));

            },

            playRecordings : function(){
                const pendingMediaDescriptors = this.getPendingMediaDescriptors();
                const shouldUseRecordedVideoPlayback = this.isInRecordMode() && pendingMediaDescriptors && pendingMediaDescriptors.length > 0 && pendingMediaDescriptors.some((function(mediaDescriptor){
                    return this._isMediaDescriptorVideo(mediaDescriptor);
                }).bind(this)) && pendingMediaDescriptors.every(function(mediaDescriptor){
                    return !!(mediaDescriptor && mediaDescriptor.localUrl);
                }) && this.view && this.view.playRecordedVideoPlayback;

                if(shouldUseRecordedVideoPlayback){
                    this._playRecordingRequestId = Utils.getInstance().generateRandomId();
                    const currentPlayRecordingRequestId = this._playRecordingRequestId;
                    const playbackPromise = this.view.playRecordedVideoPlayback(pendingMediaDescriptors).then((function(){
                        if(currentPlayRecordingRequestId == this._playRecordingRequestId){
                            this.view.setIsPlaying(false);
                        }
                    }).bind(this)).catch((function(error){
                        if(currentPlayRecordingRequestId == this._playRecordingRequestId){
                            this.view.setIsPlaying(false);
                        }
                        if(error){
                            console.error(error);
                            window.alertErrorMessage(window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_PLAYING_YOUR_CAPSULE"));
                        }
                    }).bind(this));
                    this.view.setIsPlaying(true);
                    return playbackPromise;
                }

                const backgroundTrackLoadingHandler = (function(isLoading){
                    this.view.setIsPlaybackLoading(isLoading);
                }).bind(this);
                const backgroudTrackUrl = this._backgroundTrackUrl;
                this._playRecordingRequestId = Utils.getInstance().generateRandomId();
                const currentPlayRecordingRequestId = this._playRecordingRequestId;
                const p =  AudioRecorderHelper.getInstance().playRecordings(this._filenameArray, this._backgroundTrackUrl, backgroundTrackLoadingHandler, currentPlayRecordingRequestId).then((function(){
                    if(currentPlayRecordingRequestId == this._playRecordingRequestId){
        //the background audio was not interupted by another playback
                        this.view.setIsPlaying(false);
                    }
                }).bind(this)).catch((function(error){
                    if(currentPlayRecordingRequestId == this._playRecordingRequestId){
        //the background audio was not interupted by another playback
                        this.view.setIsPlaying(false);
                    }
                }).bind(this));
                this.view.setIsPlaying(true);
                return p;
            },

            stopPlayingRecordings: function(){
                const stopVideoPlaybackPromise = this.view && this.view.stopRecordedVideoPlayback ? this.view.stopRecordedVideoPlayback() : RSVP.Promise.resolve();
                return RSVP.all([
                    stopVideoPlaybackPromise,
                    AudioRecorderHelper.getInstance().stopPlayRecordingsIfApplicable()
                ]).then((function(){
                    this.view.setIsPlaying(false);
                }).bind(this));
            },

            uploadRecordings : function(){
                const songUri = this.getSongModelToPlayAfterCapsule()? this.getSongModelToPlayAfterCapsule().get("uri"): null;
                let capsuleRefIdOrSongRefUri = this.capsuleId;
                let isCapsuleReply = true;
                if(!capsuleRefIdOrSongRefUri){
                    capsuleRefIdOrSongRefUri = songUri;
                    isCapsuleReply = false;
                }
                if(this.view.isAudioWasTranscribedAndEdited()){
                    if(this.capsuleInfoProgressBarController){
                        this.capsuleInfoProgressBarController.setProgressMessage(window.getI18n(ti18n,"RENDERING_AUDIO"));
                        this.capsuleInfoProgressBarController.setProgressSubMessage(window.getI18n(ti18n, "THIS_MIGHT_TAKE_A_FEW_MINUTES")+ " "+ window.getI18n(ti18n, "DO_NOT_REFRESH")+ " "+window.getI18n(ti18n, "PLEASE_HOLD_ON_TIGHT"));
                    }
                    return this._uploadRenderedEditedAudioFromBrowser(null, this.capsuleInfoProgressBarController, false, false, true, this.getUploadingLabel());
                }else{
                    if (window.device && window.device.platform == "browser"  && !(window.trebble.useNativeRecording && "Media" in window && this.isInRecordMode())) {
                        if(this.isInRecordMode()){
                            const recordedMediaDescriptors = this.getPendingMediaDescriptors();
                            const signatureFunctionName = this._getRecordedMediaUploadSignatureFunctionName(recordedMediaDescriptors);
                            return this._uploadRecordedAudioFromBrowser(signatureFunctionName, this.capsuleInfoProgressBarController);
                        }else{
                            let apiMethodToCall =  "getSignatureForCapsuleUpload";
                            if(this.capsuleId){
                                apiMethodToCall =  "getSignatureForCapsuleReplyUpload";
                            }
                            if(!capsuleRefIdOrSongRefUri){
                                apiMethodToCall = "getSignatureForCapsuleWithNoSongUpload";
                            }

                            return this._uploadProvidedAudioFileFromBrowser(apiMethodToCall, this.capsuleInfoProgressBarController);
                        }
                    }else{

                        return this._uploadFileProvidedFromNative();
                    }
                }
            },

            _rejectMissingSequencerControllerForEditedAudio: function(){
                const errorMessage = window.getI18n(ti18n, "UPLOADING_FAILED");
                window.sendErrorToRaygun("Attempted to save or upload edited audio without a sequencer controller", true);
                return RSVP.Promise.reject(errorMessage);
            },

            _rejectMissingSequencerProjectIdForEditedAudio: function(){
                const errorMessage = window.getI18n(ti18n, "UPLOADING_FAILED");
                window.sendErrorToRaygun("Attempted to save or update edited audio without a sequencer project id", true);
                return RSVP.Promise.reject(errorMessage);
            },

            _rejectUnsuccessfulSequencerProjectSaveForEditedAudio: function(){
                const errorMessage = window.getI18n(ti18n, "UPLOADING_FAILED");
                window.sendErrorToRaygun("Attempted to save or update edited audio without a successful sequencer project save", true);
                return RSVP.Promise.reject(errorMessage);
            },

            _rejectChangedSequencerControllerForEditedAudio: function(){
                const errorMessage = window.getI18n(ti18n, "UPLOADING_FAILED");
                window.sendErrorToRaygun("Edited audio sequencer changed while saving project", true);
                return RSVP.Promise.reject(errorMessage);
            },

            _uploadRenderedEditedAudioFromBrowser: function(functionNameToRetrieveUploadSignature, progressBarController, renderWavFile, asVideo, updateProgressBarDuringRendering, defaultProgresMessageOnUpload){
                if(!this._sequencerController){
                    return this._rejectMissingSequencerControllerForEditedAudio();
                }
                const songUri = this.getSongModelToPlayAfterCapsule()? this.getSongModelToPlayAfterCapsule().get("uri"): null;
                let capsuleRefIdOrSongRefUri = this.capsuleId;
                let isCapsuleReply = true;
                if(!capsuleRefIdOrSongRefUri){
                    capsuleRefIdOrSongRefUri = songUri;
                    isCapsuleReply = false;
                }
                const blobToUploadArray = [];
                let onRenderingProgressReported = null;
                if(updateProgressBarDuringRendering && progressBarController){
                    onRenderingProgressReported = function(progress, operationInProgress){
                        if(progress){
                            progressBarController.setIndeterminate(false);
                            progressBarController.setProgressMessage(operationInProgress?operationInProgress:defaultProgresMessageOnUpload);
                            progressBarController.setProgressSubMessage(window.getI18n(ti18n, "THIS_MIGHT_TAKE_A_FEW_MINUTES")+ " "+ window.getI18n(ti18n, "DO_NOT_REFRESH")+ " "+window.getI18n(ti18n, "PLEASE_HOLD_ON_TIGHT"));
                            progressBarController.setPercentageProgress(Math.round(progress)+ "%");
                        }else{
                            progressBarController.setIndeterminate(true);
                            progressBarController.setProgressMessage(operationInProgress?operationInProgress:defaultProgresMessageOnUpload);
                            progressBarController.setProgressSubMessage(window.getI18n(ti18n, "THIS_MIGHT_TAKE_A_FEW_MINUTES")+ " "+ window.getI18n(ti18n, "DO_NOT_REFRESH")+ " "+window.getI18n(ti18n, "PLEASE_HOLD_ON_TIGHT"));
                        }
                    }
                }
                if(LIMIT_MAX_FILE_RENDERED && this._sequencerController.getDurationInMilliseconds() > 30 * 60 * 100){
                    return RSVP.Promise.reject(asVideo?window.getI18n(ti18n,"UNFORTUNATELY_TREBBLE_CANNOT_RENDER_30_MIN_VIDEO"): window.getI18n(ti18n,"UNFORTUNATELY_TREBBLE_CANNOT_RENDER_30_MIN_AUDIO"));
                }
                this._uploadingPromise  = this._sequencerController.getRenderedAudioBlob(renderWavFile, asVideo, onRenderingProgressReported, this._lastRenderWavFileBlob).then((function(blob){
                    if(renderWavFile && !asVideo){
                        this._lastRenderWavFileBlob =  blob;
                    }
                    if(defaultProgresMessageOnUpload && progressBarController){
                        progressBarController.setIndeterminate(false);
                        progressBarController.setProgressMessage(defaultProgresMessageOnUpload);
                        progressBarController.setProgressSubMessage(window.getI18n(ti18n, "THIS_MIGHT_TAKE_A_FEW_MINUTES")+ " "+ window.getI18n(ti18n, "DO_NOT_REFRESH")+ " "+window.getI18n(ti18n, "PLEASE_HOLD_ON_TIGHT"));
                        progressBarController.setPercentageProgress("0%");
                        progressBarController.setIndeterminate(true);
                    }
                    return FileUploadHelper.getInstance().uploadAudioHigightsInWebBrowser([blob], capsuleRefIdOrSongRefUri, this.view.$el, isCapsuleReply, blob.size, progressBarController, functionNameToRetrieveUploadSignature, true, true);
                }).bind(this)).then((function(result){
                    this._uploadingPromise = null;
                    return result;
                }).bind(this)).catch(function(error){
                    try{
                        if(window.trebbleAnalyticsHelper){
                            window.trebbleAnalyticsHelper.trackEvent("Capsule", "errorOccuredDuringCapsuleUploadingToServer", "Error During Capsule Uploading To Server", error);
                        }
                    }catch(error){
                        console.error("There was an error logging than error occured during the capsule uploading to server. Error:"+error);
                    }
                    const isExpectedError = !!(error && (
                        (ExpectedError && error instanceof ExpectedError) ||
                        error.name === "ExpectedError" ||
                        error.isNetworkError === true ||
                        error.expectedErrorCategory
                    ));
                    if(isExpectedError){
                        throw error;
                    }
                    if(error){
                        throw window.getI18n(ti18n,"UPLOADING_FAILED_ERROR") + error
                    }else{
                        throw window.getI18n(ti18n,"UPLOADING_FAILED");
                    }
                });

                return this._uploadingPromise;
            },

            saveSequencerProjectIfApplicable : function(progressBarController){
                const isEditedAudio = this.view && this.view.isAudioWasTranscribedAndEdited && this.view.isAudioWasTranscribedAndEdited();
                const shouldShowSavingProject = (this.isInRecordMode && this.isInRecordMode()) || (this.isInUploadMode && this.isInUploadMode()) || isEditedAudio;
                if(shouldShowSavingProject && progressBarController){
                    progressBarController.setIndeterminate(true);
                    progressBarController.setProgressMessage(window.getI18n(ti18n,"SAVING_PROJECT"));
                    progressBarController.setProgressSubMessage(window.getI18n(ti18n, "THIS_MIGHT_TAKE_A_FEW_MINUTES")+ " "+ window.getI18n(ti18n, "DO_NOT_REFRESH")+ " "+window.getI18n(ti18n, "PLEASE_HOLD_ON_TIGHT"));
                }
                if(isEditedAudio){
                    const sequencerController = this._sequencerController;
                    if(!sequencerController){
                        return this._rejectMissingSequencerControllerForEditedAudio();
                    }
                    return RSVP.Promise.resolve(sequencerController.saveProject()).then((function(saveProjectResult){
                        if(this._sequencerController !== sequencerController){
                            return this._rejectChangedSequencerControllerForEditedAudio();
                        }
                        if(!saveProjectResult || !saveProjectResult.projectWasSaved){
                            return this._rejectUnsuccessfulSequencerProjectSaveForEditedAudio();
                        }
                        const projectId = saveProjectResult.projectId || (sequencerController.getProjectId ? sequencerController.getProjectId() : (this.getProjectId ? this.getProjectId() : null));
                        if(!projectId){
                            return this._rejectMissingSequencerProjectIdForEditedAudio();
                        }
                        return projectId;
                    }).bind(this));
                }
                return RSVP.Promise.resolve(this.getProjectId ? this.getProjectId() : null);
            },


            uploadHQRenderedEditedAudioIfApplicable : function(progressBarController){
                if(this.isInRecordMode() || this.isInUploadMode()){
                    const defaultProgresMessageOnUpload = this.getUploadingLabel();
                    if(this.view.isAudioWasTranscribedAndEdited()){
                        if(progressBarController){
                            progressBarController.setIndeterminate(false);
                            progressBarController.setProgressMessage(window.getI18n(ti18n,"RENDERING_AUDIO_UNCOMPRESSED"));
                            progressBarController.setProgressSubMessage(window.getI18n(ti18n, "THIS_MIGHT_TAKE_A_FEW_MINUTES")+ " "+ window.getI18n(ti18n, "DO_NOT_REFRESH")+ " "+window.getI18n(ti18n, "PLEASE_HOLD_ON_TIGHT"));
                            progressBarController.setPercentageProgress("0%");
                            progressBarController.setIndeterminate(true);
                        }
                        return this._uploadRenderedEditedAudioFromBrowser(null, this.capsuleInfoProgressBarController, true, false, true, defaultProgresMessageOnUpload).then(function(audioPartsInfo){
                            if(audioPartsInfo && audioPartsInfo.length > 0){
                                return audioPartsInfo[0];
                            }

                        });
                    }
                }
                return RSVP.Promise.resolve();
            },


            uploadVideoRenderedEditedIfApplicable : function(progressBarController){
                if(this.isInRecordMode() || this.isInUploadMode()){
                    if(this.view.isAudioWasTranscribedAndEdited() && this.isEditedContentContainsVideo()){
                        if(progressBarController){
                            progressBarController.setProgressMessage(window.getI18n(ti18n,"RENDERING_VIDEO_FILE"));
                            progressBarController.setProgressSubMessage(window.getI18n(ti18n, "THIS_MIGHT_TAKE_A_FEW_MINUTES")+ " "+ window.getI18n(ti18n, "DO_NOT_REFRESH")+ " "+window.getI18n(ti18n, "PLEASE_HOLD_ON_TIGHT"));
                        }
                        return this._uploadRenderedEditedAudioFromBrowser("getSignatureForCapsuleVideoUpload", this.capsuleInfoProgressBarController, true, true, true, this.getUploadingLabel()).then(function(audioPartsInfo){
                            if(audioPartsInfo && audioPartsInfo.length > 0){
                                return audioPartsInfo[0];
                            }

                        });
                    }
                }
                return RSVP.Promise.resolve();
            },


            _uploadRecordedAudioFromBrowser : function(functionNameToRetrieveUploadSignature, progressBarController){
                return AudioRecorderHelper.getInstance().getRecordingPromise().then((function(){
                    const songUri = this.getSongModelToPlayAfterCapsule()? this.getSongModelToPlayAfterCapsule().get("uri"): null;
                    let capsuleRefIdOrSongRefUri = this.capsuleId;
                    let isCapsuleReply = true;
                    if(!capsuleRefIdOrSongRefUri){
                        capsuleRefIdOrSongRefUri = songUri;
                        isCapsuleReply = false;
                    }
                    const blobToUploadArray = [];
                    const recordFilenameToBlog =  AudioRecorderHelper.getInstance().getRecordFilenameToBlob();
                    const recordFilenameToMediaInfo = AudioRecorderHelper.getInstance().getRecordFilenameToMediaInfo();
                    let totalUploadSizeInBytes = 0;
                    for(let index in this._filenameArray){
                        const fileName = this._filenameArray[index];
                        const mediaInfo = recordFilenameToMediaInfo[fileName];
                        const blob = mediaInfo && mediaInfo.file ? mediaInfo.file : recordFilenameToBlog[fileName];
                        if(blob && blob.size  !== 0 && blob.size > 0){
                            const uploadableFile = blob.name ? blob : Utils.getInstance().createFileWithNewName(blob, fileName);
                            blobToUploadArray.push(uploadableFile);
                            totalUploadSizeInBytes = totalUploadSizeInBytes + uploadableFile.size;
                            uploadableFile._filename = fileName;
                            if (mediaInfo && mediaInfo.recordingHealth) {
                                uploadableFile._recordingHealth = mediaInfo.recordingHealth;
                            }
                        }else{
                            try{
                                if(window.trebbleAnalyticsHelper){
                                    window.trebbleAnalyticsHelper.trackEvent("Capsule", "errorOccuredDuringCapsuleUploadingProcess", "Error During Capsule Uploading Process", blob && blob.size);
                                }
                            }catch(error){
                                console.error("There was an error logging than error occured during the capsule uploading process. Error:"+error);
                            }
                            return RSVP.Promise.reject(window.getI18n(ti18n,"OOPS_ERROR_WHILE_RENDERING_YOUR_RECORDING"));
                        }
                    }
                    const fileNamesToUpload = this._getPendingRecordingFileNamesForDurableDrafts();
                    const markUploadStartedPromise = this._updateRecordingDraftsForFileNames(fileNamesToUpload, function(recordingId) {
                        return BrowserRecordingDraftStore.getInstance().markUploadStarted(recordingId);
                    }).catch(function(error) {
                        console.warn("Unable to persist the durable draft upload-start checkpoint", error);
                        return [];
                    });

                    this._uploadingPromise  = markUploadStartedPromise.then((function(){
                        return FileUploadHelper.getInstance().uploadAudioHigightsInWebBrowser(blobToUploadArray, capsuleRefIdOrSongRefUri, this.view.$el, isCapsuleReply, totalUploadSizeInBytes, progressBarController, functionNameToRetrieveUploadSignature, true, true);
                    }).bind(this)).then((function(result){
                        const uploadedMediaPartsByFileName = this._groupUploadedMediaPartsByFileName(result);
                        return this._updateRecordingDraftsForFileNames(fileNamesToUpload, function(recordingId, currentDraftManifest, fileName) {
                            return BrowserRecordingDraftStore.getInstance().markUploadCompleted(recordingId, uploadedMediaPartsByFileName[fileName] || []);
                        }).catch(function(error) {
                            console.warn("Unable to persist the durable draft upload checkpoint", error);
                            return null;
                        }).then(function() {
                            return result;
                        });
                    }).bind(this)).then((function(result){
                        this._uploadingPromise = null;
                        return result;
                    }).bind(this)).catch((function(error){
                        this._uploadingPromise = null;
                        try{
                            if(window.trebbleAnalyticsHelper){
                                window.trebbleAnalyticsHelper.trackEvent("Capsule", "errorOccuredDuringCapsuleUploadingToServer", "Error During Capsule Uploading To Server", error);
                            }
                        }catch(error){
                            console.error("There was an error logging than error occured during the capsule uploading to server. Error:"+error);
                        }

                        const isExpectedError = !!(error && (
                            (ExpectedError && error instanceof ExpectedError) ||
                            error.name === "ExpectedError" ||
                            error.isNetworkError === true ||
                            error.expectedErrorCategory
                        ));
                        const uploadError = error ? window.getI18n(ti18n,"UPLOADING_FAILED_ERROR") + error : window.getI18n(ti18n,"UPLOADING_FAILED");
                        return this._markPendingRecordingDraftsAsRecoverableFailure(uploadError).then(function() {
                            if(isExpectedError){
                                throw error;
                            }
                            throw uploadError;
                        });
                    }).bind(this));

                    return this._uploadingPromise;
                }).bind(this));
            },

            _uploadProvidedAudioFileFromBrowser : function(functionNameToRetrieveUploadSignature, progressBarController){
                const songUri = this.getSongModelToPlayAfterCapsule()? this.getSongModelToPlayAfterCapsule().get("uri"): null;
                let capsuleRefIdOrSongRefUri = this.capsuleId;
                let isCapsuleReply = true;
                if(!capsuleRefIdOrSongRefUri){
                    capsuleRefIdOrSongRefUri = songUri;
                    isCapsuleReply = false;
                }
                const fname = this._capsuleUploadDropzoneObj.getAcceptedFiles()[0].name;
                this._capsuleUploadDropzoneObj.getAcceptedFiles()[0].status = "queued";
                const extension = fname.substr(fname.lastIndexOf("."));
                const nameOfFileToUpload = extension? "userCreatedCapsule_"+(new Date()).getTime()+extension : "userCreatedCapsule_"+(new Date()).getTime();

                const onBytesSentHanlder = (function(file, progressInPercentage, byteSent) {
                    if(progressBarController){
                        progressBarController.setPercentageProgress(Math.round(progressInPercentage) + "%");
                    }
                }).bind(this);
                this._capsuleUploadDropzoneObj.on("uploadprogress",onBytesSentHanlder );
                this._signatureValidationStarted  = true;
                const uploadedFile = this._capsuleUploadDropzoneObj.getAcceptedFiles()[0];
                const validationFunction = this._getUploadValidationFunctionForFile(uploadedFile);
                FileUploadHelper.getInstance().validateAndSignFunctionHanlder(this._capsuleUploadDropzoneObj, nameOfFileToUpload, validationFunction, functionNameToRetrieveUploadSignature ,capsuleRefIdOrSongRefUri, true).then((function(){
                    this._processQueueStarted = true;
                    this._signatureValidationStarted  = false;
                    this._capsuleUploadDropzoneObj.processQueue();
                }).bind(this)).catch(this._dropzonePromiseReject);

                this._userUploadedCapsulePromise = new RSVP.Promise((function(userUploadedCapsulePromiseResolve, userUploadedCapsulePromiseReject){
                    this._userUploadedCapsulePromiseResolve =  userUploadedCapsulePromiseResolve;
                    this._userUploadedCapsulePromiseReject =  userUploadedCapsulePromiseReject;
                }).bind(this));

                return this._userUploadedCapsulePromise;
            },

            _getUploadedFileMediaType : function(file){
                const fileMimeType = file && file.type ? file.type.toLowerCase() : "";
                if(fileMimeType.indexOf("video/") === 0){
                    return "video";
                }
                if(fileMimeType.indexOf("audio/") === 0){
                    return "audio";
                }
                const fileName = file && file.name ? file.name.toLowerCase() : "";
                if(/\.(mp4|mov|webm|mpeg)$/i.test(fileName)){
                    return "video";
                }
                if(/\.(mp3|wav|m4a|oga|ogg)$/i.test(fileName)){
                    return "audio";
                }
                return "audio";
            },

            _getUploadValidationFunctionForFile : function(file){
                const isVideo = this._getUploadedFileMediaType(file) === "video";
                return isVideo ? FileUploadHelper.getInstance().getVideoFileTypeValidationFunction() : FileUploadHelper.getInstance().getAudioFileTypeValidationFunction();
            },

            _getInvalidUploadedFileErrorMessage : function(file){
                const mediaType = this._getUploadedFileMediaType(file);
                const i18nKey = mediaType === "video" ? "INVALID_VIDEO_FILE_UPLOADED" : "INVALID_AUDIO_FILE_UPLOADED";
                return window.getI18n(ti18n, i18nKey);
            },


            _uploadFileProvidedFromNative : function(functionNameToRetrieveUploadSignature){
                const songUri = this.getSongModelToPlayAfterCapsule()? this.getSongModelToPlayAfterCapsule().get("uri"): null;
                let capsuleRefIdOrSongRefUri = this.capsuleId;
                let isCapsuleReply = true;
                if(!capsuleRefIdOrSongRefUri){
                    capsuleRefIdOrSongRefUri = songUri;
                    isCapsuleReply = false;
                }
                this._uploadingPromise = FileUploadHelper.getInstance().getPersistentFileSystemUrl().then((function(persitentFSUrl){
                    const filenameInfoToUploadArray = [];

    const filePrefix = /*device.platform == "iOS"? "cdvfile://localhost/persistent/":*/ persitentFSUrl;
                    for(let index in this._filenameArray){
                        const fileName = this._filenameArray[index];
                        const fileNameInfoToUpload = {};
                        fileNameInfoToUpload.name = fileName;

                        fileNameInfoToUpload.url = filePrefix + fileName;
                        filenameInfoToUploadArray.push(fileNameInfoToUpload);
                    }
                    return FileUploadHelper.getInstance().uploadAudioHigightsForSong(filenameInfoToUploadArray, capsuleRefIdOrSongRefUri, isCapsuleReply, functionNameToRetrieveUploadSignature);
                }).bind(this)).then((function(result){
                    this._uploadingPromise = null;
                    return result;
                }).bind(this)).catch(function(error){
                    const isExpectedError = !!(error && (
                        (ExpectedError && error instanceof ExpectedError) ||
                        error.name === "ExpectedError" ||
                        error.isNetworkError === true ||
                        error.expectedErrorCategory
                    ));
                    if(isExpectedError){
                        throw error;
                    }
                    if(error){
                        throw window.getI18n(ti18n,"UPLOADING_FAILED_ERROR") + error
                    }else{
                        throw window.getI18n(ti18n,"UPLOADING_FAILED");
                    }
                });
                return this._uploadingPromise;
            },


            uploadRecordingsInUserAudioLibrary : function(functionNameToRetrieveUploadSignature){
                const songUri = this.getSongModelToPlayAfterCapsule()? this.getSongModelToPlayAfterCapsule().get("uri"): null;
                let capsuleRefIdOrSongRefUri = this.capsuleId;
                let isCapsuleReply = true;
                if(!capsuleRefIdOrSongRefUri){
                    capsuleRefIdOrSongRefUri = songUri;
                    isCapsuleReply = false;
                }
                if (window.device && window.device.platform == "browser"  && !(window.trebble.useNativeRecording && "Media" in window && this.isInRecordMode())) {
                    const signatureFunctionName = functionNameToRetrieveUploadSignature || this.getUserLibraryUploadSignatureFunctionName();
                    if(this.isInRecordMode()){

                        return this._uploadRecordedAudioFromBrowser(signatureFunctionName, this.audioEditorProgressBarController);
                    }else{
                        let apiMethodToCall =  "getSignatureForCapsuleUpload";
                        if(this.capsuleId){
                            apiMethodToCall =  "getSignatureForCapsuleReplyUpload";
                        }
                        if(!capsuleRefIdOrSongRefUri){
                            apiMethodToCall = "getSignatureForCapsuleWithNoSongUpload";
                        }

                        return this._uploadProvidedAudioFileFromBrowser(signatureFunctionName || apiMethodToCall, this.audioEditorProgressBarController);
                    }
                }else{

                    return this._uploadFileProvidedFromNative(functionNameToRetrieveUploadSignature);
                }
            },

            saveCapsuleConfirm : function(){
                if(!this.canSaveProjectChanges()){
                    return RSVP.Promise.resolve();
                }
                if(this.getSongModelToPlayAfterCapsule() && !this.getSongModelToPlayAfterCapsule().get("addedToRadio")){
                    if(!this._receiverUserId){
                        const addSongToTrebbleAndSaveCapsule = (function(buttonIndex){
                            if(buttonIndex == 2){
                                $.mobile.loading("show");
                                return PersistentModels.getInstance().addSongToDefaultRadio(this.getSongModelToPlayAfterCapsule(), Utils.getInstance().buildContextForCapsuleCreation(), null, true).then((function(){
                                    $.mobile.loading("hide");
                                    return this.saveCapsule();
                                }).bind(this)).catch(function(error){
                                    $.mobile.loading("hide");
                                    window.alertErrorMessage(window.getI18n(ti18n,"ADDING_MUSIC_TO_YOUR_TREBBLE_FAILED") + error);
                                });
                            }
                        }).bind(this);
                        window.showConfirmDialog(window.getI18n(ti18n,"THE_MUSIC_NEEDS_TO_ADDED_TO_YOUR_LIBRARY"), addSongToTrebbleAndSaveCapsule, window.getI18n(ti18n,"ADD_SONG_TO_YOUR_TREBBLE"), [ window.getI18n(ti18n,"NO"), window.getI18n(ti18n,"YES")]);
                    }else{
        //Do not add to the trebble if the song is gonna be sent to another user
                        $.mobile.loading("show");
                        return PersistentModels.getInstance().addSongToDefaultRadio(this.getSongModelToPlayAfterCapsule(), Utils.getInstance().buildContextForCapsuleCreation(), null, true).then((function(){
                            $.mobile.loading("hide");
                            return this.saveCapsule();
                        }).bind(this)).catch(function(error){
                            $.mobile.loading("hide");
                            window.alertErrorMessage( window.getI18n(ti18n,"ADDING_MUSIC_TO_YOUR_TREBBLE_FAILED")+ error);
                        });
                    }
                }else{
                    return this.saveCapsule();
                }
            },

            uploadRecordingToAudioLibraryForEditingIfApplicable : function(progressBarController){
                if(this.isInRecordMode() || this.isInUploadMode()){
                    const recoveredUploadedMediaParts = this.isInRecordMode() ? this._getRecoveredUploadedMediaPartsForPendingMedia() : null;
                    if(recoveredUploadedMediaParts && recoveredUploadedMediaParts.length > 0){
                        return RSVP.Promise.resolve(recoveredUploadedMediaParts);
                    }

                    progressBarController.setIndeterminate(false);
                    progressBarController.setProgressMessage(this.getUploadingLabel());
                    progressBarController.setProgressSubMessage(window.getI18n(ti18n, "THIS_MIGHT_TAKE_A_FEW_MINUTES")+ " "+ window.getI18n(ti18n, "DO_NOT_REFRESH")+ " "+window.getI18n(ti18n, "PLEASE_HOLD_ON_TIGHT"));
                    progressBarController.setPercentageProgress("0%");
                    if(window.trebbleAnalyticsHelper){
                        window.trebbleAnalyticsHelper.trackEvent("audioEditing", "Upload audio for editing", "Upload audio for editing");
                    }
                    return this.uploadRecordingsInUserAudioLibrary();
                }else{

                    return RSVP.Promise.resolve();
                }
            },


            uploadRecordingIfApplicable : function(progressBarController){
                if(this.isInRecordMode() || this.isInUploadMode()){
                    const recoveredUploadedMediaParts = this.isInRecordMode() ? this._getRecoveredUploadedMediaPartsForPendingMedia() : null;
                    if(recoveredUploadedMediaParts && recoveredUploadedMediaParts.length > 0){
                        return RSVP.Promise.resolve(recoveredUploadedMediaParts);
                    }

                    progressBarController.setIndeterminate(false);
                    progressBarController.setProgressMessage(this.getUploadingLabel());
                    progressBarController.setProgressSubMessage(window.getI18n(ti18n, "THIS_MIGHT_TAKE_A_FEW_MINUTES")+ " "+ window.getI18n(ti18n, "DO_NOT_REFRESH")+ " "+window.getI18n(ti18n, "PLEASE_HOLD_ON_TIGHT"));
                    progressBarController.setPercentageProgress("0%");
                    progressBarController.setIndeterminate(true);
                    return this.uploadRecordings();
                }else{

                    return RSVP.Promise.resolve();
                }
            },

            canSaveProjectChanges : function(){
                return this._projectAccessLevel !== "can_view" &&
                    !this._workspaceReadOnly &&
                    (!this._sequencerController || this._sequencerController.hasMutationAccess());
            },

            getProjectId:function(){
                return this._sequencerController? this._sequencerController.getProjectId():null;
            },

            _delayBackendVideoRenderRetry: function(delayInMilliseconds) {
                return new RSVP.Promise(function(resolve) {
                    setTimeout(resolve, delayInMilliseconds);
                });
            },

            _startBackendVideoRenderingForSavedCapsule: async function(playableAudioUrl, capsuleId, audioEditVersion) {
                if(!this._sequencerController || !capsuleId){
                    return;
                }
                // Newly-created video capsules may not have a playable audio URL yet.
                // The cloud-render kickoff renders and uploads audio locally when needed.

                const maximumRenderKickoffAttempts = 2;
                const retryDelayInMilliseconds = 500;
                let lastRenderKickoffError = null;

                for(let attemptIndex = 0; attemptIndex < maximumRenderKickoffAttempts; attemptIndex++){
                    try{
                        await this._sequencerController.startVideoRenderingInCloudForLaterDownload(null, null, playableAudioUrl, capsuleId, undefined, undefined, audioEditVersion);
                        return;
                    }catch(error){
                        lastRenderKickoffError = error;
                        console.warn("Unable to start cloud video rendering after capsule persistence", error);
                        if(attemptIndex < maximumRenderKickoffAttempts - 1){
                            await this._delayBackendVideoRenderRetry(retryDelayInMilliseconds * (attemptIndex + 1));
                        }
                    }
                }

                try{
                    window.sendErrorToRaygun("Failed starting cloud video rendering after capsule persistence. Error:" + lastRenderKickoffError, true);
                }catch(raygunError){
                    console.warn("Unable to report cloud video rendering kickoff failure", raygunError);
                }

                try{
                    Utils.getInstance().showWarningNotification(window.getI18n(ti18n, "VIDEO_RENDERING_COULD_NOT_BE_STARTED"));
                }catch(notificationError){
                    console.warn("Unable to show cloud video rendering kickoff warning", notificationError);
                }
            },

            updateCapsule : async function(){
                let savedProjectId = null;
                try{
                    this.view.showHideUploadingViewInCapsuleInfo(true);
                    let wasTranscribedAndEditedInTrebble = false;
                    let hqAudioInfo = null;
                    let videoInfo = null;
                    let capsuleUpdateResults = null;
                    const audioEditVersion = this._sequencerController ? this._sequencerController.getModel().getAudioEditVersion() : undefined;
                    savedProjectId = await this.saveSequencerProjectIfApplicable(this.capsuleInfoProgressBarController);
                    const projectId = savedProjectId || this.getProjectId();
                    if(this.view.isAudioWasTranscribedAndEdited() && !savedProjectId){
                        await this._rejectMissingSequencerProjectIdForEditedAudio();
                    }
                    if(SAVE_AUDIO_WAV_FILE_FROM_AUDIO_EDITOR){
                        hqAudioInfo  = await this.uploadHQRenderedEditedAudioIfApplicable(this.capsuleInfoProgressBarController);
                    }
                    if(window.chrome && !RENDER_VIDEO_ON_BACKEND){
                        //Only allow video rendering on chrome
                        videoInfo = await this.uploadVideoRenderedEditedIfApplicable(this.capsuleInfoProgressBarController);
                        window.alertSuccessMessage(window.getI18n("YOUR_VIDEO_IS_BEING_PROCESSED"),window.getI18n("WE_WILL_NOTIFY_WHEN_YOUR_VIDEO_IS_READY_TO_DOWNLOAD"));
                    }
                    const audioPartsInfo  = await this.uploadRecordingIfApplicable(this.capsuleInfoProgressBarController);
                    const audioInfo = audioPartsInfo && audioPartsInfo.length > 0? audioPartsInfo[0]: audioPartsInfo;
                    this.capsuleInfoProgressBarController.setIndeterminate(true);
                    this.capsuleInfoProgressBarController.setProgressMessage(this._createAShortcast?window.getI18n(ti18n,"SAVING_YOUR_SHORTCAST_INFO"): window.getI18n(ti18n,"SAVING_YOUR_CAPSULE_INFO"));
                    this.capsuleInfoProgressBarController.setProgressSubMessage("");
                    let title = this.view.getTitle();
                    const comment = this.view.getComment();
                    if(TREBBLE_TEXT_BASED_AUDIO_EDITOR && this.view.isAudioWasTranscribedAndEdited()){
                        wasTranscribedAndEditedInTrebble = true;
                    }
                    capsuleUpdateResults =  await PersistentModels.getInstance().updateSongCapsule(this._capsuleIdToEdit, audioPartsInfo, title,comment, null, this.context, this._receiverUserId,wasTranscribedAndEditedInTrebble, hqAudioInfo, projectId, videoInfo, audioInfo );
                    await this._updateRecordingDraftsForFileNames(this._getPendingRecordingFileNamesForDurableDrafts(), function(recordingId) {
                        return BrowserRecordingDraftStore.getInstance().markCompleted(recordingId);
                    }).catch(function(error) {
                        console.warn("Unable to mark the durable drafts as completed after capsule persistence", error);
                    });

                    if(RENDER_VIDEO_ON_BACKEND  && this.isEditedContentContainsVideo() && capsuleUpdateResults){
                        await this._startBackendVideoRenderingForSavedCapsule(capsuleUpdateResults.playableAudioUrl, this._capsuleIdToEdit, audioEditVersion);
                    }
                    this._hideAllWhatsACapsuleButtons();
                    if(this._onCapsuleSuccessfullyUpdated){
                        this._onCapsuleSuccessfullyUpdated(capsuleUpdateResults);
                    }
                    if(this._returnToDefaultAfterCreation){
                        PersistentModels.getInstance().getRouter().showMyLibraryPage(null, null, true).then((function(){
                            this.view.removePage();
                        }).bind(this));
                    }else{
                        this.view.navigateToPreviousPage().then((function(){
                            this.view.removePage();
                        }).bind(this));
                    }

                    if(window.trebbleAnalyticsHelper){
                        window.trebbleAnalyticsHelper.trackEvent("Capsule", "capsuleUpdated", "Capsule Updated", null, {"projectId": projectId, "capsuleId": this._capsuleIdToEdit, "hasVideo": this.isEditedContentContainsVideo()});
                        if(window.trebbleAnalyticsHelper.trebbleHelperTrackCapsuleUpdated){
                            window.trebbleAnalyticsHelper.trebbleHelperTrackCapsuleUpdated();
                        }
                    }
                    FacebookEventTrackingHelper.getInstance().trackCapsuleUpdated();
                    return capsuleUpdateResults;
                }catch(error){
                    console.error(error);
                    this.view.showHideUploadingViewInCapsuleInfo(false);
                    const isExpectedError = !!(error && (
                        (window.ExpectedError && error instanceof window.ExpectedError) ||
                        error.name === "ExpectedError" ||
                        error.isNetworkError === true
                    ));
                    // Use alertUserErrorMessage to avoid duplicate Rollbar reporting; sendErrorToRaygun below handles error tracking with better context
                    window.alertUserErrorMessage((typeof error === "string")? error : (isExpectedError && error.message ? error.message : window.getI18n(ti18n,"UPLOADING_FAILED")));
                    if(window.trebbleAnalyticsHelper){
                        const errorCategory = (typeof error === "string") ? "string_error" : (error && error.name) ? error.name : "unknown";
                        window.trebbleAnalyticsHelper.trackEvent("Capsule", "ShortcastUpdateFailed", "Shortcast Update Failed", null, {"projectId": savedProjectId || this.getProjectId(), "capsuleId": this._capsuleIdToEdit, "errorCategory": errorCategory});
                    }
                    try{
                        window.sendErrorToRaygun(isExpectedError ? error : "Failed updating capsule. Error:"+ error);
                    }catch(err){
                        console.error(err);
                    }
                }
            },

            /**
             * When the user picked (or inherited) a folder in the Create Content
             * save step, assign the newly created capsule into that folder via
             * the existing assignProjectFolderItem API. Fire-and-forget — we log
             * failures but never block the success flow on them.
             *
             * The `itemId` contract matches LibraryPage.handleMoveToFolder: we
             * prefer the capsule id, falling back to the project id.
             */
            _assignNewCapsuleToFolderIfApplicable : function(capsuleCreationResults){
                try {
                    if(!this.view || typeof this.view.getSelectedFolderId !== "function"){
                        return;
                    }
                    const selectedFolderId = this.view.getSelectedFolderId();
                    if(!selectedFolderId){
                        return; // User left "No folder" selected — nothing to do.
                    }
                    if(!capsuleCreationResults || !capsuleCreationResults.capsuleInfo){
                        return;
                    }
                    const capsuleId = capsuleCreationResults.capsuleUID
                        || capsuleCreationResults.capsuleInfo._id
                        || null;
                    const projectId = this.getProjectId ? this.getProjectId() : null;
                    const itemId = capsuleId || projectId;
                    if(!itemId){
                        return;
                    }
                    TrebbleClientAPIHelper.getInstance().assignProjectFolderItem({
                        itemId: itemId,
                        folderId: selectedFolderId,
                        workspaceId: this.getWorkspaceId(),
                    }).catch((err) => {
                        // Non-fatal — capsule was created successfully, only
                        // the folder assignment failed.
                        console.warn("Failed to assign new capsule to folder", err);
                    });
                } catch(err) {
                    console.warn("Unexpected error in folder assignment hook", err);
                }
            },

            getWorkspaceId : function(){
                return this._workspaceId;
            },

            saveCapsule : async function(){
                if(this._capsuleInfoToEdit){
                    return await this.updateCapsule();
                }
                // Track that the user initiated a manual save
                if(window.trebbleAnalyticsHelper){
                    window.trebbleAnalyticsHelper.trackEvent("Capsule", "ManualSaveInitiated", "Manual Save Initiated", null, {"projectId": this.getProjectId(), "hasVideo": this.isEditedContentContainsVideo()});
                }
                let isPrivate = false;
                let doNotAddOnAir = false;
                this.view.showHideUploadingViewInCapsuleInfo(true);
                let doNotTriggerAudioProcessing = false;
                let isCapsuleScheduled = false;
                let scheduleStartDate = null;
                let timezone = null;
                let lifeSpan = null;
                let wasTranscribedAndEditedInTrebble = false;
                let hqAudioInfo = null;
                let videoInfo = null;
                let capsuleCreationResults = null;
                let ffmpegParamsInfoArrayToRunOnServer = null;
                const audioEditVersion = this._sequencerController ? this._sequencerController.getModel().getAudioEditVersion() : undefined;
                let savedProjectId = null;
                try{
                    savedProjectId = await this.saveSequencerProjectIfApplicable(this.capsuleInfoProgressBarController);
                    const projectId = savedProjectId || this.getProjectId();
                    if(this.view.isAudioWasTranscribedAndEdited() && !savedProjectId){
                        await this._rejectMissingSequencerProjectIdForEditedAudio();
                    }
                    if(SAVE_AUDIO_WAV_FILE_FROM_AUDIO_EDITOR){
                        hqAudioInfo = await this.uploadHQRenderedEditedAudioIfApplicable(this.capsuleInfoProgressBarController);
                    }

                    if(window.chrome && !RENDER_VIDEO_ON_BACKEND){
                            //Only allow video rendering on chrome
                            videoInfo = await this.uploadVideoRenderedEditedIfApplicable(this.capsuleInfoProgressBarController);
                        }

                    const audioPartsInfo = await this.uploadRecordingIfApplicable(this.capsuleInfoProgressBarController)

                    this.capsuleInfoProgressBarController.setIndeterminate(true);
                    this.capsuleInfoProgressBarController.setProgressMessage(this._createAShortcast?window.getI18n(ti18n,"SAVING_YOUR_SHORTCAST_INFO"): window.getI18n(ti18n,"SAVING_YOUR_CAPSULE_INFO"));
                    this.capsuleInfoProgressBarController.setProgressSubMessage("");
                    lifeSpan = this.view.getLifeSpan();

                    if(!lifeSpan || lifeSpan == ""){
                        lifeSpan = null
                    }
                    const categoryId = this.view.getCategoryId();
                    const categoryLabel = this.view.getCategoryLabel();
                    const songJsonForBackend = Utils.getInstance().getSongJsonForBackendFromSongModel(this.getSongModelToPlayAfterCapsule());
                    let title = this.view.getTitle();
                    if(!title){
                        title = categoryLabel;
                    }
                    const comment = this.view.getComment();
                    doNotAddOnAir =  this.view.getDoNotAddOnAir();
                    isCapsuleScheduled = this.view.isScheduled();
                    scheduleStartDate =  isCapsuleScheduled ? this.view.getScheduleStartDate(): null;
                    timezone =  isCapsuleScheduled ? this.view.getTimezone():  Intl.DateTimeFormat().resolvedOptions().timeZone;
                    const language = this.getCapsuleLanguage();
                    isPrivate = this.view.isPrivate();
                    const backgroundMusicModel = this.backgroundSongSelectorInputController.getSelectedSongModel();
                    let backgroundMusicUri = backgroundMusicModel?backgroundMusicModel.get("uri"):this._backgroundTrackUrl;
                    if(!this.isInRecordMode() && !this._addBackgroundMusicToUploadedAudio){
                        backgroundMusicUri = null;
                    }

                    doNotTriggerAudioProcessing = false;
                    if(TREBBLE_TEXT_BASED_AUDIO_EDITOR && this.view.isAudioWasTranscribedAndEdited()){
                        backgroundMusicUri = null;
                        doNotTriggerAudioProcessing = true;
                        wasTranscribedAndEditedInTrebble = true;
                    }
                    const addToRadioWitIds = (!isPrivate && !this._receiverUserId)? PersistentModels.getInstance().getAllMyPersonalRadioIds(): null;
                    capsuleCreationResults = await PersistentModels.getInstance().createSongCapsule(this.getSongModelToPlayAfterCapsule(), this.capsuleId, audioPartsInfo,lifeSpan,title, comment,null,backgroundMusicUri, doNotTriggerAudioProcessing,categoryId, isPrivate, this.context, this._receiverUserId, doNotAddOnAir,isCapsuleScheduled , scheduleStartDate, timezone, language, this.isInTTSMode()?this.view.getTextToConvert(): null, null, this.isInTTSMode()?this.view.getTTSLanguage():null, this.getNarrationParams(), wasTranscribedAndEditedInTrebble, hqAudioInfo, projectId, videoInfo);

                    // Fire-and-forget folder assignment when the user picked a folder
                    // in the Create Content save step. We don't block success on this
                    // — the capsule has already been created.
                    this._assignNewCapsuleToFolderIfApplicable(capsuleCreationResults);
                    await this._updateRecordingDraftsForFileNames(this._getPendingRecordingFileNamesForDurableDrafts(), function(recordingId) {
                        return BrowserRecordingDraftStore.getInstance().markCompleted(recordingId);
                    }).catch(function(error) {
                        console.warn("Unable to mark the durable drafts as completed after capsule persistence", error);
                    });

                    if(RENDER_VIDEO_ON_BACKEND && this.isEditedContentContainsVideo() && capsuleCreationResults && capsuleCreationResults.capsuleInfo){
                        await this._startBackendVideoRenderingForSavedCapsule(capsuleCreationResults.capsuleInfo.playableAudioUrl, capsuleCreationResults.capsuleInfo._id, audioEditVersion);
                    }

                    this._hideAllWhatsACapsuleButtons();
                    if(this.getSongModelToPlayAfterCapsule()){
                        const songTitle = this.getSongModelToPlayAfterCapsule().get("title");
                        Utils.getInstance().showShortToastMessage(window.getI18n(ti18n,"CAPSULE_FOR")+" '"+songTitle+"' "+ window.getI18n(ti18n,"WAS_SUCCESSFULLY_UPLOADED"));
                    }


                    if(this._onCapsuleSuccessfullyCreated){
                        this._onCapsuleSuccessfullyCreated(capsuleCreationResults);
                    }
                    if(this._returnToDefaultAfterCreation){
                        PersistentModels.getInstance().getRouter().showMyLibraryPage(null, null, true).then((function(){
                            this.view.removePage();
                        }).bind(this));
                    }else{
                        this.view.navigateToPreviousPage().then((function(){
                            this.view.removePage();
                        }).bind(this));
                    }

                    let messageTitle = window.getI18n(ti18n,"CAPSULE_CREATED");

                    const detailMessage = window.getI18n(ti18n,"YOU_CAN_FIND_THE_CAPSULE_IN_LIBRARY");
                    if(isPrivate){
                        //detailMessage = window.getI18n(ti18n,"YOUR_CAPSULE_WILL_NOT_AIR_BUT_CAN_BE_SHARED");
                    }
                    if(this._receiverUserId){
                        messageTitle = window.getI18n(ti18n,"CAPSULE_SENT");
                        //detailMessage = window.getI18n(ti18n,"YOUR_CAPSULE_CAN_BE_FOUND_UNDER_ARCHIVED_TAB");
                    }
                    if(doNotAddOnAir){
                        //detailMessage = window.getI18n(ti18n,"YOU_CAN_FIND_THE_CAPSULE_UNDER_DRAFTS");
                    }
                    if(isCapsuleScheduled){
                        messageTitle = window.getI18n(ti18n,"CAPSULE_SCHEDULED");
                        //detailMessage = window.getI18n(ti18n,"YOU_CAN_FIND_THE_CAPSULE_UNDER_SCHEDULED");
                    }

                    if(REMEMBER_UPLOAD_SETTING_IN_CURRENT_SESSION){
                        if(!window._lastCapsuleUploadSettings){
                            window._lastCapsuleUploadSettings = {};
                        }
                        if(isCapsuleScheduled){
                            window._lastCapsuleUploadSettings.timezone = timezone;
                            window._lastCapsuleUploadSettings.capsuleLastScheduleDurationInCurrentSession = lifeSpan;
                            window._lastCapsuleUploadSettings.capsuleLastScheduleDateInCurrentSession = scheduleStartDate;
                        }
                    }
                    const onCapsuleCreatedPopupAcknowledged = null;
                    if(!this._createAShortcast){
                        if(!window._capsuleCreatedInThisSession && (messageTitle || detailMessage)){
                            window.alertSuccessMessage(messageTitle,detailMessage, onCapsuleCreatedPopupAcknowledged);
                        }
                    }
                    window._capsuleCreatedInThisSession = true;
                    if(!isPrivate && !window._capsuleCreatedAndProcessedInThisSession /*&& doNotTriggerAudioProcessing*/ && !this._receiverUserId){
                        window._capsuleCreatedAndProcessedInThisSession = true;
                        //onCapsuleCreatedPopupAcknowledged =  (function(){ setTimeout((function(){PersistentModels.getInstance().getRouter().showSuggestionPopupToShareTrebbleIfApplicable()}).bind(this), 300);}).bind(this);
                    }


                if(window.trebbleAnalyticsHelper){
                    const capsuleId = capsuleCreationResults && capsuleCreationResults.capsuleInfo ? capsuleCreationResults.capsuleInfo._id : null;
                    window.trebbleAnalyticsHelper.trackEvent("Capsule", "capsuleCreated", "Capsule Created", null, {"projectId": savedProjectId || this.getProjectId(), "capsuleId": capsuleId, "hasVideo": this.isEditedContentContainsVideo()});
                    if(window.trebbleAnalyticsHelper.trebbleHelperTrackCapsuleCreated){
                        window.trebbleAnalyticsHelper.trebbleHelperTrackCapsuleCreated();
                    }
                }
                // Track capsule/project creation for SaaS tracking
                try {
                    FacebookEventTrackingHelper.getInstance().trackCapsuleCreated();
                    FacebookEventTrackingHelper.getInstance().trackAdvancedFeatureUsed('editor_project_created');
                } catch(trackingError) {
                    console.warn('Tracking error (capsule/project creation):', trackingError);
                }
                return capsuleCreationResults;
            }catch(error){
                console.error(error);
                this.view.showHideUploadingViewInCapsuleInfo(false);
    //$.mobile.loading("hide");
                const isExpectedError = !!(error && (
                    (window.ExpectedError && error instanceof window.ExpectedError) ||
                    error.name === "ExpectedError" ||
                    error.isNetworkError === true
                ));
                // Use alertUserErrorMessage to avoid duplicate Rollbar reporting; sendErrorToRaygun below handles error tracking with better context
                window.alertUserErrorMessage((typeof error === "string")? error : (isExpectedError && error.message ? error.message : window.getI18n(ti18n,"UPLOADING_FAILED")));
                if(window.trebbleAnalyticsHelper){
                    const errorCategory = (typeof error === "string") ? "string_error" : (error && error.name) ? error.name : "unknown";
                    window.trebbleAnalyticsHelper.trackEvent("Capsule", "ShortcastCreationFailed", "Shortcast Creation Failed", null, {"projectId": savedProjectId || this.getProjectId(), "errorCategory": errorCategory});
                }
                try{
                    window.sendErrorToRaygun(isExpectedError ? error : "Failed creating capsule. Error:"+ error);
                }catch(err){
                    console.error(err);
                }
            }
        },

        _hideAllWhatsACapsuleButtons : function(){
            LocalStorageHelper.getInstance().setWhatsACapsuleCapsulePlayed();
$(document).find("#whatsacapsuleButton").hide(); //This is dirty but it is easy. This should be cleaned
},


initCapsuleUploadIfApplicable : function(){
this._uploadEementId = this.view.getUploadElementId();
this._nameOfFileToUpload =  "userCreatedCapsule_"+(new Date()).getTime()+".mp3";
let filedUploaded =  false;
if(false && !LocalStorageHelper.getInstance().isWhatsACapsuleCapsulePlayed() && !PersistentModels.getInstance().hasCapsuleCreated()){
    this.view.showWhatsACapsuleButton();
}else{
    this.view.hideWhatsACapsuleButton();
}

this._userUploadedCapsulePromise = new RSVP.Promise((function(userUploadedCapsulePromiseResolve, userUploadedCapsulePromiseReject){
    this._userUploadedCapsulePromiseResolve =  userUploadedCapsulePromiseResolve;
    this._userUploadedCapsulePromiseReject =  userUploadedCapsulePromiseReject;

}).bind(this));

this._dropzonePromiseResolve = (function(result){
        //this will only be call if the upload was successfull
    this._processQueueStarted = false;
    this._userUploadedCapsulePromiseResolve(result)
}).bind(this);
this._dropzonePromiseReject = (function(error){
    if(this._processQueueStarted){
        this._processQueueStarted = false;
        this._userUploadedCapsulePromiseReject(error)
    }else{
        if(this._signatureValidationStarted){
            this._signatureValidationStarted = false;
            this._userUploadedCapsulePromiseReject(error)
        }else{
                //User didn't start uploading the file so do not propaggate the error as this promise is meant to fail only if the upload process started
        }
    }
}).bind(this);
const onFileAccepted = (function(fileAdded, done){
    if(fileAdded){
        this._clearLegacyTranscriptionSource();
        filedUploaded = true;
            //if(this._capsuleUploadDropzoneObj.getAcceptedFiles().length == 1){
        if(fileAdded){
                    const file = fileAdded;//this._capsuleUploadDropzoneObj.getAcceptedFiles()[0];
                    return Utils.getInstance().getMediaMetadata(file, true).then((async function(mediaMetadata){
                        if(mediaMetadata && mediaMetadata.isVideo && TREBBLE_TEXT_BASED_AUDIO_EDITOR && !this._recordOnly){
                            try {
                                await this._validateMediaHasAudioForTranscription(file);
                            } catch(error) {
                                // Warn immediately, but allow saving without text editing.
                                // The transcription action enforces this check before upload.
                                window.alertErrorMessage(error);
                            }
                        }
                        const duration = mediaMetadata && mediaMetadata.duration ? mediaMetadata.duration : null;
                        console.log("file name",file.name);
                        console.log("file type",file.type);
                        console.log("file duration",duration);
                        if(window.trebbleAnalyticsHelper){
                            window.trebbleAnalyticsHelper.trackEvent("Capsule", "fileNameForShortcastCreation", "Name of the audio file uploaded for shortcast creation", file.name);
                            window.trebbleAnalyticsHelper.trackEvent("Capsule", "fileTypeForShortcastCreation", "Type of the audio file uploaded for shortcast creation", file.type);
                            window.trebbleAnalyticsHelper.trackEvent("Capsule", "fileDurationForShortcastCreation", "Duration of the audio file uploaded for shortcast creation", duration);
                        }
                        let capsuleMaxDuration = LocalStorageHelper.getInstance().getCustomMaxCapsuleLimitInSeconds() ?  LocalStorageHelper.getInstance().getCustomMaxCapsuleLimitInSeconds() : 5400; //1h30
                        if(LocalStorageHelper.getInstance().getCustomMaxCapsuleLimitInSecondsOnUpload && LocalStorageHelper.getInstance().getCustomMaxCapsuleLimitInSecondsOnUpload()){
                            capsuleMaxDuration =   LocalStorageHelper.getInstance().getCustomMaxCapsuleLimitInSecondsOnUpload();
                        }
                        capsuleMaxDuration = 5400; //1h30min
                        if(mediaMetadata && mediaMetadata.isVideo){
                            capsuleMaxDuration = 60 * 90 //1h30min
                        }
                        if(!duration || duration > capsuleMaxDuration){
                            const validationError = window.getI18n(ti18n,"UPLOADED_FILE_IS_LONGER_THAN")+" "+ Math.round(capsuleMaxDuration/60) +" "+window.getI18n(ti18n,"MINUTES");
                            this.view.setUploadedFileAdded(false);
                            //window.alertErrorMessage(validationError);
                            if(done){
                                done(validationError);
                            }
                        }else{
                            this.view.setUploadedFileAdded(true);
                            if(done){
                                done();
                            }
                        }
                    }).bind(this)).catch((function(error){
                        console.error("Audio loading failed:", error);
                        const errorMessage = this._getInvalidUploadedFileErrorMessage(fileAdded);
                        window.alertUserErrorMessage(errorMessage);
                        this.view.setUploadedFileAdded(false); // Disable Next button

                        if(done){
                            done(errorMessage); // Properly handle dropzone state
                        }
                    }).bind(this))
                }
                //this.view.setUploadedFileAdded(true);
            }

        }).bind(this);
this._capsuleUploadDropzoneObj =  FileUploadHelper.getInstance().uploadCapsuleInWebBrowser(this._nameOfFileToUpload,"#"+ this._uploadEementId,this._dropzonePromiseResolve,this._dropzonePromiseReject, onFileAccepted);
if(!this._capsuleUploadDropzoneObj){
    window.alertUserErrorMessage(window.getI18n(ti18n, "UPLOADING_FAILED"));
    return;
}
//this._capsuleUploadDropzoneObj.on("addedfile", onFileAccepted);
this._capsuleUploadDropzoneObj.on("removedfile", (function(fileRemoved){
    filedUploaded = false;
    this.resetTranscriptionAndAudioEdits();
    if(this._capsuleUploadDropzoneObj.getAcceptedFiles().length == 1){
        this.view.setUploadedFileAdded(true);
    }else{
        this.view.setUploadedFileAdded(false);
    }

}).bind(this));

this._capsuleUploadDropzoneObj.on("error", (function(file, error){
    window.alertUserErrorMessage(error);
    this.view.setUploadedFileAdded(false);
}).bind(this));

this._capsuleUploadDropzoneObj.on("maxfilesexceeded", (function(file){
    const errorMessage = window.getI18n(ti18n, "ONLY_ONE_FILE_ALLOWED_FOR_UPLOAD");
    window.alertUserErrorMessage(errorMessage);
    this.view.setUploadedFileAdded(false);
}).bind(this));

this._capsuleUploadDropzoneObj.on("addedfiles", (function(files){
    if (files && files.length > 1) {
        // Remove all files when multiple are dropped via drag & drop
        for (let i = files.length - 1; i >= 0; i--) {
            this._capsuleUploadDropzoneObj.removeFile(files[i]);
        }

        // Show clear message explaining why files were rejected
        const errorMessage = window.getI18n(ti18n, "ONLY_ONE_FILE_ALLOWED_FOR_UPLOAD");
        window.alertUserErrorMessage(errorMessage);
        this.view.setUploadedFileAdded(false); // Disable Next button
    }
}).bind(this));

},
setRecordMode : function(){
this._creationMode = CREATION_MODE.FROM_RECORDING;
this.refreshVideoPreviewIfApplicable();
this.showOnboardingIfApplicable();
},

setFileUploadMode : function(){
this._creationMode = CREATION_MODE.FROM_FILE;
this.stopVideoPreviewIfApplicable();
this.showOnboardingIfApplicable();
},

setFromTextMode : function(){
this._creationMode = CREATION_MODE.FROM_TEXT;
this.stopVideoPreviewIfApplicable();
},

setFromVoiceActor : function(){
this._creationMode = CREATION_MODE.FROM_VOICE_ACTOR;
this.stopVideoPreviewIfApplicable();
},

isInRecordMode :function(){
return this._creationMode == CREATION_MODE.FROM_RECORDING;
},

isInUploadMode :function(){
return this._creationMode == CREATION_MODE.FROM_FILE;
},

isInTTSMode :function(){
return this._creationMode == CREATION_MODE.FROM_TEXT;
},

isInVoiceActorMode :function(){
return this._creationMode == CREATION_MODE.FROM_VOICE_ACTOR;
},

_onCreationModeSelectionChanged : function(modeSelectedModel){
if(modeSelectedModel){
    this.view.setCreationMode(modeSelectedModel.getId());

    this.showSelectedCreationMode(modeSelectedModel);
    if(this.creationModeSelectorController){
        this.creationModeSelectorController.setSelected(modeSelectedModel, true, true);
    }
}
},

shouldOnboardingBeDisplayed: function(){
    return RECORD_PAGE_ONBOARDING && !window.isMobileBrowser && (PersistentModels.getInstance().getRouter().didSignUpOccuredInCurrentSession() ||  !LocalStorageHelper.getInstance().isRecordPageOnboardingWasCompletedOrDismissed());
  },

  showOnboardingIfApplicable: function(){
    if(this.shouldOnboardingBeDisplayed() && this.view){
        this.view.showRecordPageOnboardingInstruction();
    }
  },

  onRecordPageOnboardingTourCompleted: function () {
    LocalStorageHelper.getInstance().setRecordPageOnboardingWasCompletedOrDismissed();
  },

  onRecordPageOnboardingTourCancelled: function () {
    LocalStorageHelper.getInstance().setRecordPageOnboardingWasCompletedOrDismissed();
  },

  onSaveOrEditPageOnboardingTourCompleted: function () {
    LocalStorageHelper.getInstance().setSaveOrEditPageOnboardingWasCompletedOrDismissed();
  },

  onSaveOrEditPageOnboardingTourCancelled: function () {
    LocalStorageHelper.getInstance().setSaveOrEditPageOnboardingWasCompletedOrDismissed();
  },



showAndPlayWhatsACapsuleCapsule: function(){
PersistentModels.getInstance().getRouter().showAndPlayWhatACapusleCapsule().then((function(capsuleDetailsPopupController){
    capsuleDetailsPopupController.playCapsule();
    this.listenTo(capsuleDetailsPopupController,"finishPlaying", (function(){
        LocalStorageHelper.getInstance().setWhatsACapsuleCapsulePlayed();
    }).bind(this))
}).bind(this));
},

getCapsuleLanguage : function(){
const trebbleDefauftLanguages = PersistentModels.getInstance().getAllMyPersonalRadioLanguages();
const trebbleDefaultLanguage  = trebbleDefauftLanguages && trebbleDefauftLanguages.length> 0? trebbleDefauftLanguages[0]: "en";
return trebbleDefaultLanguage;
},

onBackgroundTrackChanged : function(backgroundTrackUrl){
this._backgroundTrackUrl =  backgroundTrackUrl;
if(!CONFIGURE_BACKGROUND_MUSIC || this.view.isPlaying()){
    if(this._filenameArray && this._filenameArray.length > 0 && !AudioRecorderHelper.getInstance().isRecording()){
        const exitingBackgroundChangePromise =  this._backgroundTrackChangeInProgressPromise? this._backgroundTrackChangeInProgressPromise: RSVP.Promise.resolve();
        const  p  = exitingBackgroundChangePromise.then((function(){
            return this.stopPlayingRecordings();
        }).bind(this)).then((function(){
            this.playRecordings();
            this._backgroundTrackChangeInProgressPromise = null;
        }).bind(this));
        this._backgroundTrackChangeInProgressPromise = p;
        return this._backgroundTrackChangeInProgressPromise;
    }
}
},

onViewRemoved:function(){
	if(this._pageTeardownStarted){
		return;
	}
this._pageTeardownStarted = true;

if(this._setupForTranscriptionTimer){
    clearTimeout(this._setupForTranscriptionTimer);
    this._setupForTranscriptionTimer = null;
}
if(this._showOnboardingTimer){
    clearTimeout(this._showOnboardingTimer);
    this._showOnboardingTimer = null;
}
this._clearRecoveredTranscriptionPolling();
this.stopListening();
const recorderRuntimeTeardownPromise = this._waitForPendingRecordingVisualSourceSwitch().catch(function(error){
    console.warn("Unable to wait for the active recording source switch before tearing down the recorder page", error);
    return null;
}).then((function(){
    const stopActiveRecordingPromise = AudioRecorderHelper.getInstance().isRecording() ? AudioRecorderHelper.getInstance().stopRecording(this._fileNameOfCurrentRecording).catch(function(stopRecordingError){
        console.warn("Unable to gracefully stop the active browser recording while removing the recorder page", stopRecordingError);
        return null;
    }) : RSVP.Promise.resolve();

    return stopActiveRecordingPromise.then((function(){
        return this.stopPlayingRecordings().catch(function(stopPlaybackError){
            console.warn("Unable to stop the recorder playback while tearing down the recorder page", stopPlaybackError);
            return null;
        });
    }).bind(this)).then((function(){
        return this.stopVideoPreviewIfApplicable().catch(function(stopPreviewError){
            console.warn("Unable to stop the recorder preview while tearing down the recorder page", stopPreviewError);
            return null;
        });
    }).bind(this)).then((function(){
        AudioRecorderHelper.getInstance().deleteAllBackgroundMusicDownloadedLocally();
        return AudioRecorderHelper.getInstance().releaseAllRecordings().catch(function(releaseError){
            console.warn("Unable to release the recorder runtime state without deleting the durable drafts", releaseError);
            return null;
        });
    }).bind(this));
}).bind(this)).catch(function(releaseError){
    console.warn("Unable to fully release recorder runtime state while removing the recorder page", releaseError);
    return null;
});
const sequencerTeardownPromise = this._destroySequencerNodeController().catch(function(error){
    console.warn("Unable to destroy the sequencer controller while removing the recorder page", error);
    return null;
});
RSVP.Promise.all([recorderRuntimeTeardownPromise, sequencerTeardownPromise]).then((function(){
    if(this._onCapsuleCreationPageClosed){
        this._onCapsuleCreationPageClosed();
    }
}).bind(this)).catch(function(error){
    console.warn("Error during page teardown finalization", error);
});
},

showRecordingSettings : function(){
PersistentModels.getInstance().getRouter().showRecordingSettingsPopup({
    recordingMediaType: this.getRecordingMediaType(),
    onPopupClose: (function(){
        if(this.view && this.view.refreshInlineRecordingDeviceSelectors){
            this.view.refreshInlineRecordingDeviceSelectors();
        }
        this.refreshVideoPreviewIfApplicable(true);
    }).bind(this)
});
},

addUploadedAudioRecordingToUserLibrary : function(){
	return new RSVP.Promise((function(resolve, reject){
		const uploadedMediaParts = this._uploadedAudioPartInfoForTranscriptionAndEditing || [];
		const audioUriToTrebbleAudio = Object.assign({}, this._audioUriToTrebbleAudio || {});
		const workspaceId = typeof this.getWorkspaceId === "function" ? this.getWorkspaceId() : undefined;

    if(uploadedMediaParts.length === 0){
        resolve(audioUriToTrebbleAudio);
        return;
    }

    const registerMediaPartRecursive = (function(index){
        if(index >= uploadedMediaParts.length){
            resolve(audioUriToTrebbleAudio);
            return;
        }

        const mediaPartInfo = uploadedMediaParts[index];
        if(!mediaPartInfo || !mediaPartInfo.uri){
            registerMediaPartRecursive(index + 1);
            return;
        }

        if(audioUriToTrebbleAudio[mediaPartInfo.uri]){
            registerMediaPartRecursive(index + 1);
            return;
        }

        const registerUploadedMediaPromise = mediaPartInfo.metadata ? RSVP.Promise.resolve(mediaPartInfo.metadata) : Utils.getInstance().getMediaMetadata(mediaPartInfo.uri).catch(function(){
            return {
                duration: mediaPartInfo.duration ? mediaPartInfo.duration / 1000 : null,
                isVideo: !!mediaPartInfo.isVideo,
                width: mediaPartInfo.width,
                height: mediaPartInfo.height,
                thumbnail: mediaPartInfo.thumbnail,
                thumbnailWidth: mediaPartInfo.thumbnailWidth,
                thumbnailHeight: mediaPartInfo.thumbnailHeight
            };
        });

        registerUploadedMediaPromise.then((function(mediaMetadata){
            const uploadAudioInfo = Object.assign({}, mediaPartInfo);
            const mediaName = mediaPartInfo.originalFilename || mediaPartInfo.fileName || mediaPartInfo.uri.split("/").pop();
            const normalizedMetadata = Object.assign({}, mediaMetadata || {}, {
                isVideo: !!(mediaPartInfo.isVideo || (mediaMetadata && mediaMetadata.isVideo))
            });

            if(uploadAudioInfo.duration && !normalizedMetadata.duration){
                normalizedMetadata.duration = uploadAudioInfo.duration / 1000;
            }

			if(normalizedMetadata.isVideo){
				return TrebbleClientAPIHelper.getInstance().addUploadedMediaToUserLibrary(mediaName, mediaPartInfo.uri, uploadAudioInfo, true, normalizedMetadata, workspaceId);
			}
			return TrebbleClientAPIHelper.getInstance().addUploadedAudioRecordingToUserLibrary(mediaName, mediaPartInfo.uri, uploadAudioInfo, mediaPartInfo.originalFilename || mediaName, workspaceId);
        }).bind(this)).then((function(registeredMedia){
            if(registeredMedia){
                audioUriToTrebbleAudio[mediaPartInfo.uri] = registeredMedia;
            }

            const fileName = this._getDurableDraftFileNameFromMediaPart(mediaPartInfo, index);
            if(!registeredMedia || !fileName){
                registerMediaPartRecursive(index + 1);
                return;
            }

            this._updateRecordingDraftsForFileNames([fileName], function(recordingId) {
                return BrowserRecordingDraftStore.getInstance().markRegistrationCompleted(recordingId, registeredMedia);
            }).catch(function(error) {
                console.warn("Unable to persist the durable draft registration checkpoint", error);
                return null;
            }).then((function(){
                registerMediaPartRecursive(index + 1);
            }).bind(this)).catch(reject);
        }).bind(this)).catch(reject);
    }).bind(this);

		registerMediaPartRecursive(0);
	}).bind(this));
},

isTransciptionProcessFast :function(){
const FAST_LANGUAGE_TRANSCRIBED = ["no","pl", "uk"];
if(this.view.getLanguageUsedInAudio()){
    return FAST_LANGUAGE_TRANSCRIBED.indexOf(this.view.getLanguageUsedInAudio()) != -1;
}
return false;
},

startTranscriptionOfUploadedAudioRecording : function(){
	return new RSVP.Promise((function(resolve, reject){
		(async function(){
		const workspaceId = typeof this.getWorkspaceId === "function" ? this.getWorkspaceId() : undefined;
    const activeWorkspaceId = typeof LocalStorageHelper !== "undefined" && LocalStorageHelper.getInstance ? LocalStorageHelper.getInstance().getCurrentWorkspaceId() : null;
    // Only pre-check quota when the page has an explicit workspace scope and
    // it still matches the user's live workspace selection. The backend
    // transcription start path still resolves some unlinked recordings from the
    // current workspace context, so a stale pinned workspace would show the
    // wrong frontend result here.
    if(workspaceId != null && activeWorkspaceId && workspaceId === activeWorkspaceId){
        try {
            const usage = await TrebbleClientAPIHelper.getInstance().getWorkspaceUsage({ workspaceId: activeWorkspaceId });
            if(usage && typeof usage.hoursUsed === "number" && typeof usage.hoursTotal === "number"){
                if(usage.hoursUsed >= usage.hoursTotal){
                    const detailTemplate = window.getI18n(ti18n, "WORKSPACE_TRANSCRIPTION_LIMIT_REACHED_DETAIL") || "Your workspace has used {hoursUsed} out of {hoursTotal} transcription hours this month. Please ask your workspace owner to upgrade the plan for more hours.";
                    const detail = detailTemplate
                        .replace("{hoursUsed}", String(usage.hoursUsed))
                        .replace("{hoursTotal}", String(usage.hoursTotal));
                    window.alertErrorMessage(
                        window.getI18n(ti18n, "WORKSPACE_TRANSCRIPTION_LIMIT_REACHED") || "Transcription limit reached",
                        detail
                    );
                    // Reject with a dedicated error code so the upstream
                    // transcribeAndEditAudio() handler can short-circuit
                    // without surfacing a second generic alert.
                    const quotaError = new Error(window.getI18n(ti18n, "WORKSPACE_TRANSCRIPTION_LIMIT_REACHED") || "Transcription limit reached");
                    quotaError.code = "workspace_transcription_limit_reached";
                    reject(quotaError);
                    return;
                }
            }
        } catch(error){
            console.error("Failed to check workspace transcription quota:", error);
            // Allow transcription if quota check fails — backend will enforce
		}
	}
	const uploadedMediaParts = this._uploadedAudioPartInfoForTranscriptionAndEditing || [];
	const trebbleAudioArray = [];
    const transcriptionStartFileNames = [];
    if(uploadedMediaParts.length > 0){
        uploadedMediaParts.forEach((function(mediaPartInfo){
            if(!mediaPartInfo || !mediaPartInfo.uri){
                return;
            }

            const trebbleAudioJson = this._audioUriToTrebbleAudio ? this._audioUriToTrebbleAudio[mediaPartInfo.uri] : null;
            if(!trebbleAudioJson){
                return;
            }

            const trebbleAudioOrVideoModel = trebbleAudioJson.isVideo?  new TrebbleVideo(trebbleAudioJson):  new TrebbleAudio(trebbleAudioJson);
            trebbleAudioArray.push(trebbleAudioOrVideoModel);
            transcriptionStartFileNames.push(this._getDurableDraftFileNameFromMediaPart(mediaPartInfo));
        }).bind(this));
    }else{
        for(let audioUri in this._audioUriToTrebbleAudio){
            const trebbleAudioJson = this._audioUriToTrebbleAudio[audioUri];
            if(!trebbleAudioJson){
                continue;
            }

            const trebbleAudioOrVideoModel = trebbleAudioJson.isVideo?  new TrebbleVideo(trebbleAudioJson):  new TrebbleAudio(trebbleAudioJson);
            trebbleAudioArray.push(trebbleAudioOrVideoModel);
            transcriptionStartFileNames.push(null);
        }
    }

    if(trebbleAudioArray.length === 0){
        reject(window.getI18n(ti18n, "TRANSCRIPTION_FAILED"));
        return;
    }

    const onTranscriptionCompleted = (function(results){
        if(results){
            this._lastTranscriptionResults = results;
            resolve(this._areAllTranscriptionStatusCompleted(results));
        }else{
            reject(window.getI18n(ti18n, "TRANSCRIPTION_FAILED"));
        }
    }).bind(this)

    const  onTranscriptionFailedStartingBecuaseNotEnoughMinutes = function(quotaError){
        reject(quotaError || window.getI18n(ti18n, "YOU_DONT_HAVE_ENOUGH_MINUTES_TO_EXECUTE_THIS_TRANSCRIPTION"))
    };
    const onTranscriptionFailedStartingForOtherReason = function(error){
        reject(error);
    }
    TranscriptionManager.getInstance().startBulklTranscription(trebbleAudioArray, onTranscriptionCompleted, this.view.getLanguageUsedInAudio(), onTranscriptionFailedStartingBecuaseNotEnoughMinutes, onTranscriptionFailedStartingForOtherReason).then((function(transcriptionStartResults){
        const successfulTranscriptionStarts = [];

        (transcriptionStartResults || []).forEach((function(operationResult, index){
            if(!operationResult || !operationResult.transcriptionWasSuccessfull || !operationResult.transcriptionId){
                return;
            }

            const fileName = transcriptionStartFileNames[index] || null;
            if(fileName){
                successfulTranscriptionStarts.push({
                    fileName: fileName,
                    operationResult: operationResult
                });
            }
        }).bind(this));

        return this._updateRecordingDraftsForFileNames(successfulTranscriptionStarts.map(function(transcriptionStartInfo) {
            return transcriptionStartInfo.fileName;
        }), function(recordingId, currentDraftManifest, fileName) {
            const matchingTranscriptionStartInfo = successfulTranscriptionStarts.find(function(transcriptionStartInfo) {
                return transcriptionStartInfo.fileName === fileName;
            });

            if(!matchingTranscriptionStartInfo){
                return currentDraftManifest;
            }

            return BrowserRecordingDraftStore.getInstance().markTranscriptionStarted(recordingId, matchingTranscriptionStartInfo.operationResult);
        }).catch(function(error) {
            console.warn("Unable to persist the durable draft transcription-start checkpoint", error);
            return null;
        });
}).bind(this)).catch(reject);
		}).bind(this)().catch(reject);
}).bind(this));
},

_areAllTranscriptionStatusCompleted : function(results){
for(let i = 0; i < results.length; i++){
    const r  = results[i];
    if(r.status != Utils.getInstance().getTrebbleJobStatus().COMPLETED){
        return false;
    }
}
return true;
},

_destroySequencerNodeController : async function(){
const sequencerController = this._sequencerController;
if(sequencerController){
    this._sequencerController =  null;
    this._lastRenderWavFileBlob = null;
    this.stopListening(sequencerController);
    this.stopListening(sequencerController.getModel())
    if(sequencerController.getView() && sequencerController.getView().$el){
        sequencerController.getView().$el.remove();
    }
    try{
        await sequencerController.stopPlaybackIfApplicable();
        await sequencerController.clearSequencer(true);
    }finally{
        await sequencerController.closeAudioContext();
    }
}
},

_onSequencerProjectIdChange : function(projectId){
if(projectId){
    if(this._projectRouteType === PROJECT_ROUTE_TYPE.SHARED){
        PersistentModels.getInstance().getRouter().updateWindowLocationWithSharedProjectId(projectId);
    }else if(this._projectRouteType === PROJECT_ROUTE_TYPE.EDIT){
        PersistentModels.getInstance().getRouter().updateWindowLocationWithEditedProjectId(projectId);
    }else if(this._projectRouteType === PROJECT_ROUTE_TYPE.DUPLICATE && this._createFromProjectId){
        this._projectRouteType = PROJECT_ROUTE_TYPE.EDIT;
        this._createFromProjectId = null;
        this._editProjectId = projectId;
        PersistentModels.getInstance().getRouter().updateWindowLocationWithEditedProjectId(projectId);
    }else{
        PersistentModels.getInstance().getRouter().updateWindowLocationWithNewProjectId(projectId);
    }
}
},

_onSequencerMutationAccessChange : function(){
if(this.view){
    this.view.setSaveAccess(this.canSaveProjectChanges());
}
},

_isCurrentSequencerController : function(sequencerController){
return !!sequencerController && this._sequencerController === sequencerController;
},

_focusTurboEditorCommentIfRequested : async function(sequencerController){
    if(!this._turboEditorCommentId || !sequencerController || typeof sequencerController.focusTurboEditorCommentById !== "function"){
        return null;
    }
    const turboEditorCommentId = this._turboEditorCommentId;
    const turboEditorCommentMessageId = this._turboEditorCommentMessageId;
    this._turboEditorCommentId = null;
    this._turboEditorCommentMessageId = null;
    try{
        return await sequencerController.focusTurboEditorCommentById(turboEditorCommentId, turboEditorCommentMessageId);
    }catch(error){
        console.warn("Failed to focus Turbo Editor comment from link:", error);
        return null;
}
},

initialiazedAudioEditorWithLatestTranscriptions : async function(audioFileUrl, transcriptionFileLocation, transcriptionId, isVideo){
await this._destroySequencerNodeController();
const sequencerController = new SequencerController({
    projectAccessLevel: this._projectAccessLevel,
    workspaceReadOnly: this._workspaceReadOnly,
    workspaceId: this.getWorkspaceId()
});
this._sequencerController =  sequencerController;
if(window.trebbleAnalyticsHelper){
    window.trebbleAnalyticsHelper.trackEvent("audioEditor", "Initialize Audio Editor", "Initialize Audio Editor");
}
this.listenTo(sequencerController.getModel(), "projectIdChange",this._onSequencerProjectIdChange.bind(this));
this.listenTo(sequencerController, "mutationAccessChange", this._onSequencerMutationAccessChange.bind(this));
this.view.setContentLoading(false);
this.view.showHideUploadingViewInAudioEditor(true);
this.audioEditorProgressBarController.setIndeterminate(true);
this.audioEditorProgressBarController.setProgressMessage(window.getI18n(ti18n,"INITIALIZING_EDITOR"));
try{
    const initSequencerControllerPromise = (audioFileUrl && transcriptionFileLocation)
        ? this._initSequencerControllerWithTranscriptionInfo(audioFileUrl, transcriptionFileLocation, transcriptionId, isVideo, null, sequencerController)
        : this._addLatestTranscriptionsToAudioEditor(0, sequencerController);
    await initSequencerControllerPromise;
    if(this._isCurrentSequencerController(sequencerController)){
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("audioEditor", "Transcription Added To Audio Editor", "Transcription Added To Audio Editor");
        }
        await sequencerController.buildModelAndRenderView();
    }
    if(this._isCurrentSequencerController(sequencerController)){
        //this._sequencerController.setHeightMargin(170);
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("audioEditor", "Audio Editor Built And Rendered", "Audio Editor Built And Rendered");
        }
        sequencerController.setJqueryPageElWhereSequencerWillBeAdded(this.view.$el);
        sequencerController.setHeightMargin(10);
        this.view.setContentLoading(false);
        this.view.showHideUploadingViewInAudioEditor(false);
        const setAudioEditorViewResult = await this.view.setAudioEditorView(sequencerController.getView());
        await this._focusTurboEditorCommentIfRequested(sequencerController);
        return setAudioEditorViewResult;
    }
}catch(error){
    if(!this._isCurrentSequencerController(sequencerController)){
        return;
    }
    await this._destroySequencerNodeController();
    throw error;
}
},

initialiazedAudioEditor : async function(sequencerControllerInitializationFunction){
await this._destroySequencerNodeController();
const sequencerController = new SequencerController({
    projectAccessLevel: this._projectAccessLevel,
    workspaceReadOnly: this._workspaceReadOnly,
    workspaceId: this.getWorkspaceId()
});
this._sequencerController =  sequencerController;
if(window.trebbleAnalyticsHelper){
    window.trebbleAnalyticsHelper.trackEvent("audioEditor", "Initialize Audio Editor", "Initialize Audio Editor");
}
this.listenTo(sequencerController.getModel(), "projectIdChange",this._onSequencerProjectIdChange.bind(this));
this.listenTo(sequencerController, "mutationAccessChange", this._onSequencerMutationAccessChange.bind(this));
this.view.setContentLoading(true);
try{
    const initSequencerControllerPromise = sequencerControllerInitializationFunction(sequencerController);
    await initSequencerControllerPromise;
    if(this._isCurrentSequencerController(sequencerController)){
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("audioEditor", "Transcription Added To Audio Editor", "Transcription Added To Audio Editor");
        }
        await sequencerController.buildModelAndRenderView();
    }
    if(this._isCurrentSequencerController(sequencerController)){
        this.view.showHideUploadingViewInAudioEditor(false); //hide loading progress
        //this._sequencerController.setHeightMargin(170);
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("audioEditor", "Audio Editor Built And Rendered", "Audio Editor Built And Rendered");
        }
        sequencerController.setJqueryPageElWhereSequencerWillBeAdded(this.view.$el);
        sequencerController.setHeightMargin(10);
        this.view.setContentLoading(false);
        if(this._editSuggestionRequestId){
            sequencerController.displayAIEditSuggestionsByRequestId(this._editSuggestionRequestId);
        }
        const setAudioEditorViewResult = await this.view.setAudioEditorView(sequencerController.getView());
        await this._focusTurboEditorCommentIfRequested(sequencerController);
        return setAudioEditorViewResult;
    }
}catch(error){
    if(!this._isCurrentSequencerController(sequencerController)){
        return;
    }
    await this._destroySequencerNodeController();
    throw error;
}
},


_addLatestTranscriptionsToAudioEditor : function(startIndex, sequencerController){
const currentSequencerController = sequencerController? sequencerController : this._sequencerController;
if(this._isCurrentSequencerController(currentSequencerController) && this._lastTranscriptionResults && this._lastTranscriptionResults.length > startIndex){
    const r = this._lastTranscriptionResults[startIndex];
    const transcriptionId = r.transcriptionId;
    const trebbleAudio = r.trebbleAudio;
    const status = r.status;
    const isVideo = r.isVideo;
    const transcriptionFileLocation = r.transcriptionFileLocation;
    return this._initSequencerControllerWithTranscriptionInfo(trebbleAudio.getAudioUrl(), transcriptionFileLocation, transcriptionId, isVideo, null, currentSequencerController).then((function(){
        return this._addLatestTranscriptionsToAudioEditor(startIndex + 1, currentSequencerController);
    }).bind(this));
}
},

_initSequencerControllerWithTranscriptionInfo: async function(audioFileUrl, transcriptionFileLocation, transcriptionId, isVideo, languageCode, sequencerController){
    const currentSequencerController = sequencerController? sequencerController : this._sequencerController;
    if(!this._isCurrentSequencerController(currentSequencerController)){
        return;
    }
    let videoWidth = null;
    let videoHeight = null;
    if(isVideo){
        await this._validateMediaHasAudioForTranscription(audioFileUrl);
        const videoMetadata =  await Utils.getInstance().getVideoMetadata(audioFileUrl);
        if(videoMetadata){
            videoWidth = videoMetadata.width;
            videoHeight = videoMetadata.height;
        }
    }
    if(!this._isCurrentSequencerController(currentSequencerController)){
        return;
    }
    return  currentSequencerController.addTranscribeAudio(audioFileUrl, transcriptionFileLocation, transcriptionId, null, isVideo, this.getOnEditorLoadingProgressReported(), languageCode, videoWidth, videoHeight);
},

_isEncodingError : function(error){
    if(!error){
        return false;
    }
    const errorMessage = error && error.message ? error.message : String(error || "");
    if(error.name === 'EncodingError'){
        return typeof DOMException === 'undefined'
            || error instanceof DOMException
            || /unable to decode audio data/i.test(errorMessage);
    }
    return /unable to decode audio data/i.test(errorMessage);
},

_getExpectedAudioLoadingError : function(error){
    if(!error){
        return null;
    }
    if(error instanceof ExpectedError || error.name === "ExpectedError" || error.expectedErrorCategory || error.isNetworkError === true){
        return error;
    }

    const errorMessage = error && error.message ? error.message : String(error || "");
    let errorMessageKey = null;
    if(error.name === "NotReadableError" || /requested file could not be read/i.test(errorMessage)){
        errorMessageKey = "AUDIO_FILE_ACCESS_LOST";
    }else if(/audio file is no longer available/i.test(errorMessage)){
        errorMessageKey = "AUDIO_FILE_NO_LONGER_AVAILABLE";
    }
    if(!errorMessageKey){
        return null;
    }

    return new ExpectedError(
        window.getI18n(ti18n, errorMessageKey),
        {
            i18nKey: errorMessageKey,
            classification: EXPECTED_ERROR_CLASSIFICATION.USER_CONTENT,
            errorCode: errorMessageKey,
            expectedErrorCategory: EXPECTED_ERROR_CATEGORY.MEDIA_FILE_UNAVAILABLE,
            watchInAnalytics: true,
            source: EXPECTED_ERROR_SOURCE.TRANSCRIBE_AND_EDIT_AUDIO,
        }
    );
},

_getAudioLoadingErrorMessageKey : function(error){
    const isEncodingError = this._isEncodingError(error);
    if(!isEncodingError){
        return "SOMETHING_WENT_WRONG_WHILE_TRANSCRIBING";
    }
    const LARGE_FILE_BYTES = 50 * 1024 * 1024;
    return (error.audioBufferByteLength || 0) > LARGE_FILE_BYTES
        ? "AUDIO_FILE_TOO_LARGE_TO_LOAD_IN_BROWSER"
        : "SOMETHING_WENT_WRONG_LOADING_AUDIO";
},

resetTranscriptionAndAudioEdits : function(){
this._lastTranscriptionResults = null;
if(TREBBLE_TEXT_BASED_AUDIO_EDITOR && this.view.isAudioWasTranscribedAndEdited()){
    this.view.setAudioWasTranscribedAndEdited(false);
    this._destroySequencerNodeController().catch(function(error){
        console.error("Failed to destroy sequencer node controller while resetting. Error:" + error, error);
    });
    this._uploadedAudioPartInfoForTranscriptionAndEditing = null;
    this._audioUriToTrebbleAudio = null;
    this.view.showHideSequncerNodeWrapper(false);
    this.view.showHideUploadingViewInAudioEditor(false);
    this.view.showHideMessageToStartTranscriptionBox(true);
    if(window.trebbleAnalyticsHelper){
        window.trebbleAnalyticsHelper.trackEvent("audioEditor", "Reset transcription and audio edits", "Reset transcription and audio edits");
    }
}
},

_clearLegacyTranscriptionSource : function(){
    this._capsuleAudioUrlToTranscribe = null;
    this._capsuleAudioDurationInSeconds = null;
},

_validateMediaHasAudioForTranscription : async function(mediaSource){
    const source = typeof mediaSource === "string"
        ? Utils.getInstance().getCloudFrontUrlIfApplicable(mediaSource)
        : mediaSource;
    if(await VideoUtilsHelper.getInstance().hasAudioTrack(source) === false){
        throw new ExpectedError(window.getI18n(ti18n, "VIDEO_HAS_NO_AUDIO_TRACK"), {
            i18nKey: "VIDEO_HAS_NO_AUDIO_TRACK",
            classification: EXPECTED_ERROR_CLASSIFICATION.USER_CONTENT,
            errorCode: "VIDEO_HAS_NO_AUDIO_TRACK",
            expectedErrorCategory: EXPECTED_ERROR_CATEGORY.AUDIO_DECODE_OR_UNSUPPORTED_FILE,
            watchInAnalytics: true,
            source: EXPECTED_ERROR_SOURCE.TRANSCRIBE_AND_EDIT_AUDIO,
        });
    }
},

_validatePendingMediaHasAudioForTranscription : async function(recoveredUploadedMediaParts){
    if(this._capsuleAudioUrlToTranscribe){
        return this._validateMediaHasAudioForTranscription(this._capsuleAudioUrlToTranscribe);
    }
    const pendingMedia = this.getPendingMediaDescriptors();
    const descriptors = pendingMedia.length > 0 ? pendingMedia : recoveredUploadedMediaParts || [];
    for(const descriptor of descriptors){
        const source = descriptor instanceof Blob ? descriptor : descriptor.blob || descriptor.file || descriptor.uri;
        if(source){
            await this._validateMediaHasAudioForTranscription(source);
        }
    }
},

transcribeAndEditAudio : function(){
//this.view.setAudioWasTranscribedAndEdited(false);
this.view.showHideMessageToStartTranscriptionBox(false);
this.view.showHideSequncerNodeWrapper(false);
this.view.showHideUploadingViewInAudioEditor(true);

const recoveredUploadedMediaPartsForPendingMedia = this.isInRecordMode() ? this._getRecoveredUploadedMediaPartsForPendingMedia() : null;
const isUsingAlreadyUploadedAudio = !!this._capsuleAudioUrlToTranscribe ||
    !!(recoveredUploadedMediaPartsForPendingMedia && recoveredUploadedMediaPartsForPendingMedia.length > 0);
const duplicateCheckPromise = this._validatePendingMediaHasAudioForTranscription(recoveredUploadedMediaPartsForPendingMedia).then(() => {
    return isUsingAlreadyUploadedAudio ? RSVP.Promise.resolve(true) : this.checkForDuplicateTranscriptionsBeforeUpload();
});

// Only check duplicates before a new upload; resumed uploads already point at known media.
return duplicateCheckPromise.then(async (shouldProceed) => {
    if (!shouldProceed) {
        this.view.showHideUploadingViewInAudioEditor(false);
        this.view.showHideMessageToStartTranscriptionBox(true);
        return RSVP.Promise.reject("Transcription cancelled by user due to duplicate detection");
    }

    // Proceed with upload and transcription. For legacy capsules whose
    // audio is already on S3, skip the upload step. Rebuild the payload
    // here in case resetTranscriptionAndAudioEdits() cleared the cache.
    if(this._capsuleAudioUrlToTranscribe){
        const durationInMilliseconds = this._capsuleAudioDurationInSeconds ? this._capsuleAudioDurationInSeconds * 1000 : null;
        this._uploadedAudioPartInfoForTranscriptionAndEditing = [{ uri: this._capsuleAudioUrlToTranscribe, duration: durationInMilliseconds }];
        return RSVP.Promise.resolve(this._uploadedAudioPartInfoForTranscriptionAndEditing);
    }
    if(recoveredUploadedMediaPartsForPendingMedia && recoveredUploadedMediaPartsForPendingMedia.length > 0){
        return RSVP.Promise.resolve(recoveredUploadedMediaPartsForPendingMedia);
    }
    return this.uploadRecordingToAudioLibraryForEditingIfApplicable(this.audioEditorProgressBarController);
}).then((function(audioPartsInfo){
    this._uploadedAudioPartInfoForTranscriptionAndEditing = audioPartsInfo;
    window.audioPartsInfo = audioPartsInfo;

    const hasRecoveredRegistrationCheckpoint = !!(
        this._audioUriToTrebbleAudio &&
        audioPartsInfo &&
        audioPartsInfo.length > 0 &&
        audioPartsInfo.every((function(mediaPartInfo){
            return !!(mediaPartInfo && mediaPartInfo.uri && this._audioUriToTrebbleAudio[mediaPartInfo.uri]);
        }).bind(this))
    );

    if(hasRecoveredRegistrationCheckpoint){
        return this._audioUriToTrebbleAudio;
    }

    return this.addUploadedAudioRecordingToUserLibrary();
}).bind(this)).then((function(audioUriToTrebbleAudio){
    this._audioUriToTrebbleAudio = audioUriToTrebbleAudio;
    this.audioEditorProgressBarController.setIndeterminate(true);
    this.audioEditorProgressBarController.setProgressMessage(this.getTranscribingLabel());
    const transcriptionProgressSubmessage = this.isTransciptionProcessFast()? window.getI18n(ti18n, "TRANSCRIPTION_MIGHT_TAKE_SEVERAL_MINUTES")+ " "+ window.getI18n(ti18n, "DO_NOT_REFRESH")+ " "+window.getI18n(ti18n, "PLEASE_HOLD_ON_TIGHT") : window.getI18n(ti18n, "THIS_MIGHT_TAKE_A_FEW_MINUTES_WE_WILL_SEND_YOU_AN_EMAIL");
    this.audioEditorProgressBarController.setProgressSubMessage(transcriptionProgressSubmessage);
    const alreadyTranscribed = this._lastTranscriptionResults &&
        this._lastTranscriptionResults.length > 0 &&
        this._areAllTranscriptionStatusCompleted(this._lastTranscriptionResults);
    return alreadyTranscribed
        ? RSVP.Promise.resolve(true)
        : this.startTranscriptionOfUploadedAudioRecording();
}).bind(this)).then((function(transcriptionSuccessfullyCompleted){
    this.view.showHideUploadingViewInAudioEditor(false);
    if(transcriptionSuccessfullyCompleted){
        return this.initialiazedAudioEditorWithLatestTranscriptions().then((function(initializedAudioEditor) {
            this.view.setAudioWasTranscribedAndEdited(true);
            this.view.showHideSequncerNodeWrapper(true);
            return this._updateRecordingDraftsForFileNames(this._getPendingRecordingFileNamesForDurableDrafts(), function(recordingId) {
                return BrowserRecordingDraftStore.getInstance().markCompleted(recordingId);
            }).catch(function(error) {
                console.warn("Unable to mark the durable draft as completed after transcription", error);
                return null;
            }).then(function() {
                return initializedAudioEditor;
            });
        }).bind(this));
    }else{
        return this._markPendingRecordingDraftsAsRecoverableFailure(window.getI18n(ti18n, "TRANSCRIPTION_FAILED"), {
            preserveTranscribing: true
        }).then((function(){
            this.view.showHideMessageToStartTranscriptionBox(true);
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("audioEditor", "Transcription failed", "Transcription failed");
            }
            window.alertErrorMessage(window.getI18n(ti18n, "SOMETHING_WENT_WRONG_WHILE_TRANSCRIBING"))
        }).bind(this));
    }
}).bind(this)).catch((function(error){
    const shouldMarkRecoverableFailure = !(error && error === "Transcription cancelled by user due to duplicate detection");
    const expectedAudioLoadingError = this._getExpectedAudioLoadingError(error);
    const markRecoverableFailurePromise = shouldMarkRecoverableFailure ? this._markPendingRecordingDraftsAsRecoverableFailure(error).catch(function(markError){
        console.warn("Unable to persist the browser recording draft failure state for transcription", markError);
        return null;
    }) : RSVP.Promise.resolve();

    return markRecoverableFailurePromise.then((function(){
        this.view.showHideUploadingViewInAudioEditor(false);
        this.view.showHideMessageToStartTranscriptionBox(true);
        if(error && typeof error === "object" && error.code === "workspace_transcription_limit_reached"){
            // Workspace transcription quota error: alert already shown at the
            // pre-check site, so short-circuit without a second generic alert.
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("audioEditor", "Workspace transcription limit reached", "Workspace transcription limit reached");
            }
        }else if(isTranscriptionQuotaError(error) || (error && error === window.getI18n(ti18n, "YOU_DONT_HAVE_ENOUGH_MINUTES_TO_EXECUTE_THIS_TRANSCRIPTION"))){
            // Out of transcription minutes -> show the shared upgrade prompt.
            // Pass the structured error (with real minute counts) when we have it;
            // a bare legacy i18n string falls back to the generic copy. This is the
            // record/create flow, so route the post-upgrade redirect back to the
            // create-shortcast page (preserving the original behavior).
            const router = PersistentModels.getInstance().getRouter();
            showOutOfTranscriptionMinutesPrompt(isTranscriptionQuotaError(error) ? error : null, {
                upgradeReturnUrls: {
                    onUpgradeCompleted: router.getConfirmUpgradeCreatorSubscriptionAndRedirectToCreateShortcastPageURL(),
                    onPaymentMethodUpdated: router.getConfirmPaymentUpdateAndRedirectToCreateShortcastPageURL()
                }
            });
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("audioEditor", "User doesn't have enough transcription minutes", "User doesn't have enough transcription minutes");
            }
        }else if(error && error === "Transcription cancelled by user due to duplicate detection"){
            // This is expected user behavior when they choose not to proceed with duplicate transcription
            window.alertUserErrorMessage(window.getI18n(ti18n, "TRANSCRIPTION_CANCELLED"));
        }else if(expectedAudioLoadingError){
            console.warn(expectedAudioLoadingError.message, expectedAudioLoadingError, error);
            window.alertErrorMessage(expectedAudioLoadingError);
        }else if(this._isEncodingError(error)){
            const errorMessageKey = this._getAudioLoadingErrorMessageKey(error);
            const expectedDecodeError = new ExpectedError(
                window.getI18n(ti18n, errorMessageKey),
                {
                    i18nKey: errorMessageKey,
                    classification: EXPECTED_ERROR_CLASSIFICATION.USER_CONTENT,
                    errorCode: "AUDIO_DECODE_FAILED",
                    expectedErrorCategory: EXPECTED_ERROR_CATEGORY.AUDIO_DECODE_OR_UNSUPPORTED_FILE,
                    watchInAnalytics: true,
                    source: EXPECTED_ERROR_SOURCE.TRANSCRIBE_AND_EDIT_AUDIO,
                }
            );
            if(error && error.audioBufferByteLength){
                expectedDecodeError.audioBufferByteLength = error.audioBufferByteLength;
            }
            console.warn(expectedDecodeError.message, error);
            window.alertErrorMessage(expectedDecodeError);
        }else{
            console.error(error);
            window.sendErrorToRaygun(error, true);
            window.alertErrorMessage(window.getI18n(ti18n, this._getAudioLoadingErrorMessageKey(error)));
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("audioEditor", "Something went wrong during the initialization of audio editor", "Something went wrong during the initialization of audio editor", null,{"error": error });
            }
        }
    }).bind(this));
}).bind(this))
},

checkForDuplicateTranscriptionsBeforeUpload : async function(){
try {
    // Get the files that are about to be uploaded
    const filesToCheck = this.getFilesToUpload();

    if(!filesToCheck || filesToCheck.length === 0){
        // No files to check, proceed with upload
        return true;
    }

    const duplicateChecks = [];

    // Check each file for duplicates
    for(let i = 0; i < filesToCheck.length; i++){
        try {
            const file = filesToCheck[i];
            const originalFilename = file.name || file.originalFilename;

            if(originalFilename){
                const duplicateCheck = TrebbleClientAPIHelper.getInstance().checkForDuplicateTranscription(originalFilename);
                duplicateChecks.push({
                    index: i,
                    file: file,
                    filename: originalFilename,
                    checkPromise: duplicateCheck
                });
            }
        } catch (fileError) {
            console.error("Error checking file for duplicates:", fileError);
            // Continue with other files even if one fails
        }
    }

    if(duplicateChecks.length === 0){
        // No files to check, proceed with upload
        return true;
    }

    try {
        // Wait for all duplicate checks to complete
        const results = await RSVP.Promise.all(duplicateChecks.map(item => item.checkPromise));

        const duplicatesFound = [];

        for(let i = 0; i < results.length; i++){
            try {
                const result = results[i];
                const duplicateCheck = duplicateChecks[i];

                if(result && result.isDuplicate){
                    duplicatesFound.push({
                        file: duplicateCheck.file,
                        filename: duplicateCheck.filename,
                        duplicateInfo: result
                    });
                }
            } catch (resultError) {
                console.error("Error processing duplicate check result:", resultError);
                // Continue with other results even if one fails
            }
        }

        if(duplicatesFound.length === 0){
            // No duplicates found, proceed with upload
            return true;
        }

        // Ask user for confirmation for each duplicate
        try {
            return await this.askUserConfirmationForDuplicates(duplicatesFound);
        } catch (confirmationError) {
            console.error("Error in user confirmation for duplicates:", confirmationError);
            // If user confirmation fails, proceed with upload
            return true;
        }

    } catch (processingError) {
        console.error("Error processing duplicate check results:", processingError);
        // If processing fails, proceed with upload
        return true;
    }

} catch (generalError) {
    console.error("General error in duplicate checking:", generalError);
    // If any general error occurs, proceed with upload
    return true;
}
},

getFilesToUpload : function(){
    // This method should return the files that are about to be uploaded
    // The implementation depends on how files are stored in the controller
    if(this.isInUploadMode()){
        // For upload mode, get files from the dropzone object
        if(this._capsuleUploadDropzoneObj && this._capsuleUploadDropzoneObj.getAcceptedFiles){
            return this._capsuleUploadDropzoneObj.getAcceptedFiles();
        }
        return [];
    } else if(this.isInRecordMode()){
        // For record mode, we might have recorded audio files
        // This could be stored in a property like this._recordedAudioFiles
        // or accessible through the view
        if(this._filenameArray && this._filenameArray.length > 0){
            // Convert filename array to file objects for consistency
            return this._filenameArray.map(filename => ({
                name: filename,
                originalFilename: filename
            }));
        }
        return [];
    }
    return [];
},

getPendingMediaDescriptors : function(){
    if(this.isInRecordMode()){
        const recordFilenameToMediaInfo = AudioRecorderHelper.getInstance().getRecordFilenameToMediaInfo();
        return this._filenameArray.map((function(filename){
            return recordFilenameToMediaInfo[filename];
        }).bind(this)).filter(function(mediaInfo){
            return !!mediaInfo;
        });
    }

    if(this.isInUploadMode() && this._capsuleUploadDropzoneObj && this._capsuleUploadDropzoneObj.getAcceptedFiles){
        const acceptedFiles = this._capsuleUploadDropzoneObj.getAcceptedFiles();
        if(acceptedFiles && acceptedFiles.length > 0){
            return acceptedFiles;
        }
    }

    if(this._uploadedAudioPartInfoForTranscriptionAndEditing && this._uploadedAudioPartInfoForTranscriptionAndEditing.length > 0){
        return this._uploadedAudioPartInfoForTranscriptionAndEditing;
    }

    return [];
},

_isMediaDescriptorVideo : function(mediaDescriptor){
    if(!mediaDescriptor){
        return false;
    }

    if(typeof mediaDescriptor.isVideo === "boolean"){
        return mediaDescriptor.isVideo;
    }

    if(mediaDescriptor.metadata && typeof mediaDescriptor.metadata.isVideo === "boolean"){
        return mediaDescriptor.metadata.isVideo;
    }

    if(mediaDescriptor.type){
        return mediaDescriptor.type.indexOf("video/") === 0;
    }

    if(mediaDescriptor.mimeType){
        return mediaDescriptor.mimeType.indexOf("video/") === 0;
    }

    return false;
},

_isMediaDescriptorWebM : function(mediaDescriptor){
    if(!this._isMediaDescriptorVideo(mediaDescriptor) || !mediaDescriptor){
        return false;
    }

    const mimeType = mediaDescriptor.mimeType || mediaDescriptor.type || (mediaDescriptor.metadata && mediaDescriptor.metadata.mimeType) || "";
    return mimeType.indexOf("video/webm") === 0;
},

_getRecordedMediaUploadSignatureFunctionName : function(mediaDescriptors){
    if(!mediaDescriptors || mediaDescriptors.length === 0){
        return null;
    }

    const areAllVideo = mediaDescriptors.every((function(mediaDescriptor){
        return this._isMediaDescriptorVideo(mediaDescriptor);
    }).bind(this));
    if(!areAllVideo){
        return null;
    }

    const areAllWebM = mediaDescriptors.every((function(mediaDescriptor){
        return this._isMediaDescriptorWebM(mediaDescriptor);
    }).bind(this));

    return areAllWebM ? "getSignatureForCapsuleVideoWebMUpload" : "getSignatureForCapsuleVideoUpload";
},

areAllUploadedFilesVideoFiles : function(){
    const pendingMediaDescriptors = this.getPendingMediaDescriptors();
    if(!pendingMediaDescriptors || pendingMediaDescriptors.length === 0){
        return false;
    }

    return pendingMediaDescriptors.every((function(mediaDescriptor){
        return this._isMediaDescriptorVideo(mediaDescriptor);
    }).bind(this));
},

areAllUploadedFilesAudioFiles : function(){
    const pendingMediaDescriptors = this.getPendingMediaDescriptors();
    if(!pendingMediaDescriptors || pendingMediaDescriptors.length === 0){
        return false;
    }

    return pendingMediaDescriptors.every((function(mediaDescriptor){
        return !this._isMediaDescriptorVideo(mediaDescriptor);
    }).bind(this));
},

getUserLibraryUploadSignatureFunctionName : function(){
    if(this.areAllUploadedFilesVideoFiles()){
        return "getSignatureForTrebbleUserVideoUpload";
    }

    return "getSignatureForTrebbleUserAudioRecordingUpload";
},

askUserConfirmationForDuplicates : async function(duplicatesFound){
try {
    if(duplicatesFound.length === 0){
        return true;
    }

    const currentDuplicate = duplicatesFound[0];
    const remainingDuplicates = duplicatesFound.slice(1);
    const filename = currentDuplicate.filename;
    const duplicateInfo = currentDuplicate.duplicateInfo;

    try {
        const existingDate = new Date(duplicateInfo.existingTranscriptionDate).toLocaleDateString();
        const existingStatus = duplicateInfo.existingTranscriptionStatus;

        const message = window.getI18n(ti18n, "DUPLICATE_TRANSCRIPTION_WARNING_WITH_DETAILS", {
            filename: filename
        }) || window.getI18n(ti18n, "DUPLICATE_TRANSCRIPTION_WARNING");

        const submessage = window.getI18n(ti18n, "DUPLICATE_TRANSCRIPTION_SUBMESSAGE");

        // Use the new Utils confirmation dialog with separate submessage parameter
        const userConfirmed = await Utils.getInstance().showUserConfirmationDialog(
            window.getI18n(ti18n, "DUPLICATE_TRANSCRIPTION") || "Duplicate Transcription",
            message,
            submessage
        );

        if(userConfirmed){
            // User confirmed this duplicate, check next one if any
            try {
                return await this.askUserConfirmationForDuplicates(remainingDuplicates);
            } catch (recursiveError) {
                console.error("Error in recursive user confirmation:", recursiveError);
                // If recursive call fails, proceed with upload
                return true;
            }
        } else {
            // User cancelled, stop the process
            return false;
        }

    } catch (dateError) {
        console.error("Error formatting date for duplicate warning:", dateError);
        // If date formatting fails, show a simpler message
        const simpleMessage = window.getI18n(ti18n, "DUPLICATE_TRANSCRIPTION_WARNING_SIMPLE", {
                                 filename: filename
                             }) || window.getI18n(ti18n, "DUPLICATE_TRANSCRIPTION_WARNING");

        const submessage = window.getI18n(ti18n, "DUPLICATE_TRANSCRIPTION_SUBMESSAGE");

        try {
            const userConfirmed = await Utils.getInstance().showUserConfirmationDialog(
                window.getI18n(ti18n, "DUPLICATE_TRANSCRIPTION") || "Duplicate Transcription",
                simpleMessage,
                submessage
            );

            if(userConfirmed){
                try {
                    return await this.askUserConfirmationForDuplicates(remainingDuplicates);
                } catch (recursiveError) {
                    console.error("Error in recursive user confirmation (fallback):", recursiveError);
                    return true;
                }
            } else {
                return false;
            }
        } catch (fallbackError) {
            console.error("Error in fallback confirmation dialog:", fallbackError);
            return true;
        }
    }

} catch (generalError) {
    console.error("General error in user confirmation for duplicates:", generalError);
    // If any error occurs, proceed with upload
    return true;
}
},

getOnEditorLoadingProgressReported : function(){
const defaultProgresMessageOnUpload = window.getI18n(ti18n,"INITIALIZING_EDITOR");
    return (function(progress, operationInProgress){
        if(progress){
            this.audioEditorProgressBarController.setIndeterminate(false);
            this.audioEditorProgressBarController.setProgressMessage(operationInProgress?operationInProgress:defaultProgresMessageOnUpload);
            this.audioEditorProgressBarController.setProgressSubMessage("");
            this.audioEditorProgressBarController.setPercentageProgress(Math.round(progress)+ "%");
        }else{
            this.audioEditorProgressBarController.setIndeterminate(true);
            this.audioEditorProgressBarController.setProgressMessage(operationInProgress?operationInProgress:defaultProgresMessageOnUpload);
            this.audioEditorProgressBarController.setProgressSubMessage("");
        }
    }).bind(this)
},

fetchCapsuleInfoIfApplicable : async function(){
    if(this._capsuleIdToEdit){
        const capsuleJson = await TrebbleClientAPIHelper.getInstance().getCapsuleInfoByCapsuleId(this._capsuleIdToEdit);
        if(capsuleJson){
            this._capsuleInfoToEdit = Utils.getInstance().getModelFromCapsuleJson(capsuleJson);
        }
    }
},
updateFormFromCapsuleIdInfoIfApplicable : function(){
    if(this._capsuleInfoToEdit){
        this.view.setCapsuleInfoToEdit(this._capsuleInfoToEdit);
    }
},

shouldJumpToAudioEditor :function(){
    return this._createFromTranscriptionId || this._createFromProjectId|| this._editProjectId;
},

shouldSetupForTranscriptionOfExistingCapsule : function(){
    return !!this._capsuleAudioUrlToTranscribe;
},

setupForTranscriptionOfExistingCapsuleAudio : function(){
    const audioUrl = this._capsuleAudioUrlToTranscribe;

    // Pre-populate audio info as if it were just uploaded, including
    // duration so the transcription service has it on the first call.
    const durationInMilliseconds = this._capsuleAudioDurationInSeconds ? this._capsuleAudioDurationInSeconds * 1000 : null;
    this._uploadedAudioPartInfoForTranscriptionAndEditing = [{ uri: audioUrl, duration: durationInMilliseconds }];

    // Navigate the carousel from slide 0 (record/upload) to slide 1
    // (transcription & edit). The carousel needs the page to be fully
    // visible before goTo/next works, so defer past the jQuery Mobile
    // page transition. The timer is cleared in onViewRemoved() so we
    // don't navigate a torn-down view.
    this._setupForTranscriptionTimer = setTimeout((function(){
        if(this.view){
            this.view.onNextButtonClicked(true);
        }
    }).bind(this), 500);
},
jumpToAudioEditorIfApplicable : function(){
if(this.shouldJumpToAudioEditor()){
    const defaultProgresMessageOnUpload = window.getI18n(ti18n,"INITIALIZING_EDITOR");

    const onEditorLoadingProgressReported = this.getOnEditorLoadingProgressReported();

    let sequencerControllerInitializationFunction = (function(sequencerController){
        return this._addLatestTranscriptionsToAudioEditor(0);
    }).bind(this);
    if(this._createFromTranscriptionId){
        sequencerControllerInitializationFunction =((function(sequencerController){
            return TrebbleClientAPIHelper.getInstance().getTranscriptionInfo(this.transcriptionId).then((async function(transactionInfo){
                if(transactionInfo){
                    const audioFileUrl = transactionInfo.urlOfTranscribedAudio;
                    const transcriptionFileLocation = transactionInfo.transcriptionFileLocation;
                    const transcriptionId = this.transcriptionId;
                    const isVideo = transactionInfo.isVideo;
                    const languageCode =  transactionInfo.languageCode;
                    this.self.view.setContentLoading(false);
                    this.self.view.showHideUploadingViewInAudioEditor(true);
                    this.self.audioEditorProgressBarController.setIndeterminate(true);
                    this.self.audioEditorProgressBarController.setProgressMessage(defaultProgresMessageOnUpload);

                    return (audioFileUrl && transcriptionFileLocation)
                        ? this.self._initSequencerControllerWithTranscriptionInfo(audioFileUrl, transcriptionFileLocation, transcriptionId, isVideo, languageCode, sequencerController)
                        : this.self._addLatestTranscriptionsToAudioEditor(0, sequencerController);
                }
            }).bind(this));
        }).bind({"self":this, "transcriptionId": this._createFromTranscriptionId}));
    }else{
        if(this._createFromProjectId || this._editProjectId){
            sequencerControllerInitializationFunction = ((function(sequencerController){
                this.self.view.setContentLoading(false);
                this.self.view.showHideUploadingViewInAudioEditor(true);
                this.self.audioEditorProgressBarController.setIndeterminate(true);
                this.self.audioEditorProgressBarController.setProgressMessage(defaultProgresMessageOnUpload);
                return sequencerController.setAndLoadProject(this.projectId, this.duplicateProject, onEditorLoadingProgressReported);
            }).bind({"self":this, "projectId": this._editProjectId? this._editProjectId: this._createFromProjectId, duplicateProject: this._createFromProjectId? true: false }));
        }
    }
    this.view.setContentLoading(false);
    this.initialiazedAudioEditor(sequencerControllerInitializationFunction).catch((function(error){
        const isEncodingError = this._isEncodingError(error);
        const expectedAudioLoadingError = this._getExpectedAudioLoadingError(error);
        if(isEncodingError){
            console.warn("Failed to initialize audio editor because the media could not be decoded.", error);
        }else if(expectedAudioLoadingError){
            console.warn("Failed to initialize audio editor because of an expected media loading condition.", expectedAudioLoadingError, error);
        }else{
            console.error("Failed to initialize audio editor. Error:" + error, error);
        }
        this.view.setAudioWasTranscribedAndEdited(false);
        this.view.showHideSequncerNodeWrapper(false);
        this.view.showHideUploadingViewInAudioEditor(false);
        this.view.showHideMessageToStartTranscriptionBox(true);
        this.view.setContentLoading(false);
        if(isEncodingError || (expectedAudioLoadingError && expectedAudioLoadingError.errorCode === "VIDEO_HAS_NO_AUDIO_TRACK")){
            this.view.showHideTranscribeAndEditButton(false);
        }
        if(expectedAudioLoadingError){
            window.alertErrorMessage(expectedAudioLoadingError);
        }else if(isEncodingError){
            const errorMessageKey = this._getAudioLoadingErrorMessageKey(error);
            const expectedDecodeError = new ExpectedError(
                window.getI18n(ti18n, errorMessageKey),
                {
                    i18nKey: errorMessageKey,
                    classification: EXPECTED_ERROR_CLASSIFICATION.USER_CONTENT,
                    errorCode: "AUDIO_DECODE_FAILED",
                    expectedErrorCategory: EXPECTED_ERROR_CATEGORY.AUDIO_DECODE_OR_UNSUPPORTED_FILE,
                    watchInAnalytics: true,
                    source: EXPECTED_ERROR_SOURCE.TRANSCRIBE_AND_EDIT_AUDIO,
                }
            );
            if(error && error.audioBufferByteLength){
                expectedDecodeError.audioBufferByteLength = error.audioBufferByteLength;
            }
            window.alertErrorMessage(expectedDecodeError);
        }else{
            window.alertErrorMessage(window.getI18n(ti18n, this._getAudioLoadingErrorMessageKey(error)));
        }
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("audioEditor", "Something went wrong during the initialization of audio editor", "Something went wrong during the initialization of audio editor", null,{"error": error });
        }
    }).bind(this));
    this.view.setAudioWasTranscribedAndEdited(true);
    this.view.showHideMessageToStartTranscriptionBox(false);
    this.view.showHideSequncerNodeWrapper(true);
    //this.view.showHideUploadingViewInAudioEditor(false);
    this.view.setInCreationFromTranscriptMode();
}

},

stopAudioEditorPlaybackIfApplicable: function(){
if(this._sequencerController){
    this._sequencerController.stopPlaybackIfApplicable();
}
},

isEditedContentContainsVideo :function(){
if(this._sequencerController){
    return this._sequencerController.getHasVideoSegment();
}
return false;
},

onRecordingCompleted : async function(){
    if(this._recordOnly && !this._isCompletingRecordOnlyRecording){
        this._isCompletingRecordOnlyRecording = true;
        try{
            await AudioRecorderHelper.getInstance().getRecordingPromise();
            const blobArray = [];
            const recordFilenameToBlog =  AudioRecorderHelper.getInstance().getRecordFilenameToBlob();
            const recordFilenameToMediaInfo = AudioRecorderHelper.getInstance().getRecordFilenameToMediaInfo();
            for(let index in this._filenameArray){
                const fileName = this._filenameArray[index];
                const mediaInfo = recordFilenameToMediaInfo[fileName];
                const blob = mediaInfo && mediaInfo.file ? mediaInfo.file : recordFilenameToBlog[fileName];
                if(blob){
                    let fileToReturn = blob;
                    if(typeof File !== "undefined" && !(blob instanceof File)){
                        fileToReturn = Utils.getInstance().createFileWithNewName(blob, fileName);
                    }
                    if (mediaInfo && mediaInfo.recordingHealth) {
                        fileToReturn._recordingHealth = mediaInfo.recordingHealth;
                    }
                    blobArray.push(fileToReturn);
                }
            }
            const recordingsConsumed = await this._onAllAudioRecorded(blobArray);
            // A failed upload leaves its durable recording available for recovery.
            if(recordingsConsumed !== false){
                await RSVP.Promise.all(this._filenameArray.slice().map(function(fileName) {
                    return AudioRecorderHelper.getInstance().deleteRecording(fileName).catch(function(error) {
                        console.warn("Unable to explicitly clean up a completed browser recording draft in record-only mode", error);
                        return null;
                    });
                }));
            }
            this._filenameArray = [];
            this._recordingCounterArray = [];
            this._recordingCounterToFilename = {};
            this.view.navigateToPreviousPage();
        }finally{
            this._isCompletingRecordOnlyRecording = false;
        }
    }

},


buildModelAndRenderView : function() {
return new RSVP.Promise((function(resolve, reject) {
    try {
        const promises = [];

        //promises.push(this.songSelectorListController.buildModelAndRenderView());
        promises.push(this.songAttachedToCapsuleSongSelectorInputController.buildModelAndRenderView());
        promises.push(this.backgroundSongSelectorInputController.buildModelAndRenderView());
        promises.push(this.capsuleInfoProgressBarController.buildModelAndRenderView());
        promises.push(this.audioEditorProgressBarController.buildModelAndRenderView());
        promises.push(this.creationModeSelectorController.buildModelAndRenderView());
        promises.push(this.peakMeterWidgetController.buildModelAndRenderView());
        promises.push(this.fetchCapsuleInfoIfApplicable())

        RSVP.Promise.all(promises).then((function(){
            const params = {};
            params.model = this.getSongModelToPlayAfterCapsule();
            params.followersUsersInfo = PersistentModels.getInstance().getMyFollowingsInfo();
            params.recordKey  = `${window.getI18n(ti18n, "RECORDING")}_${moment().format('YYYY-MM-DD_HH-mm-ss')}`;
            params.pageId = this._pageId;
            params.creationModeSelectorView = this.creationModeSelectorController.getView();
            params.creationModeFlatListViewContainer$el = this._creationModeFlatListViewContainer$el;
            //this.creationModeSelectorController.setSelected(Utils.getInstance().getListItemModel(CREATION_MODE.FROM_RECORDING,   "<span class='icon pe-7s-micro'></span>" +this._getRecordCreationOptionLabel()), true, true);

            //params.songSelectorListView = this.songSelectorListController.getView();
            params.songAttachedToCapsuleSongSelectorInputView = this.songAttachedToCapsuleSongSelectorInputController.getView();
            params.backgroundSongSelectorInputView = this.backgroundSongSelectorInputController.getView();
            this.songAttachedToCapsuleSongSelectorInputController.setSelectedSongModel(this._defaultSongToPlayAfterCapsule);
            params.capsuleCategoryCollection = new ListItemCollection(Utils.getInstance().getCapsuleCategoryListItemArray());
            params.selectedDefaultCategoryId = Utils.getInstance().getDefaultSelectedCapsuleCategoryId();
            params.timezoneCollection = new ListItemCollection(Utils.getInstance().getTimezoneListItemArray());
            params.selectedDefaultTranscriptionLanguage  = LocalStorageHelper.getInstance().getLastLanguageUsedDuringTranscription();
            params.supportedTranscriptionLanguagesCollection = new ListItemCollection(Utils.getInstance().getSupportedTranscribedLanguage());
            const trebbleDefauftTimezones = PersistentModels.getInstance().getAllMyPersonalRadioTimezones();
            const trebbleDefaultTimezone  = trebbleDefauftTimezones && trebbleDefauftTimezones.length> 0? trebbleDefauftTimezones[0]: Intl.DateTimeFormat().resolvedOptions().timeZone;
            params.selectedDefaultTimezone = trebbleDefaultTimezone;
            params.capsuleInfoProgressBarView = this.capsuleInfoProgressBarController.getView();
            params.audioEditorProgressBarView = this.audioEditorProgressBarController.getView();
            params.audioRecordingSupported = this._audioRecordingSupported;
            params.receiverUserId = this._receiverUserId;
            params.capsuleSchedulingAvailable =  this.capsuleSchedulingAvailable;
            params.saveAsDraft = this._saveAsDraft;
            params.customPageTitle = this._customPageTitle;
            params.createAShortcast = this._createAShortcast;
            params.peakMeterView = this.peakMeterWidgetController.getView();
            params.canSaveOnlyAfterTranscriptionAndEditing =  this._canSaveOnlyAfterTranscriptionAndEditing;
            params.recordOnly = this._recordOnly;
            params.canSaveChanges = this.canSaveProjectChanges();
            params.workspaceId = this.getWorkspaceId();
            // Forward the default folder (if any) so the view can pre-select it
            // in the Create Content folder picker.
            params.defaultFolderId = this._defaultFolderId;
            params.recordingMediaType = this._recordingMediaType;
            params.recordingVisualSource = this._recordingVisualSource;
            params.opensProjectInEditor = !!(this._createFromProjectId || this._editProjectId);
            params.recoveryMode = this._recoveryMode;
            params.recoverableDrafts = this._recoverableRecordingDrafts.slice();
            this.view = new RecordAudioHightlightPageNewView(params);
            this.listenTo(this.creationModeSelectorController, "selectionChanged",this._onCreationModeSelectionChanged.bind(this) );
            this.listenTo(this.view, "startRecording",this.startRecording);
            this.listenTo(this.view, "stopRecording",this.stopRecording);
            this.listenTo(this.view, "recordingMediaTypeChanged", this.setRecordingMediaType);
            this.listenTo(this.view, "recordingVisualSourceChanged", this.onRecordingVisualSourceChanged);
            this.listenTo(this.view, "prepareRecordingMediaTypeChange", this.prepareRecordingMediaTypeChange);
            this.listenTo(this.view, "recordingVideoDeviceChanged", this.onRecordingVideoDeviceChanged);
            this.listenTo(this.view, "recordingVideoResolutionChanged", this.onRecordingVideoResolutionChanged);
            this.listenTo(this.view, "requestRecordingDevicePermissions", this.requestRecordingDevicePermissions);
            this.listenTo(this.view, "retryRecordingPreview", (function(){
                this.refreshVideoPreviewIfApplicable(true);
            }).bind(this));
            this.listenTo(this.view, "deleteRecording",this.deleteRecording);
            this.listenTo(this.view, "deleteAllRecordings",this.deleteAllRecordings);
            this.listenTo(this.view, "playRecordings",this.playRecordings);
            this.listenTo(this.view, "stopPlayingRecordings",this.stopPlayingRecordings);
            this.listenTo(this.view, "saveRecording",this.saveCapsuleConfirm);
            this.listenTo(this.view, "setRecordMode", this.setRecordMode);
            this.listenTo(this.view, "setFileUploadMode", this.setFileUploadMode);
            this.listenTo(this.view, "setFromTextMode", this.setFromTextMode);
            this.listenTo(this.view, "setFromVoiceActor", this.setFromVoiceActor);
            this.listenTo(this.view, "onWhatsACapsuleButton", this.showAndPlayWhatsACapsuleCapsule.bind(this));
            this.listenTo(this.view, "backgroundTrackChange", this.onBackgroundTrackChanged);
            this.listenTo(this.view, "checkRecordingPermissionAndRecord",this.checkRecordingPermissionAndRecord)
            this.listenTo(this.view, "showRecordingSettings", this.showRecordingSettings)
            this.listenTo(this.view, "transcribeAndEditAudio", this.transcribeAndEditAudio)
            this.listenTo(this.view, "resetTranscriptionAndAudioEdits", this.resetTranscriptionAndAudioEdits)
            this.listenTo(this.view, "navigatingToNextPageAFterAudioEditorPage", this.stopAudioEditorPlaybackIfApplicable)
            this.listenTo(this.view, "recordPageOnboardingTourCompleted", this.onRecordPageOnboardingTourCompleted);
            this.listenTo(this.view, "recordPageOnboardingTourCancelled", this.onRecordPageOnboardingTourCancelled);
            this.listenTo(this.view, "saveorEditPageOnboardingTourCompleted", this.onSaveOrEditPageOnboardingTourCompleted);
            this.listenTo(this.view, "saveorEditPageOnboardingTourCancelled", this.onSaveOrEditPageOnboardingTourCancelled);
            this.listenTo(this.view, "recordingCompleted", this.onRecordingCompleted)
            this.listenTo(this.view, "recoverRecordingDraft", this.recoverRecordingDraft)
            this.listenTo(this.view, "discardRecordingDraft", this.discardRecordingDraft)


            this.listenTo(this.view, "pageHide",this.onViewRemoved)
            this.view.$el.on( "remove", this.onViewRemoved.bind(this));
            this.view.render();
            this.view.setSaveAccess(this.canSaveProjectChanges());
            this.setAudioRecordingSupported(this._audioRecordingSupported);
            this.view.$el.on("pageAppendedToBody", (function(){
                const refreshRecoverableDraftsPromise = this._refreshRecoverableRecordingDrafts(true).catch(function(error) {
                    console.warn("Unable to refresh the recoverable browser recording drafts for the recorder page", error);
                    return [];
                });
                this.initCapsuleUploadIfApplicable();
                if(!this._audioRecordingSupported || this._startCreationInFileUploadMode){
                    this._onCreationModeSelectionChanged(this._creationFromFileListItemModel);
                }else{
                    this._onCreationModeSelectionChanged(this._creationFromRecordingListItemModel);
                }
				if(this.shouldSetupForTranscriptionOfExistingCapsule()){
                    this.setupForTranscriptionOfExistingCapsuleAudio();
                }else{
                    this.jumpToAudioEditorIfApplicable();
                }
                this.updateFormFromCapsuleIdInfoIfApplicable();
                refreshRecoverableDraftsPromise.then((function(){
                    if(this._pageTeardownStarted || !this.view){
                        return;
                    }
                    if(!this._showOnboardingTimer && !this._recoveryMode && !this.shouldJumpToAudioEditor() && !this.shouldSetupForTranscriptionOfExistingCapsule() && !(this._recoverableRecordingDrafts && this._recoverableRecordingDrafts.length > 0)){
                        this._showOnboardingTimer = setTimeout(()=>{
                            if(this._pageTeardownStarted || !this.view){
                                this._showOnboardingTimer = null;
                                return;
                            }
                            this._showOnboardingTimer = null;
                            this.showOnboardingIfApplicable();
                        },1000);
                    }
                }).bind(this));
            }).bind(this));


            resolve(this);
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("Capsule", "CapsuleCreationPageOpened", "Capsule Creation Page Opened");
            }
            // Track editor opened for SaaS tracking
            try {
                FacebookEventTrackingHelper.getInstance().trackEditorOpened('audio_editor');
            } catch(trackingError) {
                console.warn('Failed to track editor opened:', trackingError);
            }
        }).bind(this))

} catch (error) {
reject(error);
}

}).bind(this));

},

getTranscribingLabel : function(){
    // Return the appropriate transcription label based on file types
    if(this.areAllUploadedFilesVideoFiles()){
        return window.getI18n(ti18n, "TRANSCRIBING_YOUR_VIDEO");
    } else if(this.areAllUploadedFilesAudioFiles()){
        return window.getI18n(ti18n, "TRANSCRIBING_YOUR_AUDIO");
    } else {
        // Default label for mixed file types or no files
        return window.getI18n(ti18n, "TRANSCRIBING");
    }
},

getUploadingLabel : function(){
    // Return the appropriate uploading label based on file types
    if(this.areAllUploadedFilesVideoFiles()){
        return window.getI18n(ti18n, "UPLOADING_YOUR_VIDEO");
    } else if(this.areAllUploadedFilesAudioFiles()){
        return window.getI18n(ti18n, "UPLOADING_YOUR_AUDIO");
    } else {
        // Default label for mixed file types or no files
        return window.getI18n(ti18n, "UPLOADING");
    }
},

});

export default RecordAudioHightlightPageNewController;
